// TamalePage.jsx
import React, { useState, useEffect } from "react";
import MapVisualization from "./components/MapVisualization";
import HeatmapChart from "./components/HeatmapChart";
import TimeSeriesChart from "./components/TimeSeriesChart";
import SpatialGridOverlay from "./components/SpatialGridOverlay";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./App.css"; // Assuming the styling is shared from App.css

// Dataset files for Tamale
const ncFiles = [
  "r99p_Tamale_CHIRPS.nc",
  "rx1day_Tamale_CHIRPS.nc",
  "r99ptot_Tamale_CHIRPS.nc",
  "prcptot_Tamale_CHIRPS.nc",
  "r20mm_Tamale_CHIRPS.nc",
  "r95p_Tamale_CHIRPS.nc",
  "r95ptot_Tamale_CHIRPS.nc",
  "cdd_Tamale_CHIRPS.nc",
  "rx7day_Tamale_CHIRPS.nc",
  "cwd_Tamale_CHIRPS.nc",
  "r10mm_Tamale_CHIRPS.nc",
  "rx5day_Tamale_CHIRPS.nc",
  "sdii_Tamale_CHIRPS.nc",
  "r30mm_Tamale_CHIRPS.nc",
];

// Descriptions for the Tamale dataset variables
const descriptions = {
  r99p: "Extremely wet days (99th percentile)",
  rx1day: "Maximum 1-day precipitation",
  r99ptot: "Total precipitation from extremely wet days",
  prcptot: "Annual total precipitation",
  r20mm: "Days with ≥20mm precipitation",
  r95p: "Very wet days (95th percentile)",
  r95ptot: "Total precipitation from very wet days",
  cdd: "Consecutive dry days",
  rx7day: "Maximum 7-day precipitation",
  cwd: "Consecutive wet days",
  r10mm: "Days with ≥10mm precipitation",
  rx5day: "Maximum 5-day precipitation",
  sdii: "Simple Daily Intensity Index",
  r30mm: "Days with ≥30mm precipitation",
};

function TamalePage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedVariable, setSelectedVariable] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [geojson, setBoundaryGeoJson] = useState({});
  useEffect(() => {
    const fetchBoundary = async () => {
      try {
        const geojson = {
          type: "FeatureCollection",
          name: "TamaleMetro",
          crs: {
            type: "name",
            properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
          },
          features: [
            {
              type: "Feature",
              properties: {
                Label: "Tamale Metropolitan Area (TMA)",
                Region: "Northern",
                District: "Tamale Metropolitan Area (TMA)",
              },
              geometry: {
                type: "Polygon",
                coordinates: [
                  [
                    [-0.842081650999944, 9.425827960000049],
                    [-0.84185356699993, 9.424094384000057],
                    [-0.841773643999943, 9.423478098000032],
                    [-0.841709823999963, 9.422425264000026],
                    [-0.84174973599994, 9.421533884000041],
                    [-0.841759877999948, 9.421307428000034],
                    [-0.841753486999949, 9.420205603000056],
                    [-0.841750669999954, 9.419720148000067],
                    [-0.841795967999929, 9.419134460000066],
                    [-0.841867968999964, 9.418203464000044],
                    [-0.841955729999938, 9.417068722000067],
                    [-0.841995710999925, 9.416185513000073],
                    [-0.841827466999973, 9.416206611000064],
                    [-0.841598273999978, 9.416245461000074],
                    [-0.841475610999964, 9.41627247100007],
                    [-0.841097849999926, 9.416434690000074],
                    [-0.840467673999967, 9.41807452200004],
                    [-0.840167207999968, 9.418856383000048],
                    [-0.840081805999944, 9.419070603000023],
                    [-0.840027801999952, 9.419206060000022],
                    [-0.839683391999927, 9.420057884000073],
                    [-0.838864165999951, 9.420346250000023],
                    [-0.838473572999931, 9.420503994000057],
                    [-0.837856864999935, 9.420752320000076],
                    [-0.837660912999979, 9.420818623000059],
                    [-0.837462349999953, 9.420903886000076],
                    [-0.837188045999937, 9.421021631000031],
                    [-0.837020202999952, 9.421062199000062],
                    [-0.836657903999935, 9.421155516000056],
                    [-0.836340649999954, 9.42121024000005],
                    [-0.836076429999935, 9.421178982000072],
                    [-0.835683743999937, 9.421077837000041],
                    [-0.835616521999953, 9.421064286000046],
                    [-0.835522073999925, 9.421045245000073],
                    [-0.835366570999952, 9.420959817000039],
                    [-0.835161962999962, 9.420841850000045],
                    [-0.835082179999972, 9.420770682000068],
                    [-0.83485714699998, 9.420567350000056],
                    [-0.834699632999957, 9.420406727000056],
                    [-0.834478759999968, 9.420063170000049],
                    [-0.834384734999958, 9.419813156000032],
                    [-0.834317300999942, 9.419591607000029],
                    [-0.834284669999931, 9.419351784000071],
                    [-0.834268382999937, 9.419168871000068],
                    [-0.834278428999937, 9.419021386000054],
                    [-0.834248091999939, 9.418450418000077],
                    [-0.834228197999948, 9.418178358000034],
                    [-0.834268530999964, 9.417951877000064],
                    [-0.834545411999954, 9.417345948000047],
                    [-0.834831565999934, 9.416870480000057],
                    [-0.834922450999954, 9.416695920000052],
                    [-0.83531441599996, 9.416093401000069],
                    [-0.836308601999974, 9.414522445000046],
                    [-0.836342227999978, 9.414451605000068],
                    [-0.836373513999945, 9.414324296000075],
                    [-0.836383001999934, 9.414235940000026],
                    [-0.836391468999977, 9.414157061000026],
                    [-0.836437094999951, 9.413549204000049],
                    [-0.83644550899993, 9.413290326000038],
                    [-0.836461221999969, 9.412806661000047],
                    [-0.836483389999955, 9.412180234000061],
                    [-0.836494098999935, 9.411877583000035],
                    [-0.83651812599993, 9.411198609000053],
                    [-0.836530057999937, 9.410861450000027],
                    [-0.836534825999934, 9.410726705000059],
                    [-0.836541748999934, 9.410454080000022],
                    [-0.836551939999936, 9.410129640000036],
                    [-0.83655986399998, 9.409877393000045],
                    [-0.836561245999974, 9.409686332000035],
                    [-0.836555647999944, 9.409616426000071],
                    [-0.836620793999941, 9.408802783000056],
                    [-0.836668725999971, 9.408665794000058],
                    [-0.836748166999939, 9.408166273000063],
                    [-0.836773216999973, 9.408008752000057],
                    [-0.836781215999963, 9.407932063000032],
                    [-0.836801501999958, 9.407737542000064],
                    [-0.836829380999973, 9.407458573000042],
                    [-0.836846765999951, 9.407284589000028],
                    [-0.835846110999967, 9.407190593000053],
                    [-0.835750817999951, 9.407181642000069],
                    [-0.834844123999972, 9.407156021000048],
                    [-0.834565, 9.407167650000076],
                    [-0.83443191799995, 9.40719279800004],
                    [-0.834314609999979, 9.40723136500003],
                    [-0.833982134999928, 9.407413856000062],
                    [-0.833980027999928, 9.407410636000066],
                    [-0.833886372999928, 9.407466090000071],
                    [-0.833492546999935, 9.407699273000048],
                    [-0.833199659999934, 9.40791297100003],
                    [-0.832870858999968, 9.408173543000032],
                    [-0.832596849999959, 9.408411634000061],
                    [-0.832511886999953, 9.408329060000028],
                    [-0.83244678899996, 9.408230982000021],
                    [-0.83240627899994, 9.408169948000022],
                    [-0.83238055399994, 9.408099347000075],
                    [-0.832319459999951, 9.407822518000046],
                    [-0.832223346999967, 9.407361037000044],
                    [-0.832173913999952, 9.407175236000057],
                    [-0.832155467999939, 9.407105903000058],
                    [-0.832118541999932, 9.407031428000039],
                    [-0.832089419999932, 9.406972693000057],
                    [-0.832029075999969, 9.406899030000034],
                    [-0.83198181399996, 9.406841340000028],
                    [-0.831801644999928, 9.406696324000052],
                    [-0.831441806999976, 9.406375896000043],
                    [-0.831206279999947, 9.406033314000069],
                    [-0.831185094999967, 9.406002500000056],
                    [-0.83106625299996, 9.405674187000045],
                    [-0.830988912999942, 9.405466915000034],
                    [-0.830746304999934, 9.404816710000034],
                    [-0.830472446999977, 9.404082753000068],
                    [-0.82999407799997, 9.402800682000077],
                    [-0.829633097999931, 9.40183322300004],
                    [-0.829425694999941, 9.40131393300004],
                    [-0.829381912999963, 9.401204317000065],
                    [-0.829326557999934, 9.400996037000027],
                    [-0.82917480499998, 9.400633005000032],
                    [-0.829081201999941, 9.400455888000067],
                    [-0.828987580999978, 9.400317788000052],
                    [-0.828779177999934, 9.400055081000062],
                    [-0.828383509999981, 9.399559692000025],
                    [-0.827640512999949, 9.398681133000025],
                    [-0.827306525999973, 9.398286209000048],
                    [-0.826975371999936, 9.397905682000044],
                    [-0.826870903999975, 9.397785641000041],
                    [-0.826672357999939, 9.397553034000055],
                    [-0.826464138999938, 9.397281485000065],
                    [-0.826414738999972, 9.39721705900007],
                    [-0.826234239999962, 9.396928064000065],
                    [-0.826190240999949, 9.396857615000044],
                    [-0.826070991999927, 9.396649432000061],
                    [-0.826054837999948, 9.396598400000073],
                    [-0.825980002999927, 9.396361959000046],
                    [-0.825960929999951, 9.396232276000035],
                    [-0.825832251999941, 9.39604588800006],
                    [-0.825234850999948, 9.39566671700004],
                    [-0.824012827999979, 9.39492079200005],
                    [-0.823783686999946, 9.394808454000042],
                    [-0.823250951999967, 9.394517622000023],
                    [-0.823064820999946, 9.39443178700003],
                    [-0.822998522999967, 9.394393445000048],
                    [-0.822813196999959, 9.394286269000077],
                    [-0.82154974599996, 9.393592828000067],
                    [-0.814739951999968, 9.390101122000033],
                    [-0.814679221999938, 9.390069983000046],
                    [-0.813488572999972, 9.389458669000021],
                    [-0.812395197999933, 9.388909245000036],
                    [-0.812311130999944, 9.388858685000059],
                    [-0.812583424999957, 9.388296104000062],
                    [-0.812749921999966, 9.387772858000062],
                    [-0.812897310999972, 9.387662267000053],
                    [-0.813052714999969, 9.387553517000072],
                    [-0.81321283099993, 9.387499243000036],
                    [-0.813348871999949, 9.387413030000062],
                    [-0.813326253999946, 9.387326733000066],
                    [-0.813177244999963, 9.386934623000059],
                    [-0.813135823999971, 9.386685127000021],
                    [-0.813158689999966, 9.386311865000039],
                    [-0.813062555999977, 9.385947918000056],
                    [-0.812990102999947, 9.385589736000043],
                    [-0.812875245999976, 9.385116083000071],
                    [-0.812820406999947, 9.384756419000041],
                    [-0.812666302999958, 9.384073971000021],
                    [-0.812608455999964, 9.383793961000038],
                    [-0.812500022999927, 9.383322245000045],
                    [-0.812418204999972, 9.382929497000021],
                    [-0.812365458999977, 9.382666863000054],
                    [-0.812276917999952, 9.38223539300003],
                    [-0.812226100999965, 9.381901483000036],
                    [-0.812045056999978, 9.381379928000058],
                    [-0.812034666999978, 9.381308788000069],
                    [-0.812013021999974, 9.381241107000051],
                    [-0.811939547999941, 9.380894053000077],
                    [-0.811852875999932, 9.380501976000062],
                    [-0.811758632999954, 9.380136153000024],
                    [-0.811709621999967, 9.379956055000036],
                    [-0.811619174999976, 9.379556474000026],
                    [-0.811581455999942, 9.379449535000049],
                    [-0.811556997999958, 9.379275077000045],
                    [-0.811558294999941, 9.379222621000054],
                    [-0.81155139699996, 9.379155026000035],
                    [-0.811502383999937, 9.378974928000048],
                    [-0.811464758999932, 9.378701049000028],
                    [-0.811432731999957, 9.378545344000031],
                    [-0.811378057999946, 9.378361491000021],
                    [-0.811355452999976, 9.378247058000056],
                    [-0.811334755999951, 9.378098863000048],
                    [-0.811348310999961, 9.377942887000074],
                    [-0.811330747999932, 9.377817551000021],
                    [-0.811304752999945, 9.377697436000062],
                    [-0.811272688999964, 9.377616762000059],
                    [-0.811195328999929, 9.377468538000073],
                    [-0.811157616999935, 9.377352220000034],
                    [-0.811108617999935, 9.377151489000028],
                    [-0.811099235999961, 9.377037062000056],
                    [-0.810952274999977, 9.376367342000037],
                    [-0.81088819699994, 9.376106578000076],
                    [-0.810848610999926, 9.375963999000021],
                    [-0.810832621999964, 9.375395443000059],
                    [-0.810525240999937, 9.374248640000076],
                    [-0.810498260999964, 9.374196856000026],
                    [-0.810134096999946, 9.373871781000048],
                    [-0.809993650999957, 9.373732149000034],
                    [-0.80991665199997, 9.373616561000063],
                    [-0.809813055999939, 9.373495953000031],
                    [-0.809750539999925, 9.373437902000035],
                    [-0.809628181999926, 9.37338081300004],
                    [-0.809478681999963, 9.373215666000021],
                    [-0.809306530999947, 9.373027999000044],
                    [-0.809232569999949, 9.372885401000076],
                    [-0.809197875999928, 9.37277884100007],
                    [-0.809169233999967, 9.37265727700003],
                    [-0.809156179999945, 9.37255966500004],
                    [-0.80913004699994, 9.372477182000068],
                    [-0.809116551999978, 9.372366125000042],
                    [-0.809093882999946, 9.372291090000033],
                    [-0.809074273999954, 9.372229554000057],
                    [-0.809048678999943, 9.372064473000023],
                    [-0.809009452999931, 9.371954910000056],
                    [-0.809004953999931, 9.371891881000067],
                    [-0.809011044999977, 9.371807851000028],
                    [-0.80904437099997, 9.371653307000031],
                    [-0.808980154999972, 9.371243502000027],
                    [-0.808753362999937, 9.370783020000033],
                    [-0.802232916999969, 9.375073004000058],
                    [-0.801201283999944, 9.375899196000034],
                    [-0.800770949999958, 9.376306075000059],
                    [-0.800655806999941, 9.376062725000054],
                    [-0.800524449999955, 9.375748343000055],
                    [-0.800267887999951, 9.375207983000053],
                    [-0.800132107999957, 9.374844761000077],
                    [-0.800053681999941, 9.37458511400007],
                    [-0.799929990999942, 9.374215897000056],
                    [-0.79978063599998, 9.373809149000067],
                    [-0.79965088199998, 9.373477444000059],
                    [-0.799539452999966, 9.37320115600005],
                    [-0.799445649999939, 9.373016643000028],
                    [-0.799370176999957, 9.372884547000069],
                    [-0.799275072999933, 9.372728432000031],
                    [-0.799187544999938, 9.372539306000021],
                    [-0.799121151999941, 9.372381706000056],
                    [-0.799069860999964, 9.372236119000036],
                    [-0.798979373999941, 9.371938948000036],
                    [-0.79889942099993, 9.371712312000056],
                    [-0.798765143999958, 9.371364097000026],
                    [-0.798517392999941, 9.370748844000047],
                    [-0.798383395999963, 9.37044551300005],
                    [-0.798273256999948, 9.370163339000044],
                    [-0.796317685999952, 9.371658293000053],
                    [-0.786158431999979, 9.374716226000032],
                    [-0.785381602999962, 9.374950037000076],
                    [-0.782490173999975, 9.375652606000074],
                    [-0.781846645999963, 9.376117369000042],
                    [-0.78192295599996, 9.376117194000074],
                    [-0.782023058999926, 9.376166751000028],
                    [-0.78238162599996, 9.376344260000053],
                    [-0.782515565999972, 9.376408034000065],
                    [-0.782911150999951, 9.376596393000057],
                    [-0.783426333999955, 9.376820125000052],
                    [-0.783502618999933, 9.376853254000025],
                    [-0.78411003399998, 9.377210271000024],
                    [-0.78482556199998, 9.377541080000071],
                    [-0.785025779999955, 9.377706025000066],
                    [-0.786564160999944, 9.378591700000072],
                    [-0.787060043999929, 9.378878888000031],
                    [-0.78827709199993, 9.379583731000025],
                    [-0.789485884999976, 9.380283008000049],
                    [-0.789347239999927, 9.380521336000072],
                    [-0.789162585999975, 9.380855526000062],
                    [-0.788954908999926, 9.381134750000058],
                    [-0.788636531999941, 9.381464282000024],
                    [-0.788262914999962, 9.381633498000042],
                    [-0.787907773999962, 9.38174777200004],
                    [-0.78754851399998, 9.381768572000055],
                    [-0.786953241999925, 9.381742619000022],
                    [-0.78664258799995, 9.381741631000068],
                    [-0.78589465999994, 9.381739250000066],
                    [-0.785627428999931, 9.381738398000039],
                    [-0.785177894999947, 9.381736967000052],
                    [-0.784541414999978, 9.381674375000046],
                    [-0.782235760999924, 9.381447631000071],
                    [-0.781213623999975, 9.381317822000028],
                    [-0.780433458999937, 9.381218743000034],
                    [-0.779565289999937, 9.381108484000038],
                    [-0.778529692999939, 9.380976960000055],
                    [-0.778092485999935, 9.380921432000036],
                    [-0.777791756999932, 9.380882997000072],
                    [-0.777346170999976, 9.380840783000053],
                    [-0.77624746999993, 9.380734094000047],
                    [-0.776026796999929, 9.380712664000043],
                    [-0.775181736999969, 9.380630464000035],
                    [-0.774755610999932, 9.380589013000076],
                    [-0.773910364999949, 9.380506873000058],
                    [-0.771750763999933, 9.380296997000073],
                    [-0.770134801999973, 9.380137025000067],
                    [-0.769714092999948, 9.380095375000053],
                    [-0.767656559999978, 9.379891756000063],
                    [-0.767262113999948, 9.379894457000034],
                    [-0.766901493999967, 9.37982712400003],
                    [-0.765916109999978, 9.379486059000044],
                    [-0.765429873999949, 9.379317996000054],
                    [-0.764545812999927, 9.37901202300003],
                    [-0.76395671299997, 9.378808155000058],
                    [-0.763544537999962, 9.378665515000023],
                    [-0.762757191999924, 9.378393262000031],
                    [-0.762182192999944, 9.378194437000047],
                    [-0.761757537999927, 9.378063905000033],
                    [-0.76158767499993, 9.378012975000047],
                    [-0.760799944999974, 9.377778102000036],
                    [-0.760075668999946, 9.377561942000057],
                    [-0.759120009999947, 9.377276723000023],
                    [-0.758559937999962, 9.377109566000058],
                    [-0.756963718999941, 9.376633857000058],
                    [-0.755917246999957, 9.376321979000068],
                    [-0.755444145999945, 9.376208797000061],
                    [-0.754533840999954, 9.375883133000059],
                    [-0.753555077999977, 9.375532977000034],
                    [-0.751854298999945, 9.374924502000056],
                    [-0.749920797999948, 9.374232758000062],
                    [-0.749770586999944, 9.374143233000041],
                    [-0.748488621999968, 9.373688439000034],
                    [-0.746000106999929, 9.372804966000047],
                    [-0.745111000999941, 9.372489309000059],
                    [-0.743336579999948, 9.371859336000057],
                    [-0.741245267999943, 9.371744959000068],
                    [-0.740903554999932, 9.371729147000053],
                    [-0.739241496999966, 9.371652221000033],
                    [-0.738458428999934, 9.371702830000061],
                    [-0.736989034999965, 9.372438747000047],
                    [-0.736125448999928, 9.372723916000041],
                    [-0.735670156999959, 9.372874259000071],
                    [-0.73397958399994, 9.373040876000061],
                    [-0.73245825999993, 9.372939001000077],
                    [-0.730299475999971, 9.372642103000032],
                    [-0.724083134999944, 9.373357611000074],
                    [-0.722502902999963, 9.373546160000046],
                    [-0.72093809699993, 9.373732862000054],
                    [-0.719639030999929, 9.373831787000029],
                    [-0.718067345999941, 9.373951463000026],
                    [-0.712979403999952, 9.374338840000064],
                    [-0.710573067999974, 9.374522023000054],
                    [-0.709227772999952, 9.374624428000061],
                    [-0.706564932999925, 9.374793354000076],
                    [-0.70556705599995, 9.374856654000041],
                    [-0.704578629999958, 9.375087403000066],
                    [-0.70337542599998, 9.375442946000021],
                    [-0.700257944999976, 9.376649648000068],
                    [-0.696096193999949, 9.37842149100004],
                    [-0.689827589999936, 9.381069951000029],
                    [-0.68916351699994, 9.381226471000048],
                    [-0.68880153799995, 9.381315921000066],
                    [-0.686452411999937, 9.381894645000045],
                    [-0.685212297999954, 9.382126079000045],
                    [-0.684160347999978, 9.38234168300005],
                    [-0.683365154999933, 9.382699455000022],
                    [-0.682038059999968, 9.382772958000032],
                    [-0.680765733999976, 9.382843422000064],
                    [-0.678466911999976, 9.382970726000053],
                    [-0.676976957999955, 9.383048516000031],
                    [-0.675758362999943, 9.383149303000039],
                    [-0.675618128999929, 9.383159527000032],
                    [-0.674559316999932, 9.383236729000032],
                    [-0.673538578999967, 9.383311152000033],
                    [-0.672735327999931, 9.383369714000025],
                    [-0.672307844999978, 9.383400879000021],
                    [-0.671935755999925, 9.383429546000059],
                    [-0.670847155999979, 9.383513407000066],
                    [-0.669991668999955, 9.383579307000048],
                    [-0.669278052999971, 9.383634277000056],
                    [-0.669203644999925, 9.383640009000032],
                    [-0.668508526999972, 9.383664411000041],
                    [-0.667944184999953, 9.383731388000058],
                    [-0.667674064999972, 9.383693704000052],
                    [-0.667406954999933, 9.383616245000042],
                    [-0.667063362999954, 9.383516607000047],
                    [-0.665123541999947, 9.38275292700007],
                    [-0.663180801999943, 9.381997644000023],
                    [-0.661446299999966, 9.381296741000028],
                    [-0.661137715999928, 9.381172101000061],
                    [-0.659326195999938, 9.380440406000048],
                    [-0.657447802999968, 9.379680950000022],
                    [-0.654590869999936, 9.378467563000072],
                    [-0.652121484999952, 9.377484191000065],
                    [-0.650463498999954, 9.376823924000064],
                    [-0.649867212999936, 9.376586461000045],
                    [-0.649639007999951, 9.376495581000029],
                    [-0.648476448999929, 9.376032601000077],
                    [-0.648432010999954, 9.376016002000028],
                    [-0.646474963999935, 9.375344799000061],
                    [-0.645026235999978, 9.374831878000066],
                    [-0.643896746999928, 9.374432542000022],
                    [-0.643002887999955, 9.374116502000049],
                    [-0.64246628199993, 9.373787439000068],
                    [-0.641710239999952, 9.373659100000054],
                    [-0.640641578999976, 9.373305778000031],
                    [-0.640032823999945, 9.373088813000038],
                    [-0.638157324999952, 9.372420360000035],
                    [-0.637136295999937, 9.372056447000034],
                    [-0.636178171999973, 9.371714951000058],
                    [-0.635544066999955, 9.371488941000052],
                    [-0.634191486999953, 9.371006844000021],
                    [-0.634041126999932, 9.37095325100006],
                    [-0.633826192999948, 9.370936935000032],
                    [-0.63365543499998, 9.37092397300006],
                    [-0.633389825999927, 9.37083447200007],
                    [-0.632976218999943, 9.370811392000064],
                    [-0.632288217999928, 9.370820181000056],
                    [-0.631779537999932, 9.370781565000073],
                    [-0.631202412999926, 9.370801630000074],
                    [-0.629575374999945, 9.37085819400005],
                    [-0.627827212999932, 9.370910347000063],
                    [-0.626660817999948, 9.370970084000021],
                    [-0.626397096999938, 9.370997966000061],
                    [-0.625346082999954, 9.371067199000038],
                    [-0.623963691999961, 9.371135204000041],
                    [-0.622634432999973, 9.371288846000027],
                    [-0.621507959999974, 9.371419538000055],
                    [-0.620449416999975, 9.371541743000023],
                    [-0.619277822999948, 9.371677417000058],
                    [-0.618223842999953, 9.371799116000034],
                    [-0.617087226999956, 9.371930791000068],
                    [-0.616192938999973, 9.372034032000045],
                    [-0.61555070199995, 9.372144494000054],
                    [-0.614995105999981, 9.372205958000052],
                    [-0.614742057999933, 9.372233952000045],
                    [-0.613905703999933, 9.375250227000038],
                    [-0.611595527999953, 9.376900400000068],
                    [-0.608213284999977, 9.37710992500007],
                    [-0.60628077399997, 9.377054469000029],
                    [-0.603275458999974, 9.376251424000031],
                    [-0.60129066899998, 9.374969690000057],
                    [-0.60069785099995, 9.373344919000033],
                    [-0.59564777199995, 9.373437795000029],
                    [-0.589150505999953, 9.373657038000033],
                    [-0.586523535999959, 9.374315185000057],
                    [-0.586043849999953, 9.374469689000023],
                    [-0.584745658999964, 9.374887824000041],
                    [-0.580618320999974, 9.376185236000026],
                    [-0.578895315999944, 9.376744015000043],
                    [-0.575181401999941, 9.377948420000052],
                    [-0.572569359999932, 9.378683120000062],
                    [-0.572392437999952, 9.378732883000055],
                    [-0.571915666999928, 9.378866985000059],
                    [-0.571058594999954, 9.37910805000007],
                    [-0.570338097999979, 9.37931069900003],
                    [-0.563005259999954, 9.381119019000039],
                    [-0.562909872999967, 9.381142652000051],
                    [-0.561279087999935, 9.381546687000025],
                    [-0.560001032999935, 9.38186332600003],
                    [-0.558890577999932, 9.382138438000027],
                    [-0.557516733999933, 9.382478799000069],
                    [-0.556421901999954, 9.382750030000068],
                    [-0.555254063999939, 9.383039344000053],
                    [-0.553979100999925, 9.383355193000057],
                    [-0.55286756299995, 9.383630550000021],
                    [-0.551737652999975, 9.38391045700007],
                    [-0.550631599999974, 9.384184448000042],
                    [-0.54923660399993, 9.384530011000038],
                    [-0.549138245999927, 9.384554723000065],
                    [-0.547704754999927, 9.38491487400006],
                    [-0.544325711999932, 9.385763801000053],
                    [-0.54291742099997, 9.386113157000068],
                    [-0.542183598999941, 9.386295195000059],
                    [-0.535852573999932, 9.387865752000039],
                    [-0.534121804999927, 9.388295087000074],
                    [-0.533744895999973, 9.387870109000062],
                    [-0.533881717999975, 9.387255620000076],
                    [-0.53392077899997, 9.387104070000021],
                    [-0.533921083999928, 9.38687529200007],
                    [-0.533979550999959, 9.386740307000025],
                    [-0.53397965399995, 9.386663129000056],
                    [-0.53397975699994, 9.38658595000004],
                    [-0.534018716999924, 9.386511580000047],
                    [-0.534038529999975, 9.386222187000044],
                    [-0.534074712999939, 9.386147813000036],
                    [-0.534055716999944, 9.385822536000035],
                    [-0.534094780999965, 9.385668231000068],
                    [-0.534250314999952, 9.385591257000044],
                    [-0.534402972999942, 9.385591458000022],
                    [-0.534807918999945, 9.385804231000066],
                    [-0.534885635999956, 9.385804333000067],
                    [-0.534963402999949, 9.385765846000027],
                    [-0.535002362999933, 9.385688719000029],
                    [-0.535002464999934, 9.385611542000049],
                    [-0.535041426999953, 9.385534414000062],
                    [-0.53511646499993, 9.385460090000038],
                    [-0.535097138999959, 9.385382887000048],
                    [-0.535233446999939, 9.385154288000024],
                    [-0.535311263999972, 9.385077212000056],
                    [-0.535389032999944, 9.385038724000026],
                    [-0.535463971999945, 9.38503882200007],
                    [-0.535619503999953, 9.384961848000046],
                    [-0.535697323999955, 9.384884771000031],
                    [-0.535736279999981, 9.384810401000038],
                    [-0.535736691999944, 9.384501688000057],
                    [-0.535601121999946, 9.384176258000025],
                    [-0.535544087999938, 9.383881139000039],
                    [-0.535464530999946, 9.38373583200007],
                    [-0.535438384999964, 9.383405795000044],
                    [-0.535318986999926, 9.383234035000044],
                    [-0.535239726999976, 9.382864325000071],
                    [-0.535200360999966, 9.382481470000073],
                    [-0.535134057999926, 9.382362581000052],
                    [-0.535094585999957, 9.382058925000024],
                    [-0.535094903999948, 9.381821323000054],
                    [-0.535171832999936, 9.381400029000076],
                    [-0.53519156699997, 9.381171276000032],
                    [-0.535247380999976, 9.380942571000048],
                    [-0.535267117999979, 9.380711062000046],
                    [-0.535306075999927, 9.380633934000059],
                    [-0.535267317999967, 9.380559462000065],
                    [-0.535267524999938, 9.380405105000023],
                    [-0.535306484999978, 9.380327978000025],
                    [-0.535267725999972, 9.380253505000042],
                    [-0.535268034999945, 9.38002197000003],
                    [-0.535306993999939, 9.379944844000022],
                    [-0.535268234999933, 9.379870370000049],
                    [-0.535269151999955, 9.379181278000033],
                    [-0.535194826999941, 9.378720868000073],
                    [-0.53519503299998, 9.378566510000041],
                    [-0.535156274999963, 9.378492037000058],
                    [-0.535078967999937, 9.378185979000023],
                    [-0.535079070999927, 9.378108801000053],
                    [-0.535040316999925, 9.378031571000065],
                    [-0.535040417999937, 9.377954393000039],
                    [-0.534982236999952, 9.377877139000077],
                    [-0.534924151999974, 9.377725462000058],
                    [-0.534924256999943, 9.377648284000031],
                    [-0.534849621999967, 9.377419406000058],
                    [-0.534849723999969, 9.377342228000032],
                    [-0.534791541999937, 9.377264973000024],
                    [-0.534791742999971, 9.377113373000043],
                    [-0.534733664999976, 9.376958940000065],
                    [-0.534695112999941, 9.376730111000029],
                    [-0.534578797999927, 9.376537012000028],
                    [-0.53457889699996, 9.376462590000074],
                    [-0.534523516999968, 9.376366045000054],
                    [-0.534484865999957, 9.37621163700004],
                    [-0.534426656999926, 9.376153676000058],
                    [-0.534271664999949, 9.375828221000063],
                    [-0.53421345199996, 9.375773017000029],
                    [-0.534119396999927, 9.375541358000021],
                    [-0.533811724999964, 9.375234997000064],
                    [-0.533734213999935, 9.375083293000046],
                    [-0.533540239999979, 9.374851504000048],
                    [-0.533310387999961, 9.37446806500003],
                    [-0.533194021999975, 9.374316312000076],
                    [-0.533080536999933, 9.374084626000069],
                    [-0.532811778999928, 9.373739725000064],
                    [-0.532714837999947, 9.373587997000072],
                    [-0.532695512999965, 9.373510793000037],
                    [-0.53261785199993, 9.373472102000051],
                    [-0.53236867399994, 9.373014216000058],
                    [-0.532252309999933, 9.372859705000053],
                    [-0.532194077999975, 9.37282103900003],
                    [-0.532155349999925, 9.372724515000073],
                    [-0.531983553999964, 9.372514804000048],
                    [-0.531944801999941, 9.37243757400006],
                    [-0.531808980999926, 9.372305090000054],
                    [-0.53125242699997, 9.371325841000044],
                    [-0.531233201999953, 9.371174216000043],
                    [-0.531080962999965, 9.370868057000052],
                    [-0.530964653999945, 9.370674957000062],
                    [-0.530828861999964, 9.370523177000052],
                    [-0.530751460999966, 9.37029153900005],
                    [-0.530541015999972, 9.369927420000067],
                    [-0.530463376999933, 9.369872189000034],
                    [-0.530311040999948, 9.369640452000056],
                    [-0.53023338099996, 9.369601761000069],
                    [-0.52984805899996, 9.369256703000076],
                    [-0.529695509999954, 9.369182079000041],
                    [-0.529540293999958, 9.369027516000074],
                    [-0.529002377999973, 9.368643666000025],
                    [-0.528924667999945, 9.368643563000035],
                    [-0.528847058999929, 9.368566281000028],
                    [-0.52859742499993, 9.368452938000075],
                    [-0.527923258999976, 9.368259095000042],
                    [-0.527615391999973, 9.368107086000066],
                    [-0.527537680999956, 9.368106981000039],
                    [-0.527132858999948, 9.367819779000058],
                    [-0.526883460999954, 9.367530028000033],
                    [-0.526689544999954, 9.367262401000062],
                    [-0.526650790999952, 9.367186550000042],
                    [-0.526612038999929, 9.367110697000044],
                    [-0.526537207999979, 9.367033419000052],
                    [-0.526401523999937, 9.366804459000036],
                    [-0.526382197999965, 9.366727255000058],
                    [-0.526229813999976, 9.366534106000074],
                    [-0.526036054999963, 9.366150711000046],
                    [-0.526036155999975, 9.366076289000034],
                    [-0.525958496999976, 9.366037596000069],
                    [-0.525767512999948, 9.365654205000055],
                    [-0.525728866999941, 9.365501175000077],
                    [-0.525631214999976, 9.365104711000072],
                    [-0.525609164999935, 9.365015188000029],
                    [-0.52556346199998, 9.36482963900005],
                    [-0.525523353999972, 9.364666794000073],
                    [-0.525489661999927, 9.364530012000046],
                    [-0.525392455999963, 9.364135350000026],
                    [-0.525377133999939, 9.364073140000073],
                    [-0.525334698999927, 9.363900857000033],
                    [-0.525220482999941, 9.363437139000041],
                    [-0.525181467999971, 9.363278732000026],
                    [-0.52510644299997, 9.362974129000065],
                    [-0.525124189999929, 9.362622290000047],
                    [-0.525164914999948, 9.362501492000035],
                    [-0.525396327999943, 9.362391513000034],
                    [-0.525505147999979, 9.362172809000072],
                    [-0.525638266999977, 9.36190526200005],
                    [-0.525683189999938, 9.361814971000058],
                    [-0.525737221999975, 9.361706376000029],
                    [-0.525825625999971, 9.361528700000065],
                    [-0.525926023999943, 9.361326916000053],
                    [-0.526003834999926, 9.361252599000068],
                    [-0.526312161999954, 9.361060064000071],
                    [-0.526409634999936, 9.360812121000038],
                    [-0.526506955999935, 9.360677188000068],
                    [-0.526507054999968, 9.360602767000046],
                    [-0.526660116999949, 9.360294257000021],
                    [-0.526699177999944, 9.360142709000058],
                    [-0.526777097999968, 9.359988456000053],
                    [-0.526777196999944, 9.359914034000042],
                    [-0.526816156999928, 9.359836908000034],
                    [-0.526893971999925, 9.359759833000055],
                    [-0.526949658999968, 9.359624845000042],
                    [-0.527027444999931, 9.359569822000026],
                    [-0.527144217999933, 9.35941562000005],
                    [-0.527259486999981, 9.359348244000046],
                    [-0.527374754999926, 9.359280866000063],
                    [-0.527530246999959, 9.359225945000048],
                    [-0.52799105899993, 9.359149381000066],
                    [-0.528704320999964, 9.359150328000055],
                    [-0.528781980999952, 9.359189020000031],
                    [-0.528937398999972, 9.359189227000059],
                    [-0.529245361999926, 9.359264057000075],
                    [-0.529323119999958, 9.359228328000029],
                    [-0.529398004999962, 9.359264261000021],
                    [-0.529456313999958, 9.359245043000044],
                    [-0.529631134999931, 9.359264569000061],
                    [-0.529861589999939, 9.359190452000064],
                    [-0.530056250999962, 9.358901291000052],
                    [-0.530131259999962, 9.358846263000032],
                    [-0.530131361999963, 9.358769085000063],
                    [-0.530170321999947, 9.358691959000055],
                    [-0.530170834999979, 9.358308823000073],
                    [-0.530209793999973, 9.358231696000075],
                    [-0.530171039999971, 9.358157223000035],
                    [-0.530132697999932, 9.357774036000023],
                    [-0.530133109999952, 9.357468079000057],
                    [-0.530172066999967, 9.35739095200006],
                    [-0.530152768999926, 9.357294454000055],
                    [-0.530172299999947, 9.357217301000048],
                    [-0.530172580999931, 9.357007817000067],
                    [-0.530250597999952, 9.35677914200005],
                    [-0.530250700999943, 9.356701963000035],
                    [-0.530367571999932, 9.356473339000047],
                    [-0.530442609999966, 9.356396260000054],
                    [-0.530539952999959, 9.356242032000068],
                    [-0.530637394999928, 9.356013382000071],
                    [-0.530637601999956, 9.355859025000029],
                    [-0.530676555999946, 9.355784654000047],
                    [-0.530676660999973, 9.355707476000021],
                    [-0.530637909999939, 9.355630246000032],
                    [-0.530609025999979, 9.355438640000045],
                    [-0.530580141999963, 9.355247034000058],
                    [-0.53067778999997, 9.354864027000076],
                    [-0.530677992999927, 9.354712427000038],
                    [-0.530736482999941, 9.354558148000024],
                    [-0.53075621499994, 9.354329395000036],
                    [-0.530756624999924, 9.35402343800007],
                    [-0.530717977999927, 9.353869031000045],
                    [-0.530718285999967, 9.353640251000058],
                    [-0.530660209999951, 9.353485817000035],
                    [-0.530679741999961, 9.353408666000064],
                    [-0.530680046999976, 9.353179886000021],
                    [-0.530758062999951, 9.352951210000072],
                    [-0.530794295999954, 9.352835491000064],
                    [-0.530852805999928, 9.352664673000049],
                    [-0.530911165999953, 9.352606866000031],
                    [-0.530911267999954, 9.352529688000061],
                    [-0.531008735999933, 9.352281743000049],
                    [-0.531142130999967, 9.352146857000037],
                    [-0.531220041999973, 9.351995360000046],
                    [-0.531297853999945, 9.351918283000032],
                    [-0.53131738299993, 9.351841130000025],
                    [-0.531434151999974, 9.351686928000049],
                    [-0.531914990999951, 9.351152825000042],
                    [-0.53207071199995, 9.350924251000038],
                    [-0.53218490699993, 9.350618445000066],
                    [-0.532185112999969, 9.350464088000024],
                    [-0.532129913999938, 9.35023523600006],
                    [-0.532032958999935, 9.350100047000069],
                    [-0.53195545799997, 9.349945586000047],
                    [-0.531877927999972, 9.349813178000034],
                    [-0.531803300999968, 9.349584302000039],
                    [-0.531803402999969, 9.349507123000024],
                    [-0.531687100999932, 9.349314023000034],
                    [-0.531687198999975, 9.349239601000022],
                    [-0.531629048999946, 9.349143051000055],
                    [-0.531571051999947, 9.348930735000067],
                    [-0.531571149999934, 9.348856313000056],
                    [-0.531493649999959, 9.348701853000023],
                    [-0.531438655999978, 9.348318644000074],
                    [-0.53144872799993, 9.348051289000068],
                    [-0.53145879799996, 9.347783934000063],
                    [-0.53149498099998, 9.347706803000051],
                    [-0.53145905599996, 9.347590988000036],
                    [-0.531495233999976, 9.347516614000028],
                    [-0.531495337999957, 9.347439436000059],
                    [-0.531573378999951, 9.347188708000033],
                    [-0.531768154999952, 9.346808585000076],
                    [-0.532076951999954, 9.346252205000042],
                    [-0.532346634999953, 9.345888718000026],
                    [-0.532463475999975, 9.345679387000075],
                    [-0.532463577999977, 9.345602209000049],
                    [-0.532558163999965, 9.345431438000048],
                    [-0.532577898999932, 9.345199928000056],
                    [-0.532578074999947, 9.345067622000045],
                    [-0.532539324999959, 9.344990393000046],
                    [-0.532484254999929, 9.34466506800004],
                    [-0.532520739999939, 9.344359159000021],
                    [-0.532637584999975, 9.344147071000066],
                    [-0.532868333999943, 9.343841418000068],
                    [-0.532926664999934, 9.343802905000075],
                    [-0.533024102999946, 9.343574253000043],
                    [-0.533082687999979, 9.343345553000063],
                    [-0.53308289499995, 9.343191194000042],
                    [-0.53312184999993, 9.343114067000045],
                    [-0.533102520999932, 9.343039619000024],
                    [-0.533122255999956, 9.342808110000021],
                    [-0.533200471999976, 9.34242507700003],
                    [-0.533161717999974, 9.342350603000057],
                    [-0.533334470999932, 9.341832631000045],
                    [-0.533392827999933, 9.341774824000026],
                    [-0.533373528999959, 9.341678325000032],
                    [-0.533393131999958, 9.34154604500003],
                    [-0.533432088999973, 9.341468918000032],
                    [-0.533412788999954, 9.341372419000038],
                    [-0.533432519999963, 9.34114366600005],
                    [-0.533471449999979, 9.341085834000069],
                    [-0.533452456999953, 9.340760556000021],
                    [-0.533471985999938, 9.340683403000071],
                    [-0.533472469999936, 9.340319562000047],
                    [-0.533511827999973, 9.339939234000042],
                    [-0.533473077999929, 9.339862005000043],
                    [-0.533473282999978, 9.339707647000068],
                    [-0.533434532999934, 9.33963041800007],
                    [-0.533435168999972, 9.339153565000061],
                    [-0.533474303999981, 9.338941376000037],
                    [-0.533513253999956, 9.338867005000054],
                    [-0.533493956999962, 9.33877050600006],
                    [-0.533533112999976, 9.338541778000035],
                    [-0.533588718999965, 9.338464673000033],
                    [-0.533627777999925, 9.338310367000076],
                    [-0.533744510999952, 9.338178214000038],
                    [-0.533744612999953, 9.338101035000022],
                    [-0.53390043099995, 9.337795282000059],
                    [-0.533900531999961, 9.337718103000043],
                    [-0.533975564999935, 9.33764102300006],
                    [-0.534131355999932, 9.337354565000055],
                    [-0.53417041199998, 9.337200259000042],
                    [-0.534248317999925, 9.337048759000027],
                    [-0.534323324999946, 9.33699097300007],
                    [-0.534440186999973, 9.336762347000047],
                    [-0.534748992999937, 9.336186668000039],
                    [-0.534768517999964, 9.336112272000037],
                    [-0.534865801999956, 9.335996631000057],
                    [-0.534999647999939, 9.335517196000069],
                    [-0.535077550999972, 9.335365697000043],
                    [-0.535175188999972, 9.334982688000025],
                    [-0.535175394999953, 9.334828332000029],
                    [-0.535214319999966, 9.334773255000073],
                    [-0.535195199999976, 9.334541694000052],
                    [-0.535214728999961, 9.334464541000045],
                    [-0.53521503199994, 9.334235762000048],
                    [-0.535253986999976, 9.334158634000062],
                    [-0.535254084999963, 9.33408421200005],
                    [-0.535215334999975, 9.334006983000052],
                    [-0.535235369999953, 9.333546694000063],
                    [-0.535330334999969, 9.33308650400005],
                    [-0.535369283999955, 9.333012132000022],
                    [-0.535349959999962, 9.332934929000032],
                    [-0.535525504999953, 9.332397663000052],
                    [-0.535525706999977, 9.332246063000071],
                    [-0.535603461999926, 9.332207575000041],
                    [-0.53556471099995, 9.332130346000042],
                    [-0.535584464999943, 9.33188229700005],
                    [-0.535659797999926, 9.33157643800007],
                    [-0.535660002999975, 9.331422081000028],
                    [-0.53571835799994, 9.331364273000077],
                    [-0.535699259999944, 9.331116174000044],
                    [-0.53571878899993, 9.331039021000038],
                    [-0.53572010399995, 9.330043971000066],
                    [-0.535681450999959, 9.329892318000077],
                    [-0.535681758999942, 9.329660783000065],
                    [-0.535646087999964, 9.329354778000038],
                    [-0.535646285999974, 9.329203178000057],
                    [-0.53568243899997, 9.329145341000071],
                    [-0.535663342999953, 9.328897242000039],
                    [-0.535682845999929, 9.328839384000048],
                    [-0.535646868999947, 9.328762158000075],
                    [-0.535608955999976, 9.32805372100006],
                    [-0.535570308999979, 9.327899312000056],
                    [-0.535571394999977, 9.32707791200005],
                    [-0.535494097999958, 9.326771853000025],
                    [-0.535455500999944, 9.326578856000026],
                    [-0.534531000999948, 9.326700551000044],
                    [-0.534646061999979, 9.326302535000025],
                    [-0.534794982999927, 9.325787395000077],
                    [-0.534969947999969, 9.325182162000033],
                    [-0.535002077999934, 9.324784581000074],
                    [-0.535051479999936, 9.324173288000054],
                    [-0.535310462999973, 9.323698206000074],
                    [-0.535316775999945, 9.323306882000054],
                    [-0.535151424999924, 9.322936555000069],
                    [-0.535165277999965, 9.322765147000041],
                    [-0.535074526999949, 9.322477860000049],
                    [-0.535026302999938, 9.322078489000035],
                    [-0.53490962099994, 9.321828321000055],
                    [-0.534794277999936, 9.321581020000053],
                    [-0.534622226999943, 9.321212142000036],
                    [-0.534529838999958, 9.321014060000039],
                    [-0.534419369999966, 9.320777212000053],
                    [-0.535587686999975, 9.319896115000063],
                    [-0.536183555999969, 9.319388493000076],
                    [-0.536798511999962, 9.319108691000054],
                    [-0.536954950999927, 9.319108166000035],
                    [-0.537160042999972, 9.318702067000061],
                    [-0.537258505999944, 9.318493462000049],
                    [-0.537286501999972, 9.31826460700006],
                    [-0.537475631999939, 9.318030412000041],
                    [-0.537641182999948, 9.317996041000072],
                    [-0.537733193999941, 9.317976939000062],
                    [-0.537839514999973, 9.317954866000036],
                    [-0.538095806999934, 9.318161498000052],
                    [-0.538156782999977, 9.318246523000028],
                    [-0.538326565999967, 9.318524248000074],
                    [-0.538559842999973, 9.318636776000062],
                    [-0.538779434999924, 9.31857498100004],
                    [-0.53890176799996, 9.318453787000067],
                    [-0.53907690099993, 9.318138060000024],
                    [-0.539232111999979, 9.318090157000029],
                    [-0.539476425999965, 9.318114743000024],
                    [-0.539708444999974, 9.318199991000029],
                    [-0.539842516999954, 9.318442868000034],
                    [-0.540082437999956, 9.318635533000077],
                    [-0.54030180899997, 9.318735744000037],
                    [-0.540563020999969, 9.318686503000038],
                    [-0.540841832999945, 9.318418485000052],
                    [-0.541064343999949, 9.318371632000037],
                    [-0.541210919999969, 9.318396092000057],
                    [-0.54130854899995, 9.318481163000058],
                    [-0.541613950999931, 9.318505827000024],
                    [-0.541785259999926, 9.318299749000062],
                    [-0.541773534999948, 9.317923541000027],
                    [-0.54190816299996, 9.317741687000023],
                    [-0.54216469399995, 9.317766286000051],
                    [-0.542323375999956, 9.317875707000042],
                    [-0.54250666799993, 9.317851672000074],
                    [-0.542555757999935, 9.317681841000024],
                    [-0.542324213999962, 9.317232541000067],
                    [-0.542397768999933, 9.317038470000057],
                    [-0.542532269999924, 9.316953696000041],
                    [-0.542703280999945, 9.316978186000028],
                    [-0.543008617999931, 9.317051389000028],
                    [-0.543167505999975, 9.317003052000075],
                    [-0.543204345999925, 9.316857476000052],
                    [-0.543229270999973, 9.316481317000068],
                    [-0.543412763999925, 9.316299522000065],
                    [-0.543535030999976, 9.316226868000058],
                    [-0.543681844999981, 9.31606929700007],
                    [-0.543682427999954, 9.315620295000031],
                    [-0.543731451999975, 9.31549900400006],
                    [-0.544000404999963, 9.315365860000043],
                    [-0.544209385999977, 9.315290679000043],
                    [-0.544403761999945, 9.315220753000062],
                    [-0.544489564999935, 9.315002428000071],
                    [-0.54456307199996, 9.314844765000032],
                    [-0.544746519999933, 9.314699375000032],
                    [-0.544868624999935, 9.314700145000074],
                    [-0.545100738999963, 9.314760504000049],
                    [-0.545223, 9.314759733000074],
                    [-0.545345052999949, 9.314785086000029],
                    [-0.545625835999942, 9.314781658000072],
                    [-0.545809525999971, 9.314778974000035],
                    [-0.545902202999969, 9.314777620000029],
                    [-0.546151403999943, 9.314773978000062],
                    [-0.546322742999962, 9.314543627000035],
                    [-0.546469488999946, 9.314434597000059],
                    [-0.546652777999952, 9.314410559000066],
                    [-0.54676296599996, 9.314228670000034],
                    [-0.546750875999976, 9.314131573000054],
                    [-0.54687318799995, 9.314022512000065],
                    [-0.547081051999953, 9.313889289000031],
                    [-0.547435207999968, 9.313998956000034],
                    [-0.547654633999969, 9.314375426000026],
                    [-0.547788931999946, 9.314448409000022],
                    [-0.548018111999966, 9.314310119000027],
                    [-0.548143415999959, 9.314303235000068],
                    [-0.548302206999949, 9.314327706000029],
                    [-0.548485263999964, 9.314485698000055],
                    [-0.548656274999928, 9.314510184000028],
                    [-0.548729762999926, 9.314364653000041],
                    [-0.548693408999952, 9.314134037000031],
                    [-0.548656989999927, 9.313951962000033],
                    [-0.548657114999969, 9.313854881000054],
                    [-0.548803843999963, 9.313757985000052],
                    [-0.548999101999925, 9.313928126000064],
                    [-0.549267691999944, 9.314074088000041],
                    [-0.549499957999956, 9.313965164000024],
                    [-0.549512392999929, 9.313795286000072],
                    [-0.549415779999947, 9.313466755000036],
                    [-0.549328612999943, 9.313275076000025],
                    [-0.549348136999924, 9.313197922000029],
                    [-0.549542580999969, 9.313046567000072],
                    [-0.549695228999951, 9.313027466000051],
                    [-0.549850603999971, 9.31304695700004],
                    [-0.550065182999958, 9.313153004000071],
                    [-0.550159529999974, 9.313155189000042],
                    [-0.55038880799998, 9.313160647000075],
                    [-0.55046645699997, 9.313199334000046],
                    [-0.550544183999932, 9.313180137000074],
                    [-0.550774480999962, 9.313199722000036],
                    [-0.550832829999933, 9.313141912000049],
                    [-0.550929978999932, 9.31312273900005],
                    [-0.551082845999929, 9.312932741000054],
                    [-0.55110239499993, 9.312836292000043],
                    [-0.551160742999969, 9.312778481000066],
                    [-0.55116083799993, 9.312704060000044],
                    [-0.551238951999949, 9.31237890400007],
                    [-0.551314074999937, 9.312224641000057],
                    [-0.55139184799998, 9.312166854000054],
                    [-0.551411394999946, 9.312070405000043],
                    [-0.551450314999954, 9.31201532700004],
                    [-0.551933599999927, 9.311671386000057],
                    [-0.552008720999936, 9.311517123000044],
                    [-0.552203260999931, 9.311288587000035],
                    [-0.552242210999964, 9.31121145700007],
                    [-0.552472773999966, 9.311021555000025],
                    [-0.552472970999929, 9.310867198000039],
                    [-0.552375943999948, 9.310789898000053],
                    [-0.552270566999937, 9.310733260000063],
                    [-0.552165189999926, 9.310676622000074],
                    [-0.552087614999948, 9.310580051000045],
                    [-0.552087810999979, 9.310425692000024],
                    [-0.552126732999966, 9.310367858000063],
                    [-0.552126828999974, 9.310293434000073],
                    [-0.552165801999934, 9.310197011000071],
                    [-0.552396585999929, 9.309833456000035],
                    [-0.552474334999943, 9.309794964000048],
                    [-0.55255213199996, 9.309717883000076],
                    [-0.552610428999969, 9.309698662000073],
                    [-0.552685328999928, 9.309718050000072],
                    [-0.552879454999925, 9.309814767000034],
                    [-0.553114968999978, 9.310096214000055],
                    [-0.553284135999945, 9.310179118000065],
                    [-0.553361884999958, 9.310140627000067],
                    [-0.553437000999963, 9.309989118000033],
                    [-0.553379020999955, 9.309757509000065],
                    [-0.553284841999925, 9.309625084000061],
                    [-0.553149037999958, 9.309489851000023],
                    [-0.553129808999927, 9.309335469000075],
                    [-0.553227100999948, 9.309203285000024],
                    [-0.553324249999946, 9.309184112000025],
                    [-0.553690544999938, 9.30918457000007],
                    [-0.553843264999955, 9.30910758300007],
                    [-0.553882211999962, 9.309030452000059],
                    [-0.553843553999968, 9.308878802000038],
                    [-0.553766051999958, 9.308724348000055],
                    [-0.553477893999968, 9.308379438000031],
                    [-0.553497509999943, 9.308227862000024],
                    [-0.553614254999957, 9.30807365000004],
                    [-0.553711427999929, 9.308035182000026],
                    [-0.553747838999925, 9.307767858000034],
                    [-0.553673013999969, 9.307690586000035],
                    [-0.553634454999951, 9.307461759000034],
                    [-0.553673402999948, 9.307384627000033],
                    [-0.55374837599993, 9.307346131000031],
                    [-0.553806746999953, 9.307269026000029],
                    [-0.553942811999946, 9.307194774000038],
                    [-0.554270087999953, 9.307327489000045],
                    [-0.554422562999946, 9.307443447000026],
                    [-0.554577910999967, 9.30748223300003],
                    [-0.554827778999936, 9.307386069000074],
                    [-0.554827969999963, 9.307234468000047],
                    [-0.554789243999949, 9.307137946000068],
                    [-0.554598040999963, 9.306925465000063],
                    [-0.554559285999972, 9.306850994000058],
                    [-0.554559382999969, 9.306773817000021],
                    [-0.55463717899994, 9.30669673500006],
                    [-0.554695477999928, 9.306677512000022],
                    [-0.555022944999962, 9.306658627000047],
                    [-0.555100692999929, 9.306620133000024],
                    [-0.555136859999948, 9.306545757000038],
                    [-0.555100981999942, 9.306391353000038],
                    [-0.554906976999973, 9.306200921000027],
                    [-0.554829325999947, 9.306162234000055],
                    [-0.554754549999927, 9.306046372000026],
                    [-0.554754670999955, 9.305949899000041],
                    [-0.554829785999971, 9.305798391000053],
                    [-0.554830272999936, 9.305415254000025],
                    [-0.554927514999974, 9.305318902000067],
                    [-0.55498573999995, 9.30535756300003],
                    [-0.555118937999964, 9.305357730000026],
                    [-0.555274234999956, 9.305435102000047],
                    [-0.555371359999924, 9.305435223000075],
                    [-0.555410304999953, 9.305358093000052],
                    [-0.555429947999926, 9.305184465000025],
                    [-0.555563312999936, 9.30505232400003],
                    [-0.555949074999944, 9.305014216000075],
                    [-0.555949270999974, 9.304859857000054],
                    [-0.555891213999928, 9.304688890000023],
                    [-0.555891407999979, 9.304534531000058],
                    [-0.555988696999975, 9.304402345000028],
                    [-0.556008217999931, 9.304325192000022],
                    [-0.556008411999926, 9.304170833000057],
                    [-0.55598908199994, 9.304096387000072],
                    [-0.556008748999943, 9.30390346400003],
                    [-0.556067119999966, 9.303826357000048],
                    [-0.556180984999969, 9.30375207700007],
                    [-0.556414175999976, 9.303675188000057],
                    [-0.556547542999965, 9.303540290000058],
                    [-0.556856087999961, 9.303118946000041],
                    [-0.557011625999962, 9.30300612800005],
                    [-0.557167117999938, 9.30292914100005],
                    [-0.55733812099993, 9.302915028000029],
                    [-0.557397458999958, 9.302910132000022],
                    [-0.557494533999943, 9.302948841000045],
                    [-0.557569454999964, 9.302948934000028],
                    [-0.557627777999926, 9.302910417000021],
                    [-0.557783123999968, 9.302949200000057],
                    [-0.55795504799994, 9.303045887000053],
                    [-0.558090657999969, 9.303332718000036],
                    [-0.55820710699993, 9.303410042000053],
                    [-0.558301453999945, 9.303410158000077],
                    [-0.558379466999952, 9.303159423000068],
                    [-0.558340784999928, 9.303027069000052],
                    [-0.558340879999946, 9.302949891000026],
                    [-0.558379825999964, 9.302872759000024],
                    [-0.558515937999971, 9.302759915000024],
                    [-0.558746234999944, 9.302776739000024],
                    [-0.558901532999926, 9.302854109000066],
                    [-0.558995856999957, 9.302873522000027],
                    [-0.559054057999958, 9.302931479000051],
                    [-0.559209403999944, 9.302970258000073],
                    [-0.559303775999979, 9.302951080000071],
                    [-0.559537297999952, 9.302606820000051],
                    [-0.559537395999939, 9.302529642000025],
                    [-0.559459886999946, 9.302377943000067],
                    [-0.559498929999961, 9.302223634000029],
                    [-0.559596337999949, 9.301994973000035],
                    [-0.55955806399993, 9.301534609000043],
                    [-0.559671978999972, 9.30141898200003],
                    [-0.560057782999934, 9.301345034000065],
                    [-0.560232601999928, 9.301345249000065],
                    [-0.560271548999935, 9.301268119000042],
                    [-0.560346564999975, 9.301191032000077],
                    [-0.560424644999955, 9.300885168000036],
                    [-0.560463589999927, 9.300808037000024],
                    [-0.560424931999933, 9.300656389000039],
                    [-0.560366752999926, 9.300579137000057],
                    [-0.560233631999949, 9.300521089000028],
                    [-0.560000492999961, 9.300559392000025],
                    [-0.559925594999925, 9.300540004000027],
                    [-0.559867490999977, 9.300404869000033],
                    [-0.559925928999974, 9.300272636000045],
                    [-0.559965064999972, 9.300041147000059],
                    [-0.559887486999969, 9.299947334000024],
                    [-0.559809981999933, 9.299792880000041],
                    [-0.559849018999955, 9.299641327000074],
                    [-0.559926788999974, 9.299583538000036],
                    [-0.559993577999933, 9.299430640000026],
                    [-0.56006036499997, 9.299277743000061],
                    [-0.560118927999952, 9.299046279000038],
                    [-0.560119211999961, 9.298817497000073],
                    [-0.560080460999927, 9.298740271000042],
                    [-0.560080558999971, 9.298663093000073],
                    [-0.560294579999947, 9.298376691000044],
                    [-0.560314077999976, 9.298318831000074],
                    [-0.560197817999949, 9.298089907000076],
                    [-0.560042522999936, 9.298012536000044],
                    [-0.559928891999959, 9.297899384000061],
                    [-0.559948533999943, 9.297725756000034],
                    [-0.560004104999962, 9.297667941000043],
                    [-0.560004291999974, 9.297516339000026],
                    [-0.559968314999935, 9.297439116000021],
                    [-0.559871291999968, 9.297361817000024],
                    [-0.559715946999972, 9.297323036000023],
                    [-0.55956342199994, 9.297248426000067],
                    [-0.559427598999946, 9.297132490000024],
                    [-0.559408295999958, 9.29703599100003],
                    [-0.559466733999955, 9.296903757000052],
                    [-0.559544524999978, 9.296826675000034],
                    [-0.559622413999932, 9.296672412000021],
                    [-0.559583663999945, 9.296595186000047],
                    [-0.55937023599995, 9.296404731000052],
                    [-0.559276060999935, 9.296269551000023],
                    [-0.559081936999974, 9.296175594000033],
                    [-0.559004240999968, 9.296175498000025],
                    [-0.558929489999969, 9.296040343000072],
                    [-0.558929682999974, 9.29588598600003],
                    [-0.559101985999973, 9.295676712000045],
                    [-0.559179753999956, 9.295618923000063],
                    [-0.559257473999935, 9.295599725000045],
                    [-0.559410090999961, 9.295599914000036],
                    [-0.559565433999978, 9.295638694000047],
                    [-0.559950897999954, 9.295832117000032],
                    [-0.560103467999966, 9.295870894000075],
                    [-0.560200588999976, 9.295871014000056],
                    [-0.56027833099995, 9.295832521000023],
                    [-0.560430947999976, 9.295832708000034],
                    [-0.560719846999973, 9.295582231000026],
                    [-0.560875329999931, 9.29550800100003],
                    [-0.561086101999933, 9.295601976000057],
                    [-0.561163701999931, 9.295679251000024],
                    [-0.56127448999996, 9.295735110000066],
                    [-0.56139387099995, 9.295795302000045],
                    [-0.56145214299994, 9.295795374000022],
                    [-0.56211961799994, 9.296334581000053],
                    [-0.563488279999945, 9.296740900000032],
                    [-0.564189600999953, 9.296932839000021],
                    [-0.564800451999929, 9.297079704000055],
                    [-0.565632151999978, 9.297442626000077],
                    [-0.566157609999948, 9.297643361000041],
                    [-0.566787393999959, 9.297828401000061],
                    [-0.567006004999939, 9.297857951000026],
                    [-0.568295828999965, 9.297971915000062],
                    [-0.569302517999972, 9.298287853000033],
                    [-0.57018500099997, 9.298390078000068],
                    [-0.57098813999994, 9.298604605000037],
                    [-0.57211844699998, 9.298867389000065],
                    [-0.573361496999951, 9.302350662000038],
                    [-0.57465080399993, 9.303376509000032],
                    [-0.576077122999948, 9.304386564000026],
                    [-0.578230819999931, 9.305026799000075],
                    [-0.578445011999975, 9.305894187000035],
                    [-0.579001992999963, 9.308149711000056],
                    [-0.580092930999967, 9.31028073300007],
                    [-0.580606624999973, 9.311026747000028],
                    [-0.580678778999925, 9.311458058000028],
                    [-0.580884392999963, 9.311836371000027],
                    [-0.581150327999978, 9.312144019000073],
                    [-0.581194037999978, 9.312348942000028],
                    [-0.581311944999925, 9.312901742000065],
                    [-0.581189474999974, 9.313453806000041],
                    [-0.581203524999978, 9.313923888000033],
                    [-0.581243006999955, 9.314461081000047],
                    [-0.582080864999966, 9.31539443500003],
                    [-0.582267899999977, 9.315979858000048],
                    [-0.582432779999976, 9.31621741500004],
                    [-0.582743773999937, 9.316886028000056],
                    [-0.58357872299996, 9.317951873000027],
                    [-0.583963861999962, 9.318633838000039],
                    [-0.585012783999957, 9.320083281000052],
                    [-0.585655350999957, 9.320659059000036],
                    [-0.586190888999965, 9.321085629000038],
                    [-0.586522638999952, 9.321425298000065],
                    [-0.587476183999968, 9.322109393000062],
                    [-0.588633236999954, 9.322792246000063],
                    [-0.589254421999954, 9.323325398000065],
                    [-0.589746810999941, 9.323986183000045],
                    [-0.590732040999967, 9.324924401000033],
                    [-0.591008875999933, 9.326564617000031],
                    [-0.591150347999928, 9.327065268000069],
                    [-0.591364332999945, 9.327438217000065],
                    [-0.59179273999996, 9.327811413000063],
                    [-0.592194468999935, 9.328078091000066],
                    [-0.592370043999949, 9.328027444000043],
                    [-0.592453097999964, 9.328003486000057],
                    [-0.592640238999934, 9.327770772000065],
                    [-0.592837945999975, 9.327892474000066],
                    [-0.59306797399995, 9.327994334000039],
                    [-0.593117739999968, 9.328016374000072],
                    [-0.593320143999961, 9.328106001000037],
                    [-0.593476215999942, 9.327980395000054],
                    [-0.593586997999978, 9.327891239000053],
                    [-0.593832083999928, 9.327866971000049],
                    [-0.594097725999973, 9.327840670000057],
                    [-0.594446066999978, 9.32792093200004],
                    [-0.594681784999977, 9.32791959900004],
                    [-0.594724933999942, 9.327773945000047],
                    [-0.594768034999959, 9.327628460000028],
                    [-0.594982516999949, 9.327575460000048],
                    [-0.59527731299994, 9.327602418000026],
                    [-0.595339115999934, 9.32747824300003],
                    [-0.595386760999929, 9.327382518000036],
                    [-0.59549216399995, 9.327229957000043],
                    [-0.595679687999962, 9.327310036000029],
                    [-0.596078176999924, 9.327483531000041],
                    [-0.596490906999975, 9.327318668000032],
                    [-0.59668157699997, 9.327184719000059],
                    [-0.59679211699995, 9.327034114000071],
                    [-0.596950020999941, 9.326818974000048],
                    [-0.597037825999962, 9.326543897000022],
                    [-0.597082715999932, 9.326403260000063],
                    [-0.597115194999958, 9.32630150500006],
                    [-0.597151763999932, 9.326186936000056],
                    [-0.597280057999967, 9.325925901000062],
                    [-0.597280117999958, 9.32585152300004],
                    [-0.597338591999971, 9.325677969000026],
                    [-0.597452618999966, 9.325449109000033],
                    [-0.597761079999941, 9.325104865000071],
                    [-0.598072103999925, 9.324893169000063],
                    [-0.598186068999951, 9.324741549000066],
                    [-0.598244422999926, 9.324703406000026],
                    [-0.598283346999949, 9.324626165000041],
                    [-0.598283524999943, 9.324474546000033],
                    [-0.59832244699993, 9.324397306000037],
                    [-0.598342116999959, 9.324168444000065],
                    [-0.598439454999948, 9.324013964000073],
                    [-0.598592222999969, 9.323898580000048],
                    [-0.59866988999994, 9.323898581000037],
                    [-0.598747676999949, 9.323860438000054],
                    [-0.598977992999949, 9.323860438000054],
                    [-0.59905565899993, 9.32387951000004],
                    [-0.599208189999956, 9.323957703000076],
                    [-0.599363463999964, 9.324092160000021],
                    [-0.599441131999924, 9.324131256000044],
                    [-0.599748816999977, 9.324437357000022],
                    [-0.600037247999978, 9.324588977000076],
                    [-0.600267566999946, 9.324589930000059],
                    [-0.600520175999975, 9.324515551000047],
                    [-0.600595099999964, 9.324515551000047],
                    [-0.600653454999929, 9.324438312000041],
                    [-0.600808966999978, 9.324361072000045],
                    [-0.601039520999961, 9.32418847200006],
                    [-0.601195093999934, 9.324036852000063],
                    [-0.601231275999965, 9.323959611000021],
                    [-0.601367355999969, 9.323863299000038],
                    [-0.60156184799996, 9.323634440000035],
                    [-0.601714618999949, 9.323519056000066],
                    [-0.601945055999977, 9.323406533000025],
                    [-0.602022781999949, 9.323406533000025],
                    [-0.602100566999979, 9.323348364000026],
                    [-0.602330943999959, 9.32327207700007],
                    [-0.602564062999932, 9.323291149000056],
                    [-0.602638927999976, 9.323330247000058],
                    [-0.602794320999976, 9.323330246000069],
                    [-0.602910849999944, 9.323368390000041],
                    [-0.603565381999942, 9.323694517000035],
                    [-0.603795698999932, 9.323752686000034],
                    [-0.603951208999945, 9.323656374000052],
                    [-0.60402613499997, 9.323637301000076],
                    [-0.60422062799995, 9.323408442000073],
                    [-0.60424017899993, 9.323331202000077],
                    [-0.604337455999939, 9.323177673000032],
                    [-0.604567952999957, 9.323026054000024],
                    [-0.604626425999925, 9.322852502000046],
                    [-0.604607352999949, 9.322565473000054],
                    [-0.60452980499997, 9.322413853000057],
                    [-0.604510493999953, 9.322317541000075],
                    [-0.604529984999942, 9.322259372000076],
                    [-0.604452377999962, 9.322182131000034],
                    [-0.604433005999965, 9.322107751000033],
                    [-0.604452555999956, 9.322030511000037],
                    [-0.604413751999971, 9.321953270000051],
                    [-0.604413873999931, 9.321876030000055],
                    [-0.604452795999975, 9.321818816000075],
                    [-0.60446894699993, 9.321669103000033],
                    [-0.604492016999927, 9.321454545000051],
                    [-0.604530938999972, 9.32138016600004],
                    [-0.604531056999974, 9.321302925000055],
                    [-0.604589529999942, 9.321129373000076],
                    [-0.604674350999971, 9.320972033000032],
                    [-0.60473127299997, 9.320917677000068],
                    [-0.60474248099996, 9.320824225000024],
                    [-0.604839756999979, 9.320691679000049],
                    [-0.604995327999973, 9.320537198000068],
                    [-0.605148098999962, 9.320421814000042],
                    [-0.605436770999972, 9.320367459000067],
                    [-0.60584191099997, 9.320386532000043],
                    [-0.605919637999932, 9.32034838900006],
                    [-0.606130581999935, 9.32034838900006],
                    [-0.606458055999951, 9.320310246000076],
                    [-0.606671923999954, 9.320175790000064],
                    [-0.606785829999978, 9.320059452000066],
                    [-0.606883165999932, 9.319831546000046],
                    [-0.606922267999948, 9.31962175600006],
                    [-0.606961190999925, 9.319544516000065],
                    [-0.606922446999931, 9.319467275000022],
                    [-0.606922804999954, 9.319161174000044],
                    [-0.606942473999936, 9.318913243000054],
                    [-0.607000889999938, 9.318778787000042],
                    [-0.607001424999964, 9.318321066000067],
                    [-0.606923817999927, 9.318243826000071],
                    [-0.606885073999933, 9.318147514000032],
                    [-0.606752033999953, 9.318012105000037],
                    [-0.606732661999956, 9.317937725000036],
                    [-0.606635624999967, 9.31786048400005],
                    [-0.606480470999941, 9.317631624000057],
                    [-0.606441785999948, 9.317477143000076],
                    [-0.606461395999929, 9.317322662000038],
                    [-0.606519869999943, 9.317171042000041],
                    [-0.606578223999975, 9.317093802000045],
                    [-0.606656010999927, 9.317035633000046],
                    [-0.606733735999967, 9.317016561000059],
                    [-0.607119444999967, 9.317036589000054],
                    [-0.607271977999972, 9.31711382900005],
                    [-0.607502235999959, 9.317171998000049],
                    [-0.607657506999942, 9.317249238000045],
                    [-0.60773523499995, 9.317230166000058],
                    [-0.608043216999931, 9.317288335000057],
                    [-0.608195867999939, 9.317269262000025],
                    [-0.608351260999939, 9.317305499000042],
                    [-0.608581577999928, 9.317305499000042],
                    [-0.60881487499995, 9.317134808000048],
                    [-0.608853799999963, 9.317057567000063],
                    [-0.608854095999959, 9.316809636000073],
                    [-0.608834723999962, 9.316732395000031],
                    [-0.608854214999951, 9.316674226000032],
                    [-0.608776667999962, 9.316561703000048],
                    [-0.608757475999937, 9.31632998200007],
                    [-0.608777087999954, 9.316178361000027],
                    [-0.608866076999959, 9.315999087000023],
                    [-0.609046564999971, 9.315872261000038],
                    [-0.609104860999935, 9.315853189000052],
                    [-0.609257510999953, 9.315853189000052],
                    [-0.609354608999979, 9.315873214000021],
                    [-0.60943221499997, 9.315947595000068],
                    [-0.609565373999942, 9.316024834000075],
                    [-0.60982889099995, 9.316129729000068],
                    [-0.609931711999934, 9.315967619000048],
                    [-0.610087283999974, 9.315835073000073],
                    [-0.610204051999972, 9.315603352000039],
                    [-0.610204169999975, 9.315528971000049],
                    [-0.610279334999973, 9.315298203000054],
                    [-0.610357239999928, 9.315146583000057],
                    [-0.61035729799994, 9.315069343000062],
                    [-0.610454755999967, 9.314763243000073],
                    [-0.610474364999959, 9.314608762000034],
                    [-0.610513286999947, 9.314534381000044],
                    [-0.610513466999976, 9.314379901000052],
                    [-0.610571939999943, 9.314171065000039],
                    [-0.610475140999938, 9.313881177000042],
                    [-0.610475257999951, 9.313806797000041],
                    [-0.610378279999964, 9.31365231500007],
                    [-0.610245180999925, 9.313556003000031],
                    [-0.610167513999954, 9.313535978000061],
                    [-0.610012120999954, 9.313535978000061],
                    [-0.609934394999925, 9.313575075000074],
                    [-0.609704137999927, 9.313499741000044],
                    [-0.609645963999981, 9.313403429000061],
                    [-0.609626710999976, 9.313268021000056],
                    [-0.609665633999953, 9.313191733000053],
                    [-0.609646321999946, 9.313097329000072],
                    [-0.609665812999935, 9.31302008800003],
                    [-0.609821443999977, 9.312811254000053],
                    [-0.610032566999962, 9.312599558000045],
                    [-0.610129723999933, 9.312579533000076],
                    [-0.610207510999942, 9.312503245000073],
                    [-0.610263241999974, 9.312274384000034],
                    [-0.610246790999952, 9.312122766000073],
                    [-0.610033520999934, 9.311758495000049],
                    [-0.61005301199998, 9.31170032700004],
                    [-0.610014208999928, 9.311623085000065],
                    [-0.610033759999965, 9.311526773000026],
                    [-0.610150467999972, 9.311394225000072],
                    [-0.610380903999953, 9.311298866000072],
                    [-0.610555730999977, 9.311317938000059],
                    [-0.610785926999938, 9.311395180000034],
                    [-0.61092188899994, 9.311395179000044],
                    [-0.611074478999967, 9.311470513000074],
                    [-0.611557225999945, 9.31154775400006],
                    [-0.611595969999939, 9.311624994000056],
                    [-0.611670894999975, 9.311664090000022],
                    [-0.611748500999965, 9.311741332000054],
                    [-0.611825987999964, 9.311892952000051],
                    [-0.61190335699996, 9.31219905200004],
                    [-0.611961531999953, 9.312333508000052],
                    [-0.612152809999941, 9.312505153000075],
                    [-0.612249845999941, 9.312543298000037],
                    [-0.61232757199997, 9.312543299000026],
                    [-0.612402436999957, 9.31258239400006],
                    [-0.612480164999965, 9.31258239400006],
                    [-0.612690870999927, 9.312736875000041],
                    [-0.612807338999971, 9.312850351000066],
                    [-0.612904198999956, 9.313082073000032],
                    [-0.612981806999926, 9.313159313000028],
                    [-0.613075982999931, 9.313310933000025],
                    [-0.613173020999966, 9.313388174000067],
                    [-0.613403218999963, 9.313504512000065],
                    [-0.613616965999938, 9.313446343000066],
                    [-0.613847402999966, 9.313330959000041],
                    [-0.613964109999927, 9.313215575000072],
                    [-0.61400309499993, 9.313063956000065],
                    [-0.61386743099996, 9.312776927000073],
                    [-0.613789764999979, 9.31273783000006],
                    [-0.613715018999926, 9.312583348000032],
                    [-0.613715137999975, 9.312507062000066],
                    [-0.613751257999979, 9.312432682000065],
                    [-0.613829043999942, 9.312355441000022],
                    [-0.613906829999962, 9.312316344000067],
                    [-0.614137147999941, 9.312278201000026],
                    [-0.614370147999978, 9.312394539000024],
                    [-0.614639028999932, 9.312661543000047],
                    [-0.615063421999935, 9.312816978000058],
                    [-0.615987790999952, 9.312586211000053],
                    [-0.61610431899993, 9.312586211000053],
                    [-0.616179304999946, 9.312528997000072],
                    [-0.616334697999946, 9.312528997000072],
                    [-0.616798073999973, 9.312587166000071],
                    [-0.617028390999963, 9.312587167000061],
                    [-0.617106114999956, 9.312568095000074],
                    [-0.617250421999927, 9.312579538000023],
                    [-0.617414218999954, 9.312510878000069],
                    [-0.617491943999937, 9.312455571000044],
                    [-0.617800165999938, 9.312321116000021],
                    [-0.618030723999937, 9.312092255000039],
                    [-0.618205844999977, 9.311822392000067],
                    [-0.618358973999932, 9.311364670000046],
                    [-0.618495172999928, 9.31113390400003],
                    [-0.618589646999965, 9.311020427000074],
                    [-0.618745159999946, 9.310905043000048],
                    [-0.618822885999975, 9.310885970000072],
                    [-0.618919983999945, 9.310905042000059],
                    [-0.618975477999925, 9.310944139000071],
                    [-0.61907245499998, 9.311078594000037],
                    [-0.619169313999976, 9.311308408000059],
                    [-0.619227549999948, 9.311365625000064],
                    [-0.619302414999936, 9.311404721000031],
                    [-0.619457806999947, 9.311404723000066],
                    [-0.619843934999949, 9.311060477000069],
                    [-0.619921719999979, 9.310945094000033],
                    [-0.619960941999977, 9.310638992000065],
                    [-0.620035983999969, 9.310484512000073],
                    [-0.620113769999932, 9.310446368000044],
                    [-0.62019143699996, 9.310446369000033],
                    [-0.620269102999941, 9.310484512000073],
                    [-0.620363339999926, 9.310600849000025],
                    [-0.620518554999933, 9.310736258000077],
                    [-0.620671143999971, 9.310810639000067],
                    [-0.620826596999962, 9.310772496000027],
                    [-0.621037662999925, 9.310601803000054],
                    [-0.621115626999938, 9.310372943000061],
                    [-0.621271136999951, 9.310218463000069],
                    [-0.621423849999928, 9.310180320000029],
                    [-0.621731771999976, 9.310276632000068],
                    [-0.622042556999929, 9.310296657000038],
                    [-0.622350719999929, 9.310142177000046],
                    [-0.622659002999967, 9.309875173000023],
                    [-0.62281171199993, 9.309798886000067],
                    [-0.622850693999965, 9.309724506000066],
                    [-0.622850752999966, 9.309647268000049],
                    [-0.622889676999932, 9.309570026000074],
                    [-0.622870543999966, 9.309322094000038],
                    [-0.622660313999972, 9.308689866000066],
                    [-0.622660492999955, 9.308536339000057],
                    [-0.622621688999971, 9.30845910000005],
                    [-0.622738456999969, 9.30828840700002],
                    [-0.622813440999948, 9.308230238000021],
                    [-0.622891108999966, 9.308230238000021],
                    [-0.622968774999947, 9.308269335000034],
                    [-0.62304649999993, 9.308269336000023],
                    [-0.623276758999964, 9.308327504000033],
                    [-0.623354363999965, 9.308381858000075],
                    [-0.623432090999927, 9.308362787000021],
                    [-0.623584681999944, 9.308382814000026],
                    [-0.623740252999937, 9.30823119300004],
                    [-0.623759743999926, 9.308153952000055],
                    [-0.623815355999966, 9.308076712000059],
                    [-0.623893141999929, 9.308002332000058],
                    [-0.623970869999937, 9.307964189000074],
                    [-0.624107007999953, 9.307828780000023],
                    [-0.624181934999967, 9.307809708000036],
                    [-0.624337265999941, 9.307848805000049],
                    [-0.624547914999937, 9.308077666000031],
                    [-0.624586717999932, 9.308154907000073],
                    [-0.624664382999924, 9.308193049000067],
                    [-0.624819596999941, 9.308348485000067],
                    [-0.625030361999961, 9.308461008000052],
                    [-0.625110831999962, 9.308485801000074],
                    [-0.625227300999939, 9.308561135000048],
                    [-0.625843386999975, 9.308525852000059],
                    [-0.626076564999948, 9.308448612000063],
                    [-0.626151490999973, 9.308448612000063],
                    [-0.626287629999979, 9.308314157000041],
                    [-0.626384728999938, 9.308294130000036],
                    [-0.626498693999963, 9.308143465000057],
                    [-0.626576419999935, 9.308104367000055],
                    [-0.62663495299995, 9.307872648000057],
                    [-0.626576779999937, 9.307760124000026],
                    [-0.62657689699995, 9.307663811000054],
                    [-0.626538212999947, 9.307512192000047],
                    [-0.62659668799995, 9.307299541000077],
                    [-0.626732825999966, 9.307167947000039],
                    [-0.626885537999954, 9.307090706000054],
                    [-0.627040930999954, 9.30705256400006],
                    [-0.627426579999963, 9.307148876000042],
                    [-0.62773444499993, 9.307300497000028],
                    [-0.628042129999926, 9.307607551000046],
                    [-0.628119854999966, 9.307607551000046],
                    [-0.628194659999963, 9.307684792000032],
                    [-0.628272386999924, 9.307684791000042],
                    [-0.628349994999951, 9.307762032000028],
                    [-0.628427658999954, 9.307800175000068],
                    [-0.628657977999978, 9.30780112900004],
                    [-0.628735703999951, 9.307762032000028],
                    [-0.628966436999974, 9.307359619000067],
                    [-0.629121890999954, 9.307360573000039],
                    [-0.629254811999942, 9.307589433000032],
                    [-0.62937127999993, 9.307685746000061],
                    [-0.629468379999935, 9.307724843000074],
                    [-0.629546104999974, 9.307685745000072],
                    [-0.629621030999942, 9.307685745000072],
                    [-0.629679324999927, 9.307647602000031],
                    [-0.629854207999927, 9.307609460000037],
                    [-0.629987425999957, 9.307590388000051],
                    [-0.630084525999962, 9.307609461000027],
                    [-0.630392150999967, 9.307953705000045],
                    [-0.630622347999974, 9.308070042000054],
                    [-0.630661269999962, 9.308011873000055],
                    [-0.630816783999933, 9.307935586000042],
                    [-0.631008415999929, 9.307764894000059],
                    [-0.63124159399996, 9.307687656000041],
                    [-0.631316458999947, 9.307726752000065],
                    [-0.631394124999929, 9.307803992000061],
                    [-0.631413258999942, 9.308032852000053],
                    [-0.631471373999943, 9.308186379000063],
                    [-0.631529610999962, 9.308241688000066],
                    [-0.631837473999951, 9.308416194000074],
                    [-0.632086982999965, 9.308606911000027],
                    [-0.632145278999928, 9.308625982000024],
                    [-0.63230066999995, 9.30858783900004],
                    [-0.632395087999953, 9.308532533000061],
                    [-0.632472812999936, 9.308532531000026],
                    [-0.632608893999929, 9.308397124000066],
                    [-0.632761602999949, 9.308358979000047],
                    [-0.632858700999975, 9.308378052000023],
                    [-0.632936248999954, 9.308532533000061],
                    [-0.632916696999928, 9.308606911000027],
                    [-0.632994244999963, 9.308761392000065],
                    [-0.63308860099994, 9.308800489000021],
                    [-0.633224501999962, 9.308819562000053],
                    [-0.63337721299996, 9.308781418000024],
                    [-0.633532663999972, 9.308704178000028],
                    [-0.633743788999936, 9.308495343000061],
                    [-0.633821513999976, 9.308456247000038],
                    [-0.633899301999975, 9.308379959000035],
                    [-0.634129736999967, 9.30830271800005],
                    [-0.634207344999936, 9.308360887000049],
                    [-0.634357593999937, 9.308557432000043],
                    [-0.634514968999952, 9.308763301000056],
                    [-0.634620471999938, 9.308678431000033],
                    [-0.634670539999945, 9.308608820000075],
                    [-0.634728894999967, 9.30851536800003],
                    [-0.634823310999934, 9.308457200000021],
                    [-0.634920647999934, 9.308209270000077],
                    [-0.635017923999953, 9.308074812000029],
                    [-0.635095709999973, 9.308036669000046],
                    [-0.635290965999957, 9.307646508000062],
                    [-0.635479393999958, 9.307269987000041],
                    [-0.63547951399994, 9.307192747000045],
                    [-0.635518436999973, 9.307118368000033],
                    [-0.635518495999975, 9.307041127000048],
                    [-0.635596458999942, 9.306813220000038],
                    [-0.635596518999932, 9.306735979000052],
                    [-0.635655052999937, 9.306504259000064],
                    [-0.635655170999939, 9.306352639000067],
                    [-0.635713525999961, 9.306275398000025],
                    [-0.635713883999927, 9.305969298000036],
                    [-0.635752865999962, 9.305814818000044],
                    [-0.635753163999937, 9.305509670000049],
                    [-0.635792205999962, 9.305358050000052],
                    [-0.635792384999945, 9.305203568000024],
                    [-0.635856223999951, 9.305139677000057],
                    [-0.635931505999963, 9.30483453100004],
                    [-0.635984256999961, 9.304782084000067],
                    [-0.636019364999925, 9.304515080000044],
                    [-0.635506516999953, 9.304325316000075],
                    [-0.635012562999975, 9.303413689000024],
                    [-0.634138742999937, 9.302539251000042],
                    [-0.63387278099998, 9.302140652000048],
                    [-0.633349081999938, 9.301690071000053],
                    [-0.633055941999942, 9.301437858000043],
                    [-0.633008828999948, 9.30121000500003],
                    [-0.632941974999937, 9.300886686000069],
                    [-0.633321903999956, 9.300051346000032],
                    [-0.633796783999969, 9.299424840000029],
                    [-0.634252709999942, 9.299196933000076],
                    [-0.63463263899996, 9.299044360000039],
                    [-0.634716562999927, 9.298582826000029],
                    [-0.634233697999946, 9.298341567000023],
                    [-0.633872782999958, 9.298228090000066],
                    [-0.633910810999964, 9.297657847000039],
                    [-0.634138745999962, 9.297182962000022],
                    [-0.634427334999941, 9.297033267000074],
                    [-0.634651654999971, 9.296916912000029],
                    [-0.634879587999933, 9.296651816000065],
                    [-0.635145547999969, 9.296803435000072],
                    [-0.635639441999956, 9.296935984000072],
                    [-0.635961909999935, 9.29689593300003],
                    [-0.636153423999929, 9.29682441500006],
                    [-0.636370031999945, 9.296681376000038],
                    [-0.636542870999961, 9.296467177000068],
                    [-0.636944813999946, 9.295969050000053],
                    [-0.637050493999936, 9.295888948000027],
                    [-0.637195972999962, 9.295847391000052],
                    [-0.638732929999946, 9.29540834200003],
                    [-0.638885578999975, 9.295214764000036],
                    [-0.638960564999934, 9.295137526000076],
                    [-0.638999486999978, 9.295063144000039],
                    [-0.638999726999941, 9.294831423000062],
                    [-0.638769765999939, 9.294486225000071],
                    [-0.638722797999947, 9.294441408000068],
                    [-0.63858236699997, 9.293967475000045],
                    [-0.638533489999929, 9.293892143000051],
                    [-0.63843978999995, 9.293671864000032],
                    [-0.638379110999949, 9.293566016000057],
                    [-0.638155409999968, 9.293319036000071],
                    [-0.638020700999959, 9.293080640000028],
                    [-0.63796788999997, 9.292895645000044],
                    [-0.638042872999961, 9.29281745000003],
                    [-0.638157495999963, 9.292725906000044],
                    [-0.638324153999974, 9.292672507000077],
                    [-0.638651926999955, 9.292666786000041],
                    [-0.638757428999952, 9.292662017000055],
                    [-0.638877058999924, 9.292698254000072],
                    [-0.638985957999978, 9.292539004000048],
                    [-0.639157623999949, 9.292419806000055],
                    [-0.639180035999971, 9.292204296000023],
                    [-0.639116436999927, 9.291945875000067],
                    [-0.639013495999961, 9.29167505700002],
                    [-0.638987884999949, 9.291603007000049],
                    [-0.638645370999939, 9.290639463000048],
                    [-0.638621040999965, 9.290502695000043],
                    [-0.638113571999952, 9.287649973000043],
                    [-0.638158155999974, 9.287482142000044],
                    [-0.638202861999957, 9.287181762000046],
                    [-0.638203157999953, 9.286928108000041],
                    [-0.63807315899993, 9.286500903000046],
                    [-0.637945721999927, 9.286288252000077],
                    [-0.637560487999963, 9.285861047000026],
                    [-0.637130610999975, 9.285647443000073],
                    [-0.636916925999969, 9.285647442000027],
                    [-0.636703416999978, 9.285520615000053],
                    [-0.636448064999968, 9.285561620000067],
                    [-0.636145564999936, 9.285646489000044],
                    [-0.635890330999928, 9.285561619000021],
                    [-0.635590872999956, 9.28534896900004],
                    [-0.635460633999969, 9.285222143000055],
                    [-0.635419444999968, 9.284752978000029],
                    [-0.635378437999975, 9.28419894600006],
                    [-0.635289803999967, 9.284028254000077],
                    [-0.635120641999947, 9.283901428000036],
                    [-0.634907013999964, 9.283900473000074],
                    [-0.634690346999946, 9.284113122000065],
                    [-0.63447653999998, 9.284283815000038],
                    [-0.634390468999925, 9.284324818000073],
                    [-0.634262852999939, 9.284282861000065],
                    [-0.63417696199997, 9.284156034000034],
                    [-0.634091068999965, 9.284026345000029],
                    [-0.633750004999968, 9.283814649000021],
                    [-0.633578161999935, 9.283643005000044],
                    [-0.633536913999933, 9.283259663000024],
                    [-0.633451200999957, 9.282962144000066],
                    [-0.633234951999953, 9.282832456000051],
                    [-0.633065729999942, 9.282790499000043],
                    [-0.63276609199994, 9.282704675000048],
                    [-0.632635793999953, 9.282619806000071],
                    [-0.632422106999968, 9.282618852000041],
                    [-0.632250202999955, 9.282492026000057],
                    [-0.632122645999971, 9.282451022000032],
                    [-0.631736996999962, 9.28240620300005],
                    [-0.631479080999952, 9.282279377000066],
                    [-0.631396110999958, 9.28202286100003],
                    [-0.631524144999958, 9.281639521000045],
                    [-0.631696347999934, 9.281468828000072],
                    [-0.631824140999925, 9.281342002000031],
                    [-0.631910331999961, 9.281130306000023],
                    [-0.631952233999925, 9.280873791000033],
                    [-0.632038841999929, 9.280319760000054],
                    [-0.632039258999953, 9.279937371000074],
                    [-0.632211520999931, 9.279680856000027],
                    [-0.632425386999955, 9.279469161000065],
                    [-0.632811155999946, 9.27942815800003],
                    [-0.633238589999962, 9.279298470000072],
                    [-0.633710429999951, 9.279172596000024],
                    [-0.634054595999942, 9.279086776000042],
                    [-0.634396077999952, 9.278917037000042],
                    [-0.634612685999969, 9.278704387000062],
                    [-0.634995830999969, 9.278533695000021],
                    [-0.635426007999968, 9.278448827000034],
                    [-0.635767250999947, 9.278449781000063],
                    [-0.636025522999944, 9.278281949000075],
                    [-0.636369806999937, 9.278025435000075],
                    [-0.636625515999924, 9.277643048000073],
                    [-0.636711706999961, 9.277430399000025],
                    [-0.636756590999937, 9.276962187000038],
                    [-0.636670877999961, 9.276661810000064],
                    [-0.636499153999978, 9.276408157000049],
                    [-0.636113740999974, 9.276109683000072],
                    [-0.635941836999962, 9.275979994000068],
                    [-0.636028088999979, 9.275767346000066],
                    [-0.636190307999925, 9.275688253000055],
                    [-0.638496420999957, 9.277999693000027],
                    [-0.639849833999961, 9.279395610000051],
                    [-0.640061725999942, 9.279576822000024],
                    [-0.643038133999937, 9.282699673000025],
                    [-0.650374304999957, 9.290256529000033],
                    [-0.651002561999974, 9.290787201000057],
                    [-0.652128317999939, 9.292022367000072],
                    [-0.652692249999973, 9.29228211700007],
                    [-0.654548445999978, 9.292687342000022],
                    [-0.655537131999949, 9.292871516000048],
                    [-0.65957719499994, 9.293407190000039],
                    [-0.66262644699998, 9.294027217000064],
                    [-0.664772052999979, 9.294646373000035],
                    [-0.666756279999959, 9.29541209100006],
                    [-0.667666761999953, 9.295763442000066],
                    [-0.672451442999943, 9.298524979000035],
                    [-0.671460877999948, 9.294462724000027],
                    [-0.669573743999933, 9.290774507000037],
                    [-0.669410222999943, 9.290454917000034],
                    [-0.664780850999932, 9.285389353000028],
                    [-0.665147038999976, 9.28479616900006],
                    [-0.666868719999968, 9.282095005000031],
                    [-0.66726846399996, 9.281521133000069],
                    [-0.668083864999971, 9.280485015000068],
                    [-0.668643780999957, 9.279773207000062],
                    [-0.669648897999934, 9.27851834300003],
                    [-0.670572017999973, 9.277328389000047],
                    [-0.670764795999958, 9.277056797000057],
                    [-0.670916539999951, 9.276843013000075],
                    [-0.671092732999966, 9.276953910000032],
                    [-0.671062873999972, 9.277156522000041],
                    [-0.671064810999951, 9.277233281000065],
                    [-0.671177684999975, 9.277329790000067],
                    [-0.67128891599998, 9.277366735000044],
                    [-0.671496570999977, 9.27740745400007],
                    [-0.671652197999947, 9.277562339000042],
                    [-0.671741279999935, 9.277485049000063],
                    [-0.671849029999976, 9.277275142000065],
                    [-0.671930651999958, 9.277245741000058],
                    [-0.67208659299996, 9.277061667000055],
                    [-0.672172212999953, 9.276719104000051],
                    [-0.672380152999949, 9.276454024000031],
                    [-0.672465498999941, 9.276406204000068],
                    [-0.672558209999977, 9.276417342000059],
                    [-0.672576681999942, 9.276494731000071],
                    [-0.672545254999932, 9.276568429000065],
                    [-0.672546878999924, 9.276638392000052],
                    [-0.672494793999931, 9.276811507000048],
                    [-0.672505832999946, 9.276907309000023],
                    [-0.672561408999968, 9.276966310000034],
                    [-0.672683775999928, 9.276992213000028],
                    [-0.672713429999931, 9.277010661000077],
                    [-0.672835929999962, 9.276892874000055],
                    [-0.672876857999938, 9.276749224000071],
                    [-0.67287700199995, 9.276594484000043],
                    [-0.673018034999927, 9.276487766000059],
                    [-0.67316638799997, 9.276487900000063],
                    [-0.673239527999954, 9.276529909000033],
                    [-0.673318447999975, 9.276488039000071],
                    [-0.673370360999968, 9.276499139000066],
                    [-0.673392773999979, 9.276325997000072],
                    [-0.673474469999974, 9.276215542000045],
                    [-0.673656133999941, 9.276289394000059],
                    [-0.673737033999942, 9.276367900000025],
                    [-0.673811789999945, 9.276411118000055],
                    [-0.673897096999951, 9.276407513000038],
                    [-0.67393797699998, 9.276315442000055],
                    [-0.674086428999942, 9.276208732000043],
                    [-0.674168042999952, 9.27618669900005],
                    [-0.674553740999954, 9.276205473000061],
                    [-0.67464887899996, 9.27625689100006],
                    [-0.674683483999956, 9.276275591000058],
                    [-0.674894650999931, 9.276530002000072],
                    [-0.675016994999964, 9.276581694000072],
                    [-0.675284008999938, 9.276604043000077],
                    [-0.675341117999949, 9.276642741000046],
                    [-0.675499043999935, 9.27668529400006],
                    [-0.675562010999954, 9.276637416000028],
                    [-0.675591899999972, 9.276538004000031],
                    [-0.675606941999945, 9.276313274000074],
                    [-0.675666294999928, 9.276298591000057],
                    [-0.675736727999947, 9.276335498000037],
                    [-0.67580350399993, 9.276317136000046],
                    [-0.675925838999945, 9.276376197000047],
                    [-0.67609131599994, 9.276423858000044],
                    [-0.676203919999978, 9.276464872000076],
                    [-0.676181825999947, 9.276291688000072],
                    [-0.676092986999947, 9.276103706000072],
                    [-0.676084790999937, 9.276028256000075],
                    [-0.676133917999948, 9.275956370000074],
                    [-0.676445499999943, 9.275908756000035],
                    [-0.676407329999961, 9.275849866000044],
                    [-0.676519771999949, 9.275805663000028],
                    [-0.676594021999961, 9.275724675000049],
                    [-0.676594173999945, 9.275558879000073],
                    [-0.676631448999956, 9.275352593000036],
                    [-0.676676038999972, 9.275260524000032],
                    [-0.676831909999976, 9.275150135000047],
                    [-0.677058176999935, 9.275117179000063],
                    [-0.677158259999942, 9.275176220000048],
                    [-0.677210102999936, 9.275264689000039],
                    [-0.677195049999966, 9.275500475000058],
                    [-0.67724683199998, 9.275655262000043],
                    [-0.677495446999956, 9.275519165000048],
                    [-0.677732892999927, 9.275427272000059],
                    [-0.677825584999937, 9.275456829000063],
                    [-0.677851500999964, 9.275508434000074],
                    [-0.677907041999958, 9.275607960000059],
                    [-0.677802991999954, 9.275832610000066],
                    [-0.677713905999951, 9.275913585000069],
                    [-0.677669278999929, 9.276046181000027],
                    [-0.677709980999964, 9.27614937900006],
                    [-0.677862041999958, 9.276149515000043],
                    [-0.678028996999956, 9.276087033000067],
                    [-0.678259059999959, 9.275958287000037],
                    [-0.678399988999956, 9.275962099000026],
                    [-0.678540964999968, 9.275918013000023],
                    [-0.678793161999977, 9.275918240000067],
                    [-0.678863558999979, 9.275995674000058],
                    [-0.678941418999955, 9.276021534000051],
                    [-0.678944912999953, 9.276257334000036],
                    [-0.679011565999929, 9.276375294000047],
                    [-0.679169148999961, 9.276348185000074],
                    [-0.679327024999964, 9.276143464000029],
                    [-0.679408610999928, 9.276150905000065],
                    [-0.679403667999964, 9.276299147000032],
                    [-0.679438076999929, 9.276375676000043],
                    [-0.679508474999977, 9.276453110000034],
                    [-0.679667949999953, 9.276456937000034],
                    [-0.679816271999925, 9.276490227000068],
                    [-0.680142484999976, 9.276667367000073],
                    [-0.680283404999955, 9.27668591500003],
                    [-0.680376147999937, 9.276660207000077],
                    [-0.680611522999925, 9.276529843000048],
                    [-0.680669255999931, 9.276535202000048],
                    [-0.680758300999969, 9.276498438000033],
                    [-0.680758374999925, 9.276417383000023],
                    [-0.680836398999929, 9.276262711000072],
                    [-0.680984879999926, 9.276119153000025],
                    [-0.681062738999969, 9.276148699000032],
                    [-0.681081228999972, 9.276207664000026],
                    [-0.681253216999949, 9.276329589000056],
                    [-0.681392604999928, 9.276388473000054],
                    [-0.681615033999947, 9.276499201000036],
                    [-0.681723130999956, 9.276491531000033],
                    [-0.681793163999941, 9.276381462000074],
                    [-0.681866599999978, 9.276381663000052],
                    [-0.681967598999961, 9.27624529600007],
                    [-0.682097444999954, 9.276204884000038],
                    [-0.682256901999949, 9.276227132000031],
                    [-0.682312583999931, 9.276171915000077],
                    [-0.682602385999928, 9.276075835000029],
                    [-0.682664962999979, 9.276124331000062],
                    [-0.682739010999967, 9.276268087000062],
                    [-0.682831660999966, 9.276345540000023],
                    [-0.682905853999955, 9.276327183000035],
                    [-0.682950335999976, 9.276353012000072],
                    [-0.682998619999978, 9.27627568500003],
                    [-0.68306542199997, 9.276227849000065],
                    [-0.68312495999993, 9.276006841000026],
                    [-0.683199265999974, 9.275863217000051],
                    [-0.683362541999941, 9.27576388500006],
                    [-0.683505912999976, 9.27573983000002],
                    [-0.683559137999964, 9.275730900000042],
                    [-0.684041299999933, 9.275709221000056],
                    [-0.684219277999944, 9.275760959000024],
                    [-0.68436008499998, 9.275901087000022],
                    [-0.68458977399996, 9.276188667000042],
                    [-0.684697249999942, 9.276277187000062],
                    [-0.684845398999926, 9.276505746000055],
                    [-0.685171514999979, 9.276797094000074],
                    [-0.685323422999943, 9.276864047000061],
                    [-0.685397662999947, 9.276896769000075],
                    [-0.685486627999978, 9.276948428000026],
                    [-0.685534738999934, 9.277066369000067],
                    [-0.685608972999944, 9.277000116000067],
                    [-0.685827695999933, 9.277110838000056],
                    [-0.685972199999981, 9.277265707000026],
                    [-0.68614643799998, 9.277354284000069],
                    [-0.68629096799998, 9.277479678000077],
                    [-0.686357677999979, 9.277535003000025],
                    [-0.686450326999932, 9.277574192000031],
                    [-0.686535664999951, 9.277575686000034],
                    [-0.686687660999951, 9.277649505000056],
                    [-0.68675073299994, 9.277627453000036],
                    [-0.68683230299996, 9.277653316000055],
                    [-0.686906513999929, 9.277612852000061],
                    [-0.687025225999946, 9.277579799000023],
                    [-0.687299681999946, 9.277576353000029],
                    [-0.687529464999955, 9.277760771000032],
                    [-0.687614725999936, 9.277808742000047],
                    [-0.687685200999965, 9.277801434000025],
                    [-0.687816803999965, 9.277697277000073],
                    [-0.687889354999925, 9.277610028000026],
                    [-0.687956116999942, 9.27760640200006],
                    [-0.688052600999924, 9.277543851000075],
                    [-0.688108238999973, 9.277536532000056],
                    [-0.688200926999968, 9.277573457000074],
                    [-0.688293628999929, 9.277595642000051],
                    [-0.688497585999926, 9.277628978000052],
                    [-0.688656988999981, 9.277713856000048],
                    [-0.688797902999966, 9.277739770000039],
                    [-0.688872034999974, 9.277787730000057],
                    [-0.688934623999955, 9.277829508000025],
                    [-0.688982218999968, 9.277846244000045],
                    [-0.68911673599996, 9.277880054000036],
                    [-0.689350422999951, 9.277847095000027],
                    [-0.689383870999961, 9.277766069000052],
                    [-0.689294969999935, 9.277640725000026],
                    [-0.689176329999952, 9.277592726000023],
                    [-0.689157833999957, 9.277537444000075],
                    [-0.689235793999956, 9.27745277300005],
                    [-0.689265535999937, 9.27737174400005],
                    [-0.689273145999948, 9.277154374000077],
                    [-0.689225010999962, 9.277062224000076],
                    [-0.689146866999977, 9.276978108000037],
                    [-0.689073102999942, 9.276888928000062],
                    [-0.688750562999928, 9.27674496000003],
                    [-0.688680205999958, 9.276619632000063],
                    [-0.688650673999973, 9.276464863000058],
                    [-0.688736046999963, 9.276383882000061],
                    [-0.688880698999981, 9.276372955000056],
                    [-0.68904899599994, 9.276447214000029],
                    [-0.689107989999968, 9.276472392000073],
                    [-0.689195794999932, 9.276546393000046],
                    [-0.689338636999935, 9.276615358000072],
                    [-0.689424072999941, 9.276697187000025],
                    [-0.689573899999971, 9.276767781000046],
                    [-0.689718393999954, 9.276937385000053],
                    [-0.689681013999973, 9.277268943000024],
                    [-0.689699496999935, 9.277338962000044],
                    [-0.689769885999965, 9.277427446000047],
                    [-0.689847748999966, 9.277457006000077],
                    [-0.689914518999956, 9.277442309000037],
                    [-0.68999609499997, 9.277460800000028],
                    [-0.690459761999932, 9.277387517000022],
                    [-0.690530265999939, 9.27734705000006],
                    [-0.690674912999953, 9.277343490000021],
                    [-0.690778722999937, 9.277384107000046],
                    [-0.69105004499994, 9.277384342000062],
                    [-0.691160731999958, 9.277384437000023],
                    [-0.691235043999939, 9.277424233000033],
                    [-0.691297940999959, 9.277402978000055],
                    [-0.691672431999962, 9.277517515000056],
                    [-0.691757694999978, 9.277565484000036],
                    [-0.691779933999953, 9.277580240000077],
                    [-0.691857820999928, 9.277576623000073],
                    [-0.691969119999953, 9.277539875000059],
                    [-0.692080417999932, 9.277499444000057],
                    [-0.692154594999977, 9.277499508000062],
                    [-0.692225080999947, 9.277477462000036],
                    [-0.692358705999936, 9.27735599500005],
                    [-0.692551637999941, 9.277271420000034],
                    [-0.692685186999938, 9.277234691000046],
                    [-0.692777907999925, 9.277234771000053],
                    [-0.692852117999962, 9.277194307000059],
                    [-0.692922554999939, 9.277231212000061],
                    [-0.693159885999933, 9.277268259000039],
                    [-0.693228671999975, 9.277335442000037],
                    [-0.693332924999936, 9.277404612000055],
                    [-0.693402387999924, 9.277491023000039],
                    [-0.693819219999966, 9.277963435000061],
                    [-0.69385972799995, 9.278032551000024],
                    [-0.693830700999968, 9.27809009300006],
                    [-0.69390642999997, 9.278154991000065],
                    [-0.694031759999973, 9.278250522000064],
                    [-0.694184289999953, 9.278324901000076],
                    [-0.69457, 9.278344928000024],
                    [-0.694725331999962, 9.278383070000075],
                    [-0.694819569999936, 9.278537553000035],
                    [-0.694858193999949, 9.278766412000039],
                    [-0.694935740999938, 9.278920892000031],
                    [-0.695091073999947, 9.278995272000031],
                    [-0.695166057999927, 9.278940918000046],
                    [-0.695321450999927, 9.278901821000034],
                    [-0.695551766999927, 9.278921847000049],
                    [-0.69574608299996, 9.278805509000051],
                    [-0.695785005999937, 9.278709197000069],
                    [-0.69582392999996, 9.278634818000057],
                    [-0.695937775999937, 9.278558531000044],
                    [-0.696015501999966, 9.278538507000064],
                    [-0.696170835999965, 9.278596676000063],
                    [-0.696323306999943, 9.278729223000028],
                    [-0.696400972999925, 9.27876832100003],
                    [-0.696478640999942, 9.27876832000004],
                    [-0.696534251999935, 9.278691080000044],
                    [-0.696670272999938, 9.278597629000046],
                    [-0.696734170999946, 9.278487013000074],
                    [-0.696939630999964, 9.278384980000055],
                    [-0.697056101999976, 9.278424076000022],
                    [-0.69711433699996, 9.278482245000021],
                    [-0.697247257999948, 9.278788346000056],
                    [-0.697286002999931, 9.278941873000065],
                    [-0.69728588299995, 9.279036280000071],
                    [-0.697330228999931, 9.279080143000044],
                    [-0.697479658999953, 9.279574100000048],
                    [-0.697479481999949, 9.279763865000064],
                    [-0.697695610999972, 9.280122412000026],
                    [-0.697903636999968, 9.280224447000023],
                    [-0.698114523999948, 9.280224446000034],
                    [-0.698267173999966, 9.28018630300005],
                    [-0.698422566999966, 9.28018630300005],
                    [-0.698519663999946, 9.280225400000063],
                    [-0.698633210999958, 9.280492405000075],
                    [-0.698633032999965, 9.280646885000067],
                    [-0.698557870999934, 9.280952987000035],
                    [-0.698557809999954, 9.281030225000052],
                    [-0.698518888999956, 9.281104606000042],
                    [-0.698441160999948, 9.281181847000028],
                    [-0.698441102999936, 9.281259087000024],
                    [-0.698749084999974, 9.281259087000024],
                    [-0.698979463999933, 9.281181846000038],
                    [-0.699173537999968, 9.281375424000032],
                    [-0.699251084999958, 9.281527045000075],
                    [-0.699192611999933, 9.281755904000022],
                    [-0.699075963999974, 9.281890360000034],
                    [-0.69903704099994, 9.28196760000003],
                    [-0.69901749099995, 9.282119220000027],
                    [-0.69909503699995, 9.282273701000065],
                    [-0.699250311999947, 9.28240911100005],
                    [-0.699325235999936, 9.282428182000046],
                    [-0.699441644999979, 9.282579804000022],
                    [-0.699519193999947, 9.282734284000071],
                    [-0.699519131999978, 9.282827734000023],
                    [-0.699557935999962, 9.282904975000065],
                    [-0.699710406999941, 9.283040385000049],
                    [-0.699710288999938, 9.283192004000057],
                    [-0.699615753999979, 9.283404654000037],
                    [-0.699671125999942, 9.283556275000024],
                    [-0.699768283999958, 9.283536248000075],
                    [-0.699981970999943, 9.283462823000036],
                    [-0.700115251999932, 9.283366511000054],
                    [-0.700212348999969, 9.283366511000054],
                    [-0.700637219999976, 9.283022267000035],
                    [-0.70077043799995, 9.283003195000049],
                    [-0.700867536999965, 9.283022267000035],
                    [-0.701097733999973, 9.283135743000059],
                    [-0.701330792999954, 9.283135745000038],
                    [-0.701541798999926, 9.283042293000051],
                    [-0.701716561999945, 9.28310046200005],
                    [-0.70179148699998, 9.28310046200005],
                    [-0.702024426999969, 9.283212986000024],
                    [-0.702099351999948, 9.283212986000024],
                    [-0.702177018999976, 9.283252082000047],
                    [-0.702332290999948, 9.283406564000074],
                    [-0.702465449999977, 9.283425634000025],
                    [-0.702678957999979, 9.283597280000038],
                    [-0.70279256799995, 9.283826142000066],
                    [-0.702792268999929, 9.284134149000067],
                    [-0.702811700999973, 9.284189457000025],
                    [-0.702869876999955, 9.284286722000047],
                    [-0.703102755999964, 9.284498420000034],
                    [-0.703255347999971, 9.284572798000056],
                    [-0.703410739999924, 9.28455372600007],
                    [-0.703640937999978, 9.28465099400006],
                    [-0.703796329999932, 9.284670066000047],
                    [-0.703871253999978, 9.284631922000074],
                    [-0.703949100999978, 9.284480301000031],
                    [-0.703832748999957, 9.284286723000037],
                    [-0.70381337699996, 9.284209483000041],
                    [-0.703832867999949, 9.284135104000029],
                    [-0.70389116399997, 9.28407788800007],
                    [-0.704124280999963, 9.284038792000047],
                    [-0.704276812999979, 9.284116986000072],
                    [-0.704335048999951, 9.284171340000057],
                    [-0.70433492799998, 9.284325820000049],
                    [-0.704412595999941, 9.284364919000041],
                    [-0.704490262999968, 9.284364919000041],
                    [-0.704565186999957, 9.284403061000035],
                    [-0.704642792999948, 9.284480301000031],
                    [-0.704490023999938, 9.284690092000062],
                    [-0.70452602599994, 9.284786404000045],
                    [-0.704759083999932, 9.284806428000024],
                    [-0.704911614999958, 9.284880807000036],
                    [-0.705066947999967, 9.284996191000062],
                    [-0.705297027999961, 9.285245078000059],
                    [-0.705530025999963, 9.285360462000028],
                    [-0.705604949999952, 9.285360462000028],
                    [-0.705837891999977, 9.285476800000026],
                    [-0.705990422999946, 9.285628419000034],
                    [-0.706126322999978, 9.285705660000076],
                    [-0.70656353399994, 9.28582678500004],
                    [-0.70668393699998, 9.285860142000047],
                    [-0.706761661999963, 9.285821998000074],
                    [-0.706839327999944, 9.285821997000028],
                    [-0.706916994999972, 9.28586109400004],
                    [-0.706972547999953, 9.28584107000006],
                    [-0.707274868999946, 9.286001272000021],
                    [-0.707396822999954, 9.286167197000054],
                    [-0.707610150999926, 9.286550537000039],
                    [-0.707685015999971, 9.286624916000051],
                    [-0.707723758999975, 9.286702157000036],
                    [-0.707801485999937, 9.286702157000036],
                    [-0.707840288999932, 9.286779397000032],
                    [-0.708070367999937, 9.28700826000005],
                    [-0.708148093999966, 9.28700826000005],
                    [-0.708455958999934, 9.287162740000042],
                    [-0.708763881999971, 9.287260006000054],
                    [-0.708997, 9.287240934000067],
                    [-0.709149710999952, 9.287086453000029],
                    [-0.709227436999925, 9.287048311000035],
                    [-0.709305221999955, 9.28697107000005],
                    [-0.709360834999927, 9.286819450000053],
                    [-0.709458052999935, 9.286684041000058],
                    [-0.709516406999967, 9.286606800000072],
                    [-0.709691171999964, 9.286664969000071],
                    [-0.709766154999954, 9.286607755000034],
                    [-0.709921546999965, 9.286571519000063],
                    [-0.710384922999935, 9.286571518000073],
                    [-0.710615359999963, 9.286437063000051],
                    [-0.710845736999943, 9.286340750000022],
                    [-0.710923462999972, 9.286359822000065],
                    [-0.711001189999934, 9.286321679000025],
                    [-0.71115378099995, 9.286321679000025],
                    [-0.711386778999952, 9.286457089000066],
                    [-0.711461584999938, 9.286553400000059],
                    [-0.711539132999974, 9.286763189000055],
                    [-0.711597366999968, 9.286782262000031],
                    [-0.711694404999946, 9.286917671000026],
                    [-0.711846935999972, 9.287011122000024],
                    [-0.711924601999954, 9.28701112300007],
                    [-0.712154861999977, 9.287127459000033],
                    [-0.712232466999978, 9.287204700000075],
                    [-0.712387799999931, 9.287262870000063],
                    [-0.712465466999959, 9.287318178000021],
                    [-0.712618056999929, 9.287356322000051],
                    [-0.712926041999935, 9.287357274000044],
                    [-0.713159218999976, 9.287280035000038],
                    [-0.713389535999966, 9.287280035000038],
                    [-0.713542127999972, 9.287319131000061],
                    [-0.713697461999971, 9.287396371000057],
                    [-0.713852732999953, 9.287511755000025],
                    [-0.714005325999949, 9.287511755000025],
                    [-0.71416071799996, 9.287569925000071],
                    [-0.714313369999957, 9.287531781000041],
                    [-0.71446870099993, 9.287550853000027],
                    [-0.714621291999947, 9.28758995000004],
                    [-0.714776624999956, 9.28766433100003],
                    [-0.714854351999975, 9.287664330000041],
                    [-0.715006883999934, 9.287741570000037],
                    [-0.715084547999936, 9.287741570000037],
                    [-0.71524, 9.287664330000041],
                    [-0.715314925999962, 9.287664330000041],
                    [-0.715392590999954, 9.287703427000054],
                    [-0.715470317999973, 9.287703428000043],
                    [-0.715778240999953, 9.287799739000036],
                    [-0.715933633999953, 9.287800695000044],
                    [-0.71608628599995, 9.287761596000053],
                    [-0.716163951999931, 9.287781623000058],
                    [-0.716394388999959, 9.28766528400007],
                    [-0.71647205499994, 9.28766528400007],
                    [-0.716627507999931, 9.287610930000028],
                    [-0.716780036999978, 9.287666240000021],
                    [-0.716857703999949, 9.287743480000074],
                    [-0.717087901999946, 9.287858863000054],
                    [-0.717204372999959, 9.287972339000021],
                    [-0.717781295999941, 9.288243159000046],
                    [-0.71824473199996, 9.288243158000057],
                    [-0.718474929999957, 9.28835663600006],
                    [-0.718708049999975, 9.288317538000058],
                    [-0.718860758999938, 9.288244113000076],
                    [-0.719091195999965, 9.288050535000025],
                    [-0.719246647999967, 9.287974248000069],
                    [-0.719639693999966, 9.28797118500006],
                    [-0.719936326999971, 9.28797535800004],
                    [-0.720018008999944, 9.288013345000024],
                    [-0.720095733999926, 9.287993320000055],
                    [-0.720248326999979, 9.288032417000068],
                    [-0.720403597999962, 9.288167827000052],
                    [-0.720478521999951, 9.288205970000035],
                    [-0.720633736999957, 9.288415759000031],
                    [-0.720769578999978, 9.288551168000026],
                    [-0.72105813099995, 9.288609337000025],
                    [-0.721135796999931, 9.288664646000029],
                    [-0.72126895599996, 9.28866464500004],
                    [-0.721424408999951, 9.288628409000069],
                    [-0.721884981999949, 9.288648436000074],
                    [-0.722118101999968, 9.288629363000041],
                    [-0.722251319999941, 9.288571195000031],
                    [-0.722329047999949, 9.288591220000058],
                    [-0.722406771999943, 9.288552123000045],
                    [-0.722714755999959, 9.288553076000028],
                    [-0.72277305199998, 9.288494909000065],
                    [-0.722945134999975, 9.288475837000021],
                    [-0.723081152999953, 9.288417669000069],
                    [-0.723311470999931, 9.288379525000039],
                    [-0.723544648999962, 9.288286074000041],
                    [-0.723697300999959, 9.288208834000045],
                    [-0.723927796999931, 9.28803528100002],
                    [-0.724063815999955, 9.287902733000067],
                    [-0.724294252999925, 9.287806421000028],
                    [-0.724371919999953, 9.287826447000043],
                    [-0.724449526999933, 9.287903688000029],
                    [-0.724449466999943, 9.28803528100002],
                    [-0.724410483999975, 9.288189762000059],
                    [-0.724332697999955, 9.288322310000069],
                    [-0.724121632999925, 9.288514934000034],
                    [-0.724043848999941, 9.288631272000032],
                    [-0.723966121999979, 9.288685627000064],
                    [-0.723927138999954, 9.288840108000045],
                    [-0.723965883999938, 9.288975518000029],
                    [-0.724062922999963, 9.289049896000051],
                    [-0.724273806999975, 9.28910806500005],
                    [-0.724604022999927, 9.289088993000064],
                    [-0.724659516999964, 9.289049896000051],
                    [-0.724814970999944, 9.289011752000022],
                    [-0.724967618999926, 9.288937374000056],
                    [-0.725200737999955, 9.288918301000024],
                    [-0.725450547999969, 9.288861086000054],
                    [-0.725528333999932, 9.288706606000062],
                    [-0.725586628999963, 9.288651298000048],
                    [-0.725661610999964, 9.288613157000043],
                    [-0.725817004999953, 9.288613156000054],
                    [-0.725914041999943, 9.288668464000068],
                    [-0.726027651999971, 9.28888015900003],
                    [-0.726105316999963, 9.288938328000029],
                    [-0.726260651999951, 9.28901270800003],
                    [-0.726413239999943, 9.289032733000056],
                    [-0.726646179999932, 9.289283526000077],
                    [-0.726720865999937, 9.289550531000032],
                    [-0.726779101999966, 9.289627771000028],
                    [-0.727012041999956, 9.289818487000048],
                    [-0.727067475999945, 9.289895729000023],
                    [-0.727145139999948, 9.289933871000073],
                    [-0.727144961999954, 9.290143661000059],
                    [-0.727105979999976, 9.29029814200004],
                    [-0.727031056999976, 9.290356311000039],
                    [-0.726992132999953, 9.290430689000061],
                    [-0.726914346999934, 9.290506977000064],
                    [-0.726875482999958, 9.29058421600007],
                    [-0.726875423999957, 9.290661456000066],
                    [-0.726952970999946, 9.290813076000063],
                    [-0.727105441999925, 9.291006655000047],
                    [-0.727163497999925, 9.291312755000035],
                    [-0.727299341999981, 9.291464376000022],
                    [-0.727357575999974, 9.291483447000076],
                    [-0.727510225999936, 9.291483447000076],
                    [-0.727837699999952, 9.291389998000056],
                    [-0.727915426999971, 9.291389997000067],
                    [-0.727993152999943, 9.291351853000037],
                    [-0.72807082099996, 9.291351853000037],
                    [-0.728126371999963, 9.291293686000074],
                    [-0.728204098999925, 9.291274614000031],
                    [-0.728359490999935, 9.291274614000031],
                    [-0.728667534999943, 9.291217399000061],
                    [-0.728745199999935, 9.291236470000058],
                    [-0.729072674999941, 9.291198328000064],
                    [-0.729264128999944, 9.291198327000075],
                    [-0.729880393999963, 9.290893181000058],
                    [-0.72997755199998, 9.290854083000056],
                    [-0.730074649999949, 9.290854083000056],
                    [-0.73030508599993, 9.290703418000021],
                    [-0.730383050999933, 9.290394456000058],
                    [-0.730460836999953, 9.290280979000045],
                    [-0.730480327999942, 9.290203739000049],
                    [-0.73063297899995, 9.290088355000023],
                    [-0.730730135999977, 9.29005021100005],
                    [-0.730807861999949, 9.29005021200004],
                    [-0.730863414999931, 9.289994904000025],
                    [-0.731096535999939, 9.289956761000042],
                    [-0.731249185999957, 9.289879521000046],
                    [-0.731482242999959, 9.289879520000056],
                    [-0.731712560999938, 9.289899545000026],
                    [-0.731855954999958, 9.289971842000057],
                    [-0.731998912999927, 9.290016338000044],
                    [-0.732251020999968, 9.290167359000066],
                    [-0.732386583999926, 9.290243790000034],
                    [-0.732694507999952, 9.290379200000075],
                    [-0.732849900999952, 9.290415436000046],
                    [-0.733002431999978, 9.290492677000032],
                    [-0.733465807999949, 9.290512703000047],
                    [-0.733696184999928, 9.290454534000048],
                    [-0.73385157599995, 9.290454534000048],
                    [-0.734081834999927, 9.290493630000071],
                    [-0.734237167999936, 9.290570872000046],
                    [-0.734389698999962, 9.290686256000072],
                    [-0.734428500999968, 9.290780660000053],
                    [-0.734428262999927, 9.291086761000031],
                    [-0.734467065999979, 9.291164002000073],
                    [-0.734736307999924, 9.291012382000076],
                    [-0.734814031999974, 9.29101238100003],
                    [-0.734891699999935, 9.291070550000029],
                    [-0.735044110999979, 9.291318484000044],
                    [-0.735507307999967, 9.291624583000043],
                    [-0.735584975999927, 9.291624584000033],
                    [-0.735970563999956, 9.291815301000042],
                    [-0.736048291999964, 9.291777158000059],
                    [-0.736200822999933, 9.291854399000044],
                    [-0.736278549999952, 9.291854398000055],
                    [-0.736741805999941, 9.292008880000026],
                    [-0.736894456999948, 9.292008880000026],
                    [-0.736972121999941, 9.292047978000028],
                    [-0.737183009999967, 9.292027951000023],
                    [-0.737338459999933, 9.291989810000075],
                    [-0.737646563999931, 9.291797185000064],
                    [-0.737818645999937, 9.291778113000021],
                    [-0.737896310999929, 9.29181625700005],
                    [-0.738129370999957, 9.291855354000063],
                    [-0.738204295999935, 9.291894451000076],
                    [-0.738262529999929, 9.291874426000049],
                    [-0.738437354999974, 9.291932596000038],
                    [-0.738803572999927, 9.291952619000028],
                    [-0.738956222999946, 9.291913524000051],
                    [-0.739072872999941, 9.291798138000047],
                    [-0.739225522999959, 9.291723759000035],
                    [-0.739322680999976, 9.291704688000038],
                    [-0.73947807299993, 9.291704687000049],
                    [-0.739533566999967, 9.291723759000035],
                    [-0.739786115999948, 9.291704688000038],
                    [-0.73982497999998, 9.291627447000053],
                    [-0.739977690999979, 9.291551161000029],
                    [-0.740133082999932, 9.291551161000029],
                    [-0.740363339999931, 9.291628402000072],
                    [-0.740518731999941, 9.291628402000072],
                    [-0.740593598999965, 9.291667500000074],
                    [-0.740671322999958, 9.291628402000072],
                    [-0.740979365999976, 9.291590259000031],
                    [-0.741057151999939, 9.291513019000035],
                    [-0.741212603999941, 9.291435779000039],
                    [-0.74144292099993, 9.291400495000062],
                    [-0.741673237999976, 9.291400496000051],
                    [-0.741828571999974, 9.291493949000028],
                    [-0.741981044999932, 9.291668454000046],
                    [-0.742019847999927, 9.291745695000031],
                    [-0.742136315999971, 9.291858217000026],
                    [-0.74221386399995, 9.292012697000075],
                    [-0.742291529999932, 9.292089938000061],
                    [-0.742366394999976, 9.292126175000021],
                    [-0.742444119999959, 9.292126176000068],
                    [-0.742599452999968, 9.292203416000063],
                    [-0.742907437999975, 9.292203415000074],
                    [-0.742985164999936, 9.292184344000077],
                    [-0.743137754999964, 9.292203415000074],
                    [-0.743293086999927, 9.292300682000075],
                    [-0.743445558999952, 9.292509517000042],
                    [-0.74352328599997, 9.292509517000042],
                    [-0.743831386999943, 9.292358850000028],
                    [-0.743909114999951, 9.292281611000021],
                    [-0.74398684099998, 9.292242514000066],
                    [-0.744025761999978, 9.292165273000023],
                    [-0.744100686999957, 9.292146203000073],
                    [-0.744256079999957, 9.292166227000052],
                    [-0.744333747999974, 9.292204371000025],
                    [-0.744641551999962, 9.292510470000025],
                    [-0.74502714099998, 9.292704049000065],
                    [-0.745179732999929, 9.292704050000054],
                    [-0.745412850999969, 9.292626809000069],
                    [-0.745487775999948, 9.292626809000069],
                    [-0.746029055999941, 9.292379831000062],
                    [-0.746259314999975, 9.29247328200006],
                    [-0.746722450999926, 9.292837554000073],
                    [-0.746836120999944, 9.292992034000065],
                    [-0.746991332999926, 9.293298134000054],
                    [-0.747146606999934, 9.293471687000022],
                    [-0.747260155999925, 9.293777788000057],
                    [-0.747454232999928, 9.29400664700006],
                    [-0.747684429999936, 9.294161129000031],
                    [-0.747895315999926, 9.294161129000031],
                    [-0.748203418999935, 9.293987577000053],
                    [-0.748358869999947, 9.293930361000037],
                    [-0.748514322999938, 9.29389126500007],
                    [-0.748822305999965, 9.293872194000073],
                    [-0.749052683999935, 9.293817839000042],
                    [-0.74930249099998, 9.293702457000052],
                    [-0.749574652999968, 9.293454524000026],
                    [-0.74980508799996, 9.293241875000035],
                    [-0.749880073999975, 9.293167494000045],
                    [-0.749957799999947, 9.293129352000051],
                    [-0.750113190999969, 9.293090255000038],
                    [-0.750188115999947, 9.293090254000049],
                    [-0.750265782999975, 9.293129351000061],
                    [-0.750343508999947, 9.293110279000075],
                    [-0.750498840999967, 9.29318752000006],
                    [-0.750806825999973, 9.293242829000064],
                    [-0.750881748999973, 9.293242830000054],
                    [-0.750959476999981, 9.293187522000039],
                    [-0.751114926999946, 9.293130305000034],
                    [-0.751267518999953, 9.293168449000063],
                    [-0.75180844199997, 9.293398265000064],
                    [-0.752269076999937, 9.293398266000054],
                    [-0.75250213399994, 9.29347550600005],
                    [-0.752810177999947, 9.293456435000053],
                    [-0.752962769999954, 9.29349553000003],
                    [-0.753195828999935, 9.29349553000003],
                    [-0.753734247999944, 9.293399218000047],
                    [-0.754120076999925, 9.293209456000056],
                    [-0.754272726999943, 9.293170358000054],
                    [-0.754346707999957, 9.293070611000076],
                    [-0.75450578899995, 9.293171313000073],
                    [-0.754813830999979, 9.293171313000073],
                    [-0.754891495999971, 9.293209456000056],
                    [-0.75494699199993, 9.293190386000049],
                    [-0.755410306999977, 9.293322932000024],
                    [-0.755873561999977, 9.293551794000052],
                    [-0.756026153999926, 9.293590891000065],
                    [-0.756278583999972, 9.293707230000052],
                    [-0.75635344899996, 9.293784470000048],
                    [-0.756411743999934, 9.293803541000045],
                    [-0.756567017999942, 9.293916065000076],
                    [-0.756641940999941, 9.293936089000056],
                    [-0.756777842999952, 9.294071498000051],
                    [-0.756816586999946, 9.294167810000033],
                    [-0.756894253999974, 9.294205954000063],
                    [-0.757202059999941, 9.29451205600003],
                    [-0.757354648999979, 9.294586435000042],
                    [-0.757432315999949, 9.294663676000027],
                    [-0.757509982999977, 9.294664628000021],
                    [-0.757587647999969, 9.294740916000023],
                    [-0.757740179999928, 9.294819109000059],
                    [-0.757817845999966, 9.294896350000045],
                    [-0.757973180999954, 9.294970731000035],
                    [-0.758048044999953, 9.295047970000041],
                    [-0.758203376999973, 9.295125211000027],
                    [-0.758281044999933, 9.295202451000023],
                    [-0.758433633999971, 9.295257760000027],
                    [-0.758741498999939, 9.295431313000051],
                    [-0.758974557999977, 9.295527625000034],
                    [-0.759282539999958, 9.295582934000038],
                    [-0.759435132999954, 9.295641101000058],
                    [-0.759590523999975, 9.295641102000047],
                    [-0.759668189999957, 9.295699271000046],
                    [-0.759743115999925, 9.295680200000049],
                    [-0.759898447999944, 9.295718343000033],
                    [-0.760051097999963, 9.295719295000026],
                    [-0.760128764999934, 9.295776511000042],
                    [-0.760206432999951, 9.295776511000042],
                    [-0.760284157999934, 9.29573836700007],
                    [-0.760592200999952, 9.295719296000073],
                    [-0.760744852999949, 9.295642057000066],
                    [-0.760822576999942, 9.295661127000074],
                    [-0.76090030499995, 9.295622984000033],
                    [-0.76113062099995, 9.29558484100005],
                    [-0.761554448999959, 9.295394968000039],
                    [-0.76203258399994, 9.295399727000074],
                    [-0.762314061999973, 9.295462059000045],
                    [-0.762751833999971, 9.295684290000054],
                    [-0.762975258999973, 9.295688879000068],
                    [-0.763221078999948, 9.295618020000063],
                    [-0.76351600299995, 9.295622654000056],
                    [-0.763823356999978, 9.295706706000033],
                    [-0.763949320999927, 9.295822690000023],
                    [-0.764099469999962, 9.296008235000045],
                    [-0.764252061999969, 9.296104547000027],
                    [-0.76440751399997, 9.296027308000021],
                    [-0.764482377999968, 9.296047332000057],
                    [-0.76471543699995, 9.296162717000072],
                    [-0.764867968999965, 9.296314336000023],
                    [-0.76490671199997, 9.296391577000065],
                    [-0.76498437999993, 9.296468817000061],
                    [-0.765062045999969, 9.296507914000074],
                    [-0.765214457999946, 9.296814017000031],
                    [-0.765214396999966, 9.296891257000027],
                    [-0.765136551999944, 9.297120116000031],
                    [-0.765136432999952, 9.29734897700007],
                    [-0.76538880499993, 9.297580699000036],
                    [-0.76550253299996, 9.297655077000059],
                    [-0.76571592099998, 9.298038419000022],
                    [-0.765868570999942, 9.297961178000037],
                    [-0.766121301999931, 9.297655079000037],
                    [-0.766293443999928, 9.297542557000043],
                    [-0.766429523999932, 9.297407147000058],
                    [-0.766679211999929, 9.297427172000027],
                    [-0.766756878999956, 9.29750441300007],
                    [-0.766870485999959, 9.297733274000052],
                    [-0.76685105699994, 9.297790487000043],
                    [-0.766967465999926, 9.297944969000071],
                    [-0.767142229999934, 9.298039373000051],
                    [-0.767178231999935, 9.298116614000037],
                    [-0.767161304999945, 9.29857624300007],
                    [-0.767177932999971, 9.298650623000071],
                    [-0.76725547999996, 9.298805102000074],
                    [-0.767371950999973, 9.298921440000072],
                    [-0.767449677999934, 9.298940513000048],
                    [-0.767499567999948, 9.298984377000068],
                    [-0.767807668999978, 9.298908091000044],
                    [-0.767910309999934, 9.298960537000028],
                    [-0.768065702999934, 9.298960539000063],
                    [-0.768295960999978, 9.299034919000064],
                    [-0.768451235999976, 9.299189399000056],
                    [-0.768490038999971, 9.299266640000042],
                    [-0.768489976999945, 9.299341019000053],
                    [-0.768564842999979, 9.299418259000049],
                    [-0.768564842999979, 9.299495500000035],
                    [-0.768603646999964, 9.299572741000077],
                    [-0.76872011599994, 9.299685263000072],
                    [-0.768739486999948, 9.299762504000057],
                    [-0.768875329999958, 9.299916984000049],
                    [-0.768950253999947, 9.299956082000051],
                    [-0.769008547999931, 9.299937010000065],
                    [-0.769316532999937, 9.299992319000069],
                    [-0.769413569999926, 9.300069558000075],
                    [-0.769491295999956, 9.300069558000075],
                    [-0.76964376799998, 9.300301280000042],
                    [-0.769643709999968, 9.300375659000053],
                    [-0.769798981999941, 9.300568283000075],
                    [-0.769951513999956, 9.30064552500005],
                    [-0.770106905999967, 9.300681762000067],
                    [-0.770645325999965, 9.300569238000037],
                    [-0.770722990999957, 9.300588310000023],
                    [-0.77078122599994, 9.300646478000033],
                    [-0.770878323999966, 9.300681761000021],
                    [-0.770914385999959, 9.300759002000063],
                    [-0.771030854999935, 9.300875340000061],
                    [-0.771108522999953, 9.300913483000045],
                    [-0.771207980999975, 9.300905248000049],
                    [-0.771338839999942, 9.300894412000048],
                    [-0.771416625999962, 9.300817171000062],
                    [-0.771494291999943, 9.300875341000051],
                    [-0.771571837999943, 9.301026960000058],
                    [-0.771490763999964, 9.301077148000047],
                    [-0.771504740999944, 9.301211773000034],
                    [-0.771977887999981, 9.301526367000065],
                    [-0.77218739999995, 9.301679190000073],
                    [-0.77235776699996, 9.301859472000046],
                    [-0.772572362999938, 9.301930678000076],
                    [-0.772733302999939, 9.301992968000036],
                    [-0.772857921999957, 9.302040519000059],
                    [-0.772920187999944, 9.302073556000039],
                    [-0.773067460999926, 9.302151698000046],
                    [-0.773153443999945, 9.302304165000066],
                    [-0.773251785999946, 9.302357529000062],
                    [-0.773356303999947, 9.30246158500006],
                    [-0.773459386999946, 9.302703324000049],
                    [-0.773528239999962, 9.302721106000035],
                    [-0.773707454999965, 9.303050750000068],
                    [-0.773907688999941, 9.303228319000027],
                    [-0.773984581999969, 9.303237486000057],
                    [-0.77423491899998, 9.303362015000062],
                    [-0.774673351999979, 9.303915583000048],
                    [-0.77547754699998, 9.304162334000068],
                    [-0.775497516999962, 9.304401931000029],
                    [-0.77528770899994, 9.304707177000068],
                    [-0.775469250999947, 9.304901623000035],
                    [-0.775818542999957, 9.304999009000028],
                    [-0.776065012999936, 9.305032140000037],
                    [-0.77627294499996, 9.30506009100003],
                    [-0.776255523999964, 9.305181013000038],
                    [-0.776209617999939, 9.305318512000042],
                    [-0.776156369999967, 9.305548624000039],
                    [-0.776183012999979, 9.305841803000021],
                    [-0.776334973999951, 9.305966271000045],
                    [-0.77647471399996, 9.305971079000074],
                    [-0.776824033999958, 9.306026821000046],
                    [-0.777103299999965, 9.306374016000063],
                    [-0.777309491999972, 9.306482137000046],
                    [-0.777550404999943, 9.30648534200003],
                    [-0.777815880999924, 9.306541030000062],
                    [-0.778051413999947, 9.306674915000031],
                    [-0.778418157999965, 9.307006969000042],
                    [-0.778598134999925, 9.307027345000051],
                    [-0.779059319999931, 9.306972108000025],
                    [-0.779285631999926, 9.307087460000048],
                    [-0.779436478999969, 9.307208315000025],
                    [-0.77980409099996, 9.307514199000025],
                    [-0.779951055999959, 9.307491294000044],
                    [-0.780185299999971, 9.307678684000052],
                    [-0.780414270999927, 9.30786131900004],
                    [-0.780617653999968, 9.307994422000036],
                    [-0.780637618999947, 9.308250119000036],
                    [-0.780775824999978, 9.308443220000072],
                    [-0.780844573999957, 9.308573197000044],
                    [-0.780887786999926, 9.308640658000058],
                    [-0.780897740999933, 9.308724034000022],
                    [-0.78100479699998, 9.308919070000059],
                    [-0.781025115999967, 9.30901523700004],
                    [-0.78198185399998, 9.310776961000045],
                    [-0.78205817199995, 9.310949073000074],
                    [-0.782210968999948, 9.311025077000068],
                    [-0.782486725999945, 9.311025976000053],
                    [-0.783572900999957, 9.308696346000033],
                    [-0.785051526999951, 9.306504362000055],
                    [-0.786264467999956, 9.305883612000059],
                    [-0.78816554399998, 9.305457248000039],
                    [-0.790209625999978, 9.305779080000036],
                    [-0.790930807999928, 9.306044880000059],
                    [-0.792145888999926, 9.306492709000054],
                    [-0.79300640699995, 9.306885081000075],
                    [-0.793472312999938, 9.307455349000065],
                    [-0.793938302999948, 9.307883115000038],
                    [-0.794387950999976, 9.308463987000039],
                    [-0.794886433999977, 9.308712872000058],
                    [-0.795479824999973, 9.309023996000064],
                    [-0.795918749999942, 9.309258324000041],
                    [-0.796987659999957, 9.310185211000032],
                    [-0.79742934099994, 9.310571413000048],
                    [-0.79791600599998, 9.310932678000029],
                    [-0.798090903999935, 9.311062509000067],
                    [-0.798195094999926, 9.311120678000066],
                    [-0.798508919999961, 9.311371471000029],
                    [-0.798880741999938, 9.311713808000036],
                    [-0.79917132099996, 9.311942669000075],
                    [-0.799554227999977, 9.312238280000031],
                    [-0.799891239999965, 9.312535799000045],
                    [-0.800286426999946, 9.312971588000039],
                    [-0.800565202999962, 9.313186146000021],
                    [-0.800891066999952, 9.313586652000026],
                    [-0.801124007999931, 9.31388417200003],
                    [-0.801462090999962, 9.314378128000044],
                    [-0.801776810999968, 9.314835849000076],
                    [-0.80205618399998, 9.315246843000068],
                    [-0.802266352999936, 9.315591088000076],
                    [-0.802627207999933, 9.316060252000057],
                    [-0.802883689999931, 9.316426430000035],
                    [-0.803267313999925, 9.316826936000041],
                    [-0.80363913399998, 9.317179762000023],
                    [-0.803976146999958, 9.317488724000043],
                    [-0.804394161999937, 9.317808176000028],
                    [-0.804765863999933, 9.318092344000036],
                    [-0.805021394999926, 9.318299274000026],
                    [-0.805578591999961, 9.318710268000075],
                    [-0.805913156999964, 9.318949619000023],
                    [-0.806912029999978, 9.319604287000061],
                    [-0.807999561999964, 9.320162564000043],
                    [-0.808640529999934, 9.320882342000061],
                    [-0.80947267099998, 9.321522723000044],
                    [-0.811085514999945, 9.323627914000042],
                    [-0.811116885999979, 9.323338558000046],
                    [-0.81114836699993, 9.322842509000054],
                    [-0.811136369999929, 9.322508721000077],
                    [-0.810992712999962, 9.322067323000056],
                    [-0.810726705999969, 9.321104525000067],
                    [-0.810598496999944, 9.319907159000024],
                    [-0.810620359999973, 9.319717594000053],
                    [-0.810637591999978, 9.319568185000037],
                    [-0.810665125999947, 9.31932944600004],
                    [-0.810640649999925, 9.318915050000044],
                    [-0.810567960999947, 9.318646308000041],
                    [-0.810443428999974, 9.318046828000035],
                    [-0.810412516999975, 9.317488739000055],
                    [-0.810298371999977, 9.316920268000047],
                    [-0.809965528999953, 9.316177473000039],
                    [-0.810401719999959, 9.315879077000034],
                    [-0.812926898999933, 9.31415172800007],
                    [-0.814408132999972, 9.313138476000063],
                    [-0.814574729999947, 9.312932501000034],
                    [-0.814838427999973, 9.312852400000054],
                    [-0.815063259999931, 9.312747506000051],
                    [-0.815931836999937, 9.31277039400004],
                    [-0.81628148599998, 9.312729390000072],
                    [-0.816758927999956, 9.312525321000066],
                    [-0.817047601999946, 9.312341280000055],
                    [-0.817336271999977, 9.312217314000065],
                    [-0.817624943999931, 9.312156285000071],
                    [-0.818512891999944, 9.312300278000066],
                    [-0.819029078999961, 9.312237341000071],
                    [-0.819792272999962, 9.312075231000051],
                    [-0.820019907999949, 9.311932195000054],
                    [-0.820494549999978, 9.311725267000043],
                    [-0.820805393999933, 9.311684263000075],
                    [-0.821632306999959, 9.311706195000056],
                    [-0.822312229999966, 9.311665192000021],
                    [-0.822539866999932, 9.31156315800007],
                    [-0.822856849999937, 9.311616560000061],
                    [-0.822927347999951, 9.31162828500004],
                    [-0.823355632999949, 9.311699522000026],
                    [-0.82329739599993, 9.311622281000041],
                    [-0.823261393999928, 9.311470661000044],
                    [-0.823316946999967, 9.311393420000059],
                    [-0.823222590999933, 9.311373396000022],
                    [-0.823297575999959, 9.31121986900007],
                    [-0.823317067999938, 9.311087321000059],
                    [-0.823453205999954, 9.310762147000048],
                    [-0.82347281899996, 9.310456048000049],
                    [-0.823434015999965, 9.310301566000021],
                    [-0.823434133999967, 9.310091776000036],
                    [-0.823395328999936, 9.310014537000029],
                    [-0.823395507999976, 9.309632150000027],
                    [-0.823415000999944, 9.309534883000026],
                    [-0.823473293999939, 9.309477668000056],
                    [-0.823473354999976, 9.309383263000029],
                    [-0.823570570999948, 9.309248809000053],
                    [-0.823664927999971, 9.309209711000051],
                    [-0.823723222999945, 9.309116260000053],
                    [-0.824011952999967, 9.308865466000043],
                    [-0.824320117999946, 9.308675704000052],
                    [-0.824475509999957, 9.308598464000056],
                    [-0.82455323399995, 9.308598463000067],
                    [-0.824630959999979, 9.30852122400006],
                    [-0.825091713999939, 9.30829331700005],
                    [-0.825169439999968, 9.308235148000051],
                    [-0.825322149999977, 9.308176980000042],
                    [-0.82545817099998, 9.308064456000068],
                    [-0.82555532899994, 9.308025359000055],
                    [-0.825613622999924, 9.307949072000042],
                    [-0.825766274999978, 9.307871832000046],
                    [-0.825863431999949, 9.307871832000046],
                    [-0.825941157999978, 9.307794591000061],
                    [-0.826016083999946, 9.307758357000068],
                    [-0.826093809999975, 9.307758355000033],
                    [-0.826307555999961, 9.307584804000044],
                    [-0.826479696999968, 9.307375969000077],
                    [-0.826518620999934, 9.307298728000035],
                    [-0.826596287999962, 9.307259631000022],
                    [-0.826654641999937, 9.307088939000039],
                    [-0.826885196999967, 9.306629311000052],
                    [-0.827018476999967, 9.306493902000057],
                    [-0.827057398999955, 9.306419522000056],
                    [-0.827057397999965, 9.30634228200006],
                    [-0.827115751999941, 9.306187801000021],
                    [-0.827115811999931, 9.306036181000024],
                    [-0.827174166999953, 9.305881701000033],
                    [-0.827174285999945, 9.305730081000036],
                    [-0.827232640999966, 9.305576553000037],
                    [-0.827285841999981, 9.305502408000052],
                    [-0.827329798999926, 9.305441145000032],
                    [-0.827618530999928, 9.305212284000049],
                    [-0.827829534999978, 9.305003448000036],
                    [-0.827946182999938, 9.304771729000038],
                    [-0.828060029999961, 9.304658252000024],
                    [-0.828293267999925, 9.304353105000075],
                    [-0.828659724999966, 9.304008861000057],
                    [-0.82875414199998, 9.303854380000075],
                    [-0.828831867999952, 9.303815282000073],
                    [-0.828909653999972, 9.303663662000076],
                    [-0.829012354999975, 9.303191639000033],
                    [-0.829140327999937, 9.302897933000054],
                    [-0.829198623999957, 9.302858838000077],
                    [-0.829315270999928, 9.302707216000044],
                    [-0.829487352999934, 9.302630931000067],
                    [-0.829526216999966, 9.302553690000025],
                    [-0.829603942999938, 9.302514594000058],
                    [-0.829681669999957, 9.302437352000027],
                    [-0.829681787999959, 9.302208491000044],
                    [-0.829720711999926, 9.302132204000031],
                    [-0.829720770999927, 9.301903344000038],
                    [-0.829795814999954, 9.301674484000046],
                    [-0.829795874999945, 9.30159724300006],
                    [-0.829873660999965, 9.301442763000068],
                    [-0.829951385999948, 9.301404619000039],
                    [-0.82999025099997, 9.301330241000073],
                    [-0.830067974999963, 9.301252999000042],
                    [-0.830123527999945, 9.30109851800006],
                    [-0.830181882999966, 9.301021278000064],
                    [-0.830181883999956, 9.300946898000063],
                    [-0.830143079999971, 9.300869659000057],
                    [-0.830143197999973, 9.300678941000058],
                    [-0.830029469999943, 9.300563557000032],
                    [-0.830029529999933, 9.300448174000053],
                    [-0.829990726999938, 9.300350909000031],
                    [-0.830029650999961, 9.300199289000034],
                    [-0.830143498999973, 9.300064833000022],
                    [-0.830162928999925, 9.299971382000024],
                    [-0.830415539999933, 9.299797830000045],
                    [-0.830451658999948, 9.299720590000049],
                    [-0.830529386999956, 9.299646209000059],
                    [-0.830568308999943, 9.299548943000048],
                    [-0.830684897999959, 9.299433559000022],
                    [-0.83081817599998, 9.299204700000075],
                    [-0.83091533399994, 9.299147484000059],
                    [-0.830934825999975, 9.299050219000037],
                    [-0.83099311999996, 9.298995865000052],
                    [-0.831145769999978, 9.298918625000056],
                    [-0.831223496999939, 9.29884138400007],
                    [-0.831301223999958, 9.298802287000058],
                    [-0.831378948999941, 9.298802286000068],
                    [-0.831453873999976, 9.298726001000034],
                    [-0.831609446999948, 9.298419898000077],
                    [-0.831726034999974, 9.298268278000023],
                    [-0.831800958999963, 9.298268278000023],
                    [-0.831878745999973, 9.298191040000063],
                    [-0.832111863999955, 9.298075656000037],
                    [-0.832342181999934, 9.298036559000025],
                    [-0.83253375399994, 9.297846794000066],
                    [-0.832533812999941, 9.297769555000059],
                    [-0.832669953999925, 9.297463454000024],
                    [-0.832822603999944, 9.297348070000055],
                    [-0.83291976299995, 9.297309927000072],
                    [-0.83307515499996, 9.297309926000025],
                    [-0.833383137999931, 9.297387167000068],
                    [-0.833613455999966, 9.297387168000057],
                    [-0.833671749999951, 9.297309928000061],
                    [-0.833807771999943, 9.29723554900005],
                    [-0.833882694999943, 9.297158308000064],
                    [-0.834115812999926, 9.297158309000054],
                    [-0.834190738999951, 9.297177380000051],
                    [-0.834268404999932, 9.297235547000071],
                    [-0.834346072999949, 9.297235547000071],
                    [-0.834423798999978, 9.297274646000062],
                    [-0.834498722999967, 9.297274645000073],
                    [-0.83465405499993, 9.29732995300003],
                    [-0.83480944799993, 9.29742626500007],
                    [-0.835039764999976, 9.297388122000029],
                    [-0.835192415999927, 9.297310882000033],
                    [-0.835270082999955, 9.29732995300003],
                    [-0.835503080999956, 9.297542603000068],
                    [-0.835577944999955, 9.297694224000054],
                    [-0.835772082999938, 9.297886849000065],
                    [-0.836041261999981, 9.297886849000065],
                    [-0.836349365999979, 9.297713295000051],
                    [-0.836504757999933, 9.297752394000042],
                    [-0.83665734799996, 9.297829634000038],
                    [-0.83681274099996, 9.297848706000025],
                    [-0.836887666999928, 9.297887803000037],
                    [-0.837043058999939, 9.297887804000027],
                    [-0.837101353999969, 9.297829634000038],
                    [-0.837254004999977, 9.297791491000055],
                    [-0.837320582999951, 9.297717110000065],
                    [-0.837545356999954, 9.297772420000058],
                    [-0.83769794799997, 9.297829635000028],
                    [-0.838083598999958, 9.298039424000024],
                    [-0.83816126399995, 9.298039424000024],
                    [-0.838449817999958, 9.298135736000063],
                    [-0.838680072999978, 9.298271144000068],
                    [-0.838777172999926, 9.298271145000058],
                    [-0.838835465999978, 9.298345525000059],
                    [-0.838988057999927, 9.298384622000071],
                    [-0.839085155999953, 9.298461863000057],
                    [-0.839315351999971, 9.298709795000036],
                    [-0.839509549999946, 9.298767964000035],
                    [-0.839934120999942, 9.298845203000042],
                    [-0.840472422999937, 9.298845205000021],
                    [-0.840625072999956, 9.298807060000058],
                    [-0.840819327999952, 9.298807061000048],
                    [-0.841318825999963, 9.298807062000037],
                    [-0.841377060999946, 9.29884615800006],
                    [-0.841629551999972, 9.298923400000035],
                    [-0.841685043999973, 9.298981568000045],
                    [-0.841859747999933, 9.299190403000068],
                    [-0.841917982999973, 9.299342024000055],
                    [-0.841976218999946, 9.29941926500004],
                    [-0.841992789999949, 9.299573745000032],
                    [-0.842051023999943, 9.299650986000074],
                    [-0.842128690999971, 9.299687222000045],
                    [-0.842206416999943, 9.299650985000028],
                    [-0.842359066999961, 9.299650987000064],
                    [-0.842436734999978, 9.299687221000056],
                    [-0.842592127999978, 9.299671010000054],
                    [-0.843335887999956, 9.299527974000057],
                    [-0.843671706999942, 9.299420219000069],
                    [-0.843882651999934, 9.299287670000069],
                    [-0.844035303999931, 9.299230455000043],
                    [-0.844190696999931, 9.299230455000043],
                    [-0.844346090999977, 9.299191359000076],
                    [-0.844729176999977, 9.298924354000064],
                    [-0.84488456899993, 9.298886211000024],
                    [-0.845037218999948, 9.298905283000067],
                    [-0.845192552999947, 9.29900159500005],
                    [-0.845270218999929, 9.29901876100007],
                    [-0.845367374999967, 9.299076929000023],
                    [-0.845442241999933, 9.299076929000023],
                    [-0.845661173999929, 9.299009225000077],
                    [-0.845750342999963, 9.298905284000057],
                    [-0.845828128999926, 9.298751757000048],
                    [-0.845964151999965, 9.298638281000024],
                    [-0.846116741999936, 9.298674516000062],
                    [-0.846369230999926, 9.298809925000057],
                    [-0.846599548999961, 9.29884806900003],
                    [-0.846677215999932, 9.298887166000043],
                    [-0.846879353999952, 9.298852540000041],
                    [-0.847043552999935, 9.298732686000051],
                    [-0.847099106999963, 9.298658307000039],
                    [-0.847176890999947, 9.298426586000062],
                    [-0.847254617999965, 9.298388442000032],
                    [-0.847274048999964, 9.298294037000062],
                    [-0.847410249999939, 9.297853481000061],
                    [-0.84739099799998, 9.297451068000044],
                    [-0.847446608999974, 9.297241278000058],
                    [-0.847485472999949, 9.297164039000052],
                    [-0.847679787999937, 9.297010510000064],
                    [-0.847679788999926, 9.296936131000052],
                    [-0.847757573999957, 9.29678165100006],
                    [-0.847739333999925, 9.296691059000068],
                    [-0.847776349999947, 9.296619828000075],
                    [-0.848176428999977, 9.296461058000034],
                    [-0.848240395999937, 9.296540554000046],
                    [-0.848295992999965, 9.296630033000042],
                    [-0.848334795999961, 9.296704410000075],
                    [-0.848412462999931, 9.296743509000066],
                    [-0.84854562299995, 9.296897035000029],
                    [-0.848759190999942, 9.297049608000066],
                    [-0.84883405599993, 9.29716499400007],
                    [-0.848892289999981, 9.297316615000057],
                    [-0.849141858999928, 9.297777195000037],
                    [-0.849141799999927, 9.297854435000033],
                    [-0.849219466999955, 9.297931676000076],
                    [-0.849180602999979, 9.29800605500003],
                    [-0.849219405999975, 9.298083295000026],
                    [-0.849219348999952, 9.298160536000069],
                    [-0.849141620999944, 9.29831501700005],
                    [-0.849122129999955, 9.298427541000024],
                    [-0.849160932999951, 9.298582021000072],
                    [-0.84921916899998, 9.298694543000067],
                    [-0.849296715999969, 9.298965363000036],
                    [-0.849316026999929, 9.299194223000029],
                    [-0.849451927999951, 9.299423083000022],
                    [-0.849682125999948, 9.299654804000056],
                    [-0.849720928999943, 9.299883665000038],
                    [-0.849798534999934, 9.300035286000025],
                    [-0.850028792999979, 9.300189768000052],
                    [-0.850125832999936, 9.300343295000062],
                    [-0.850161892999949, 9.300494913000023],
                    [-0.850181204999956, 9.300723775000051],
                    [-0.850125651999974, 9.300801015000047],
                    [-0.850067298999932, 9.300955496000029],
                    [-0.84998957199997, 9.30102987600003],
                    [-0.849892473999944, 9.301048947000027],
                    [-0.849739764999924, 9.301165283000046],
                    [-0.849506586999951, 9.301357909000046],
                    [-0.849451092999971, 9.301451359000055],
                    [-0.849373366999941, 9.301490455000021],
                    [-0.849315012999966, 9.301567696000063],
                    [-0.849314952999976, 9.30171931700005],
                    [-0.849373247999949, 9.301795603000073],
                    [-0.849334323999926, 9.301872844000059],
                    [-0.849334323999926, 9.301950083000065],
                    [-0.849295400999949, 9.302027324000051],
                    [-0.849140009999928, 9.302101703000062],
                    [-0.849026161999973, 9.30221804100006],
                    [-0.849026102999971, 9.302371568000069],
                    [-0.849064904999977, 9.302523189000055],
                    [-0.84904535499993, 9.302752049000048],
                    [-0.849064725999938, 9.302829289000044],
                    [-0.848987, 9.302983771000072],
                    [-0.848948018999977, 9.303212630000075],
                    [-0.848967449999975, 9.30328987200005],
                    [-0.849025683999969, 9.303367112000046],
                    [-0.849006133999978, 9.303595973000029],
                    [-0.848967209999955, 9.303747593000026],
                    [-0.848986642999932, 9.303824833000021],
                    [-0.848986521999961, 9.304056553000066],
                    [-0.849005893999959, 9.304130933000067],
                    [-0.849064189999979, 9.304208173000063],
                    [-0.849158484999975, 9.304304486000035],
                    [-0.849449777999951, 9.304417009000076],
                    [-0.849987959999964, 9.304839447000063],
                    [-0.850218216999963, 9.304974857000047],
                    [-0.850295942999935, 9.30495578600005],
                    [-0.850451335999935, 9.304974858000037],
                    [-0.85052626099997, 9.305013],
                    [-0.851145088999942, 9.305013955000049],
                    [-0.851297680999949, 9.305052098000033],
                    [-0.851453072999959, 9.305052098000033],
                    [-0.851683388999959, 9.305088334000061],
                    [-0.851761056999976, 9.305126479000023],
                    [-0.851991432999966, 9.30508833600004],
                    [-0.852069099999937, 9.305127431000074],
                    [-0.852221690999954, 9.30514650300006],
                    [-0.852299415999937, 9.305204672000059],
                    [-0.852377082999965, 9.305204673000048],
                    [-0.852607339999963, 9.305320056000028],
                    [-0.852762731999974, 9.30535915300004],
                    [-0.852993049999952, 9.30535915300004],
                    [-0.853456604999963, 9.305089289000023],
                    [-0.853534331999924, 9.305089290000069],
                    [-0.853589823999926, 9.304994885000042],
                    [-0.853823002999945, 9.304918598000029],
                    [-0.854131044999974, 9.30486042900003],
                    [-0.854844230999959, 9.30486042900003],
                    [-0.854919094999957, 9.304899527000032],
                    [-0.855132782999931, 9.304937671000062],
                    [-0.855285373999948, 9.304937671000062],
                    [-0.855382530999975, 9.304976767000028],
                    [-0.855460197999946, 9.304976767000028],
                    [-0.855537922999929, 9.305015866000076],
                    [-0.855612848999954, 9.30501586400004],
                    [-0.855845845999966, 9.305128388000071],
                    [-0.855920771999934, 9.30512838900006],
                    [-0.855979064999929, 9.30518655700007],
                    [-0.856134398999927, 9.305263797000066],
                    [-0.856364716999963, 9.305321967000054],
                    [-0.856520108999973, 9.30539920700005],
                    [-0.85661440399997, 9.305473588000041],
                    [-0.856692131999978, 9.305473586000062],
                    [-0.85675036799995, 9.305511731000024],
                    [-0.856905759999961, 9.305550827000047],
                    [-0.85752178499996, 9.305628068000033],
                    [-0.857674434999979, 9.305608996000046],
                    [-0.857907495999939, 9.305628069000022],
                    [-0.858060146999946, 9.305648093000059],
                    [-0.858137812999928, 9.305667165000045],
                    [-0.858368128999928, 9.305667165000045],
                    [-0.858523521999928, 9.305628070000068],
                    [-0.858676171999946, 9.305629022000062],
                    [-0.858909170999937, 9.305837859000064],
                    [-0.85900352699997, 9.305857883000044],
                    [-0.859275389999937, 9.306124888000056],
                    [-0.859350313999926, 9.306143959000053],
                    [-0.859466783999949, 9.306298440000035],
                    [-0.859697041999937, 9.306470085000058],
                    [-0.859852433999947, 9.306470086000047],
                    [-0.859930159999976, 9.306433850000076],
                    [-0.860082809999938, 9.306433850000076],
                    [-0.860160477999955, 9.306395705000057],
                    [-0.860532500999966, 9.306396516000063],
                    [-0.860659683999927, 9.306445703000065],
                    [-0.860984611999925, 9.306803824000042],
                    [-0.861217591999946, 9.307372495000038],
                    [-0.861507187999962, 9.307737623000037],
                    [-0.861573324999938, 9.307770159000029],
                    [-0.861662609999939, 9.307857015000025],
                    [-0.86173329099995, 9.307821944000068],
                    [-0.861832211999968, 9.307857081000066],
                    [-0.862005748999934, 9.307956034000028],
                    [-0.86211287499998, 9.307978479000042],
                    [-0.862270256999977, 9.308102932000054],
                    [-0.862404406999929, 9.308404824000036],
                    [-0.862496226999951, 9.308531211000059],
                    [-0.862524457999939, 9.308622476000039],
                    [-0.862821074999943, 9.309106936000035],
                    [-0.86282809599993, 9.309226271000057],
                    [-0.862856335999936, 9.309296477000032],
                    [-0.862835078999979, 9.309436859000073],
                    [-0.862891556999955, 9.309584289000043],
                    [-0.862898549999954, 9.309773819000043],
                    [-0.862974616999963, 9.309807356000022],
                    [-0.862974837999957, 9.309894320000069],
                    [-0.86299736899997, 9.309955937000041],
                    [-0.863146652999944, 9.310182514000076],
                    [-0.86318104399993, 9.310237217000065],
                    [-0.863471256999958, 9.310438205000025],
                    [-0.863767438999957, 9.310630533000051],
                    [-0.86389455799997, 9.310848186000044],
                    [-0.863912669999934, 9.311123873000042],
                    [-0.86395704499995, 9.311261238000043],
                    [-0.863967646999924, 9.311727134000023],
                    [-0.864133143999936, 9.312069948000044],
                    [-0.864340095999978, 9.312289385000042],
                    [-0.864560877999963, 9.312440279000043],
                    [-0.864685063999957, 9.312536296000076],
                    [-0.864836812999954, 9.312742003000039],
                    [-0.866127603999928, 9.309068551000053],
                    [-0.866350730999955, 9.309040931000027],
                    [-0.866699394999955, 9.30893024900007],
                    [-0.86702022999998, 9.308653341000024],
                    [-0.867759606999925, 9.307850227000074],
                    [-0.867929103999927, 9.307711381000047],
                    [-0.868547724999928, 9.307204627000033],
                    [-0.868624446999945, 9.307144119000043],
                    [-0.869363626999927, 9.306853509000064],
                    [-0.869862215999945, 9.306380963000038],
                    [-0.870216882999955, 9.306148734000033],
                    [-0.87050501799996, 9.305975182000054],
                    [-0.87094359799994, 9.305765393000058],
                    [-0.871254801999953, 9.305556559000024],
                    [-0.871589429999972, 9.305393495000033],
                    [-0.87203909599998, 9.305104559000029],
                    [-0.872373006999965, 9.304862349000075],
                    [-0.872684746999937, 9.304710731000057],
                    [-0.873111822999931, 9.304547667000065],
                    [-0.873504327999967, 9.304407489000027],
                    [-0.873965616999953, 9.304150975000027],
                    [-0.87418407399997, 9.303886832000046],
                    [-0.874793902999954, 9.30331945100005],
                    [-0.875001090999945, 9.303090589000021],
                    [-0.875300014999937, 9.30275397500003],
                    [-0.875646742999947, 9.302696759000071],
                    [-0.875946977999945, 9.302603307000027],
                    [-0.876024800999971, 9.302590470000041],
                    [-0.879162494999946, 9.303393199000027],
                    [-0.880983541999967, 9.303449341000032],
                    [-0.881077552999955, 9.303814365000051],
                    [-0.881230024999979, 9.304203428000051],
                    [-0.881394476999958, 9.304664011000057],
                    [-0.881431431999943, 9.305110289000027],
                    [-0.881514224999933, 9.305490768000027],
                    [-0.881738044999963, 9.30623551900004],
                    [-0.881903569999963, 9.306957384000043],
                    [-0.88212756799993, 9.307762209000032],
                    [-0.882223824999926, 9.308014477000029],
                    [-0.881913047999944, 9.30940656100006],
                    [-0.881896273999928, 9.31037395900006],
                    [-0.882160948999967, 9.311205581000024],
                    [-0.882471307999936, 9.311788351000075],
                    [-0.883778941999935, 9.312205009000024],
                    [-0.884677496999927, 9.312048781000044],
                    [-0.885744616999943, 9.311424134000049],
                    [-0.887085858999967, 9.309060464000027],
                    [-0.888124822999941, 9.308557157000052],
                    [-0.888319843999966, 9.308486939000034],
                    [-0.889024563999953, 9.308252356000025],
                    [-0.889637191999952, 9.308214214000031],
                    [-0.890169293999975, 9.30817797900005],
                    [-0.890492774999927, 9.308139834000031],
                    [-0.890989530999946, 9.308056873000055],
                    [-0.891498565999939, 9.308021591000056],
                    [-0.891937264999967, 9.307925279000074],
                    [-0.892538091999938, 9.307785103000072],
                    [-0.892988890999959, 9.307691651000027],
                    [-0.893543883999939, 9.307620133000057],
                    [-0.894318161999934, 9.307534310000051],
                    [-0.894757697999978, 9.307509517000028],
                    [-0.895208971999978, 9.307529543000044],
                    [-0.895729750999976, 9.307617272000073],
                    [-0.896123268999929, 9.307640161000052],
                    [-0.896458729999949, 9.307647790000033],
                    [-0.896921151999948, 9.307587714000022],
                    [-0.897256076999952, 9.307507612000052],
                    [-0.897602445999951, 9.307355992000055],
                    [-0.897971584999937, 9.307193884000071],
                    [-0.898260256999947, 9.307053706000033],
                    [-0.89864066399997, 9.306855360000043],
                    [-0.899217051999926, 9.30650825500004],
                    [-0.89958618999998, 9.306345194000073],
                    [-0.899944183999935, 9.306240298000034],
                    [-0.900314157999958, 9.306158291000031],
                    [-0.900741530999937, 9.306061979000049],
                    [-0.901296403999936, 9.30596852900004],
                    [-0.901839649999943, 9.305918943000052],
                    [-0.902198299999952, 9.305882706000034],
                    [-0.903292775999944, 9.306289677000052],
                    [-0.904037238999933, 9.306477896000047],
                    [-0.904352716999938, 9.306452912000054],
                    [-0.904642984999953, 9.306327643000031],
                    [-0.905009016999941, 9.306014378000043],
                    [-0.905242556999951, 9.305680710000047],
                    [-0.905813039999941, 9.304852836000066],
                    [-0.906193443999939, 9.304607766000061],
                    [-0.906700870999941, 9.304318830000057],
                    [-0.907104638999954, 9.304120483000077],
                    [-0.907237857999974, 9.304038477000063],
                    [-0.907577372999924, 9.303830595000022],
                    [-0.908015537999972, 9.303576940000028],
                    [-0.908511459999943, 9.303331870000022],
                    [-0.908996411999965, 9.303111591000061],
                    [-0.90935374999998, 9.302935180000077],
                    [-0.909734808999929, 9.30279786400007],
                    [-0.910288845999958, 9.302563281000062],
                    [-0.910808311999972, 9.302389730000073],
                    [-0.911431728999958, 9.302156101000037],
                    [-0.911985884999979, 9.301968245000069],
                    [-0.912586354999974, 9.301817579000044],
                    [-0.913233317999925, 9.301641166000024],
                    [-0.913377250999929, 9.30157897600003],
                    [-0.914444925999931, 9.301117649000048],
                    [-0.914986982999949, 9.300836342000025],
                    [-0.91554113799998, 9.300604621000048],
                    [-0.916129329999933, 9.300279448000026],
                    [-0.916636754999956, 9.299943787000075],
                    [-0.917166831999964, 9.299618614000053],
                    [-0.917630861999953, 9.299448490000032],
                    [-0.919176209999932, 9.298745575000055],
                    [-0.91962934299994, 9.298548694000033],
                    [-0.919773618999955, 9.298486006000076],
                    [-0.920267185999933, 9.298222625000051],
                    [-0.92054398099998, 9.298078578000059],
                    [-0.920699314999979, 9.298191099000064],
                    [-0.920743124999944, 9.298307438000052],
                    [-0.920758790999969, 9.298430503000077],
                    [-0.920817682999939, 9.298518295000065],
                    [-0.920811750999974, 9.298705557000062],
                    [-0.920906019999961, 9.298664615000064],
                    [-0.920994420999932, 9.29851833400005],
                    [-0.921129931999928, 9.298465696000051],
                    [-0.921182975999955, 9.298366224000063],
                    [-0.921283145999951, 9.298278467000046],
                    [-0.921365658999946, 9.298114628000064],
                    [-0.921454049999966, 9.298015165000038],
                    [-0.921679746999928, 9.297886327000072],
                    [-0.921754537999959, 9.297863078000034],
                    [-0.921866500999954, 9.29773435900006],
                    [-0.922102172999928, 9.297623222000027],
                    [-0.922273019999977, 9.297617407000075],
                    [-0.92233192499998, 9.297652532000029],
                    [-0.922420305999935, 9.297594033000053],
                    [-0.922564903999955, 9.297600234000072],
                    [-0.922891571999969, 9.297740435000037],
                    [-0.922950489999948, 9.297728742000061],
                    [-0.923027064999928, 9.29777557500006],
                    [-0.923186145999978, 9.29768782900004],
                    [-0.923250948999964, 9.297693696000067],
                    [-0.923345223999945, 9.297617639000066],
                    [-0.923410028999967, 9.297617654000021],
                    [-0.923574994999967, 9.297559170000056],
                    [-0.923722271999964, 9.297582609000074],
                    [-0.923845979999953, 9.297617746000071],
                    [-0.923874400999978, 9.297640661000059],
                    [-0.924158159999934, 9.297869450000064],
                    [-0.92432311999994, 9.297846076000042],
                    [-0.924582347999944, 9.297781759000031],
                    [-0.924723724999978, 9.297840309000037],
                    [-0.924794405999933, 9.297904697000035],
                    [-0.924891119999927, 9.298092356000041],
                    [-0.924918071999969, 9.298144655000044],
                    [-0.924991219999924, 9.298565793000023],
                    [-0.925000435999948, 9.298671350000063],
                    [-0.925012160999927, 9.29894054500005],
                    [-0.925087976999976, 9.299188748000063],
                    [-0.925153125999941, 9.299244491000024],
                    [-0.925147577999951, 9.299332656000047],
                    [-0.925226489999943, 9.299484717000041],
                    [-0.925247597999942, 9.29994713800005],
                    [-0.925288823999949, 9.30000566700005],
                    [-0.925292780999939, 9.300318280000056],
                    [-0.925373544999957, 9.300373845000024],
                    [-0.925441870999975, 9.300478786000042],
                    [-0.925512581999953, 9.300532392000036],
                    [-0.925759985999946, 9.300672892000023],
                    [-0.926019167999925, 9.300836802000049],
                    [-0.92614137399994, 9.300832331000038],
                    [-0.926178234999952, 9.300830982000036],
                    [-0.926254811999968, 9.300877814000046],
                    [-0.926773265999941, 9.30077843600003],
                    [-0.92688325599994, 9.300794670000073],
                    [-0.926957673999937, 9.300834289000022],
                    [-0.927156145999959, 9.301036003000036],
                    [-0.927350525999941, 9.301188194000076],
                    [-0.927427114999944, 9.301176506000047],
                    [-0.927627419999965, 9.301170695000053],
                    [-0.927780619999965, 9.301047833000041],
                    [-0.927833656999951, 9.300965918000031],
                    [-0.927937602999975, 9.30083690500004],
                    [-0.927998656999932, 9.300761130000069],
                    [-0.928234335999946, 9.300626581000074],
                    [-0.928416976999927, 9.300568097000053],
                    [-0.928634952999971, 9.300568142000031],
                    [-0.928705651999962, 9.300550600000065],
                    [-0.928811690999964, 9.300574028000028],
                    [-0.928876392999939, 9.300531246000048],
                    [-0.929041462999976, 9.30052140600003],
                    [-0.92934194299994, 9.300398574000042],
                    [-0.929536378999956, 9.300275720000059],
                    [-0.929665995999926, 9.30022893000006],
                    [-0.92970893599994, 9.300224915000058],
                    [-0.92986592699998, 9.300257486000021],
                    [-0.93012067799998, 9.300269881000077],
                    [-0.930170401999931, 9.300195826000049],
                    [-0.930195375999972, 9.300182765000045],
                    [-0.930237473999966, 9.300106151000023],
                    [-0.93019036499993, 9.300006659000076],
                    [-0.930178626999975, 9.299778428000025],
                    [-0.930208092999976, 9.299725766000051],
                    [-0.930349507999949, 9.299608754000076],
                    [-0.930410808999966, 9.299538555000026],
                    [-0.930473261999964, 9.299415661000069],
                    [-0.930562582999926, 9.299079205000055],
                    [-0.93059698199994, 9.299005236000028],
                    [-0.930756138999925, 9.298918296000068],
                    [-0.930844506999961, 9.298924165000074],
                    [-0.93104296599995, 9.298854945000073],
                    [-0.93106249899995, 9.298848131000057],
                    [-0.931154343999935, 9.298843350000027],
                    [-0.931174432999967, 9.298842303000072],
                    [-0.931239392999942, 9.298807318000058],
                    [-0.931439546999968, 9.298813093000035],
                    [-0.93160710899997, 9.298733472000038],
                    [-0.93169877899993, 9.298725362000027],
                    [-0.931758625999976, 9.298693895000042],
                    [-0.93193443399997, 9.298696147000044],
                    [-0.932069940999952, 9.298655210000049],
                    [-0.932223128999965, 9.298573311000041],
                    [-0.932470603999946, 9.29835683400006],
                    [-0.932529522999971, 9.298321734000069],
                    [-0.932612000999939, 9.298315896000076],
                    [-0.932723949999968, 9.298233989000039],
                    [-0.932894803999943, 9.298193058000038],
                    [-0.93304789299998, 9.298197749000053],
                    [-0.933354299999962, 9.298304331000054],
                    [-0.933654710999974, 9.298532616000045],
                    [-0.933743076999974, 9.298538485000051],
                    [-0.934047935999956, 9.298802155000033],
                    [-0.934061154999938, 9.298813586000051],
                    [-0.934273212999926, 9.298954073000061],
                    [-0.934349798999961, 9.298959940000032],
                    [-0.934597219999944, 9.299012652000044],
                    [-0.934932988999947, 9.299199977000058],
                    [-0.935198082999932, 9.299258547000022],
                    [-0.935274675999949, 9.299229301000025],
                    [-0.935363038999981, 9.299264427000026],
                    [-0.935445523999931, 9.299217627000075],
                    [-0.935704744999953, 9.29918841500006],
                    [-0.935897162999936, 9.299286105000022],
                    [-0.935975707999944, 9.299375726000051],
                    [-0.936046403999967, 9.299375739000027],
                    [-0.936081739999963, 9.299445969000033],
                    [-0.936170093999976, 9.299527914000066],
                    [-0.936193646999925, 9.299592291000067],
                    [-0.936405693999973, 9.299797147000049],
                    [-0.936665245999961, 9.299875047000057],
                    [-0.936741483999924, 9.299873283000068],
                    [-0.936814090999974, 9.299917320000077],
                    [-0.937130300999968, 9.299914314000034],
                    [-0.937212785999975, 9.299879217000068],
                    [-0.937572150999927, 9.299879280000027],
                    [-0.937713547999977, 9.299844193000069],
                    [-0.937872605999928, 9.29988518600004],
                    [-0.938049348999925, 9.299855955000055],
                    [-0.93812593399997, 9.299867674000041],
                    [-0.938408711999955, 9.299885279000023],
                    [-0.938473519999945, 9.299856029000068],
                    [-0.938885908999964, 9.299861951000025],
                    [-0.939115658999924, 9.299920511000039],
                    [-0.939134490999948, 9.29992089600006],
                    [-0.939318062999973, 9.299924649000047],
                    [-0.939404328999956, 9.299926413000037],
                    [-0.939492584999925, 9.29994769800004],
                    [-0.939622351999958, 9.29997899600005],
                    [-0.939781349999976, 9.300049368000032],
                    [-0.939916843999924, 9.300084503000051],
                    [-0.940176035999968, 9.300224995000065],
                    [-0.940641445999972, 9.300225072000046],
                    [-0.94072982199998, 9.300184123000065],
                    [-0.940782842999965, 9.300184132000027],
                    [-0.94101262099997, 9.300078834000033],
                    [-0.94114224599997, 9.299985222000032],
                    [-0.94140738599998, 9.299786298000072],
                    [-0.94165477599995, 9.299717744000077],
                    [-0.941784437999956, 9.299721988000044],
                    [-0.941866902999948, 9.299792226000022],
                    [-0.942031838999981, 9.299920997000072],
                    [-0.942055391999929, 9.299985372000037],
                    [-0.942184982999947, 9.300090729000033],
                    [-0.942414691999943, 9.300406774000066],
                    [-0.94259729099997, 9.300588215000062],
                    [-0.942673867999929, 9.30064674700003],
                    [-0.942832891999956, 9.300898409000069],
                    [-0.943033155999956, 9.301150077000045],
                    [-0.943286427999965, 9.301483682000026],
                    [-0.943509715999937, 9.301595578000047],
                    [-0.943580962999931, 9.301665140000068],
                    [-0.943822490999935, 9.301770514000054],
                    [-0.943966312999976, 9.301820418000034],
                    [-0.943987761999949, 9.30182785900007],
                    [-0.944022779999955, 9.301858326000058],
                    [-0.944228962999944, 9.301940285000057],
                    [-0.944404351999935, 9.302063577000069],
                    [-0.944482258999926, 9.302127589000065],
                    [-0.944632714999955, 9.302193917000068],
                    [-0.944900497999924, 9.302408549000063],
                    [-0.944965301999957, 9.302420263000045],
                    [-0.945301078999933, 9.302595874000076],
                    [-0.945925557999942, 9.302595970000027],
                    [-0.946137662999945, 9.302484815000071],
                    [-0.946214254999973, 9.302455565000059],
                    [-0.946367436999935, 9.302408774000071],
                    [-0.946461709999937, 9.302326859000061],
                    [-0.946538296999961, 9.302332723000063],
                    [-0.946633875999964, 9.302242189000026],
                    [-0.946697378999943, 9.302215706000027],
                    [-0.946732751999946, 9.302139663000048],
                    [-0.94680933099994, 9.302104535000069],
                    [-0.946880026999963, 9.302098693000062],
                    [-0.946980187999941, 9.30204604000005],
                    [-0.947109498999964, 9.302027810000027],
                    [-0.947204065999927, 9.301987555000039],
                    [-0.94746328399998, 9.301981742000066],
                    [-0.94753987699994, 9.30194663900005],
                    [-0.947592347999944, 9.301951039000073],
                    [-0.947698946999935, 9.301911551000046],
                    [-0.94839806799996, 9.301910848000034],
                    [-0.948659241999962, 9.301835615000073],
                    [-0.948818310999968, 9.301800524000043],
                    [-0.948894899999971, 9.301794683000026],
                    [-0.949171798999942, 9.30173035200005],
                    [-0.949324984999976, 9.301648445000069],
                    [-0.949584204999951, 9.301636779000034],
                    [-0.949908204999929, 9.301788976000068],
                    [-0.950122906999979, 9.301907631000063],
                    [-0.950332360999937, 9.301911927000049],
                    [-0.950509108999938, 9.301847581000061],
                    [-0.95065051499995, 9.30174226400004],
                    [-0.950727104999942, 9.301730569000028],
                    [-0.950786035999954, 9.301601834000053],
                    [-0.950868524999976, 9.301514065000049],
                    [-0.950882854999975, 9.301487979000058],
                    [-0.950903883999956, 9.301449698000056],
                    [-0.950986385999954, 9.301268298000025],
                    [-0.95106887399993, 9.301192234000041],
                    [-0.951151390999939, 9.30092305200003],
                    [-0.951298707999968, 9.300671436000073],
                    [-0.951319234999971, 9.300643056000069],
                    [-0.951316583999926, 9.300577045000068],
                    [-0.951369437999972, 9.300413960000071],
                    [-0.951404792999938, 9.300367147000031],
                    [-0.95149906499995, 9.300273529000037],
                    [-0.951504968999927, 9.300179898000067],
                    [-0.95156829299998, 9.29994941700005],
                    [-0.951634626999976, 9.299822943000038],
                    [-0.951646314999948, 9.299729276000051],
                    [-0.951723038999944, 9.29951279900007],
                    [-0.951823198999932, 9.299454292000064],
                    [-0.95197049899997, 9.29930801200004],
                    [-0.952123683999957, 9.299231957000075],
                    [-0.952347563999979, 9.299150060000045],
                    [-0.952424442999927, 9.299162304000049],
                    [-0.952488954999978, 9.299126669000032],
                    [-0.952592680999942, 9.299037876000057],
                    [-0.952736410999933, 9.298962848000031],
                    [-0.95280986399996, 9.298873456000024],
                    [-0.952889600999924, 9.298822420000022],
                    [-0.953036893999979, 9.298734658000058],
                    [-0.953531698999939, 9.299191179000047],
                    [-0.954337599999974, 9.299843190000047],
                    [-0.954358672999945, 9.299863453000057],
                    [-0.955278003999979, 9.30074742000005],
                    [-0.95594540999997, 9.301229695000075],
                    [-0.956992008999975, 9.302133935000029],
                    [-0.957841400999939, 9.303098422000062],
                    [-0.958789568999975, 9.304040600000064],
                    [-0.959654666999938, 9.303459876000034],
                    [-0.959766942999977, 9.303772190000075],
                    [-0.959984189999943, 9.30439517700006],
                    [-0.960072095999976, 9.304629487000057],
                    [-0.960259365999946, 9.305020927000044],
                    [-0.960393240999963, 9.305180817000064],
                    [-0.96052711699997, 9.305340708000074],
                    [-0.960693019999951, 9.306040867000036],
                    [-0.960706853999966, 9.306418506000057],
                    [-0.960702147999939, 9.306619727000054],
                    [-0.960697442999958, 9.306820948000052],
                    [-0.96078302899997, 9.307647898000027],
                    [-0.960750550999933, 9.308050341000069],
                    [-0.960719599999948, 9.308764262000068],
                    [-0.960688986999969, 9.309533314000021],
                    [-0.960623017999978, 9.31008459800006],
                    [-0.960488852999958, 9.310947359000068],
                    [-0.96043296199997, 9.311327744000039],
                    [-0.960377412999947, 9.311752234000039],
                    [-0.960253847999979, 9.312419286000022],
                    [-0.959026207999955, 9.314051430000063],
                    [-0.958400773999927, 9.315473664000024],
                    [-0.958581635999963, 9.316387766000048],
                    [-0.959287153999981, 9.317556042000035],
                    [-0.96050237399993, 9.318437267000036],
                    [-0.961875152999937, 9.319073575000061],
                    [-0.96195836499993, 9.319465001000026],
                    [-0.962053024999932, 9.319842648000076],
                    [-0.962111973999924, 9.320043876000057],
                    [-0.962170923999963, 9.320245104000037],
                    [-0.962207483999975, 9.320589666000046],
                    [-0.962279584999976, 9.32108308200003],
                    [-0.962306231999946, 9.321667454000021],
                    [-0.962332100999959, 9.321958691000077],
                    [-0.962342957999965, 9.322080928000048],
                    [-0.962460857999929, 9.322494411000037],
                    [-0.962579438999967, 9.323020909000036],
                    [-0.962607033999973, 9.323243507000029],
                    [-0.962676487999943, 9.323803755000029],
                    [-0.962793705999957, 9.324101466000059],
                    [-0.962911095999971, 9.324432253000055],
                    [-0.962913815999968, 9.324950470000033],
                    [-0.962904412999933, 9.325306053000077],
                    [-0.962893728999973, 9.325456278000047],
                    [-0.962883044999955, 9.325606505000053],
                    [-0.96288457299994, 9.325926256000059],
                    [-0.96288644699996, 9.326248762000034],
                    [-0.962888660999965, 9.326640181000073],
                    [-0.96290197999997, 9.326973713000029],
                    [-0.962920514999951, 9.327208015000053],
                    [-0.962939048999942, 9.32744231700002],
                    [-0.962953735999974, 9.327982585000029],
                    [-0.963036012999964, 9.328212759000053],
                    [-0.963118289999954, 9.328442933000076],
                    [-0.963050778999957, 9.328820561000043],
                    [-0.96299506899993, 9.329132036000033],
                    [-0.963054867999972, 9.329523460000075],
                    [-0.963114496999935, 9.329890076000027],
                    [-0.963186435999944, 9.330303554000068],
                    [-0.96321274099995, 9.330854848000058],
                    [-0.963179576999948, 9.331199403000028],
                    [-0.963147612999933, 9.331659730000069],
                    [-0.963091298999927, 9.331935370000053],
                    [-0.963034985999968, 9.332211011000027],
                    [-0.962932442999943, 9.332522481000069],
                    [-0.962785296999925, 9.33308478400005],
                    [-0.962728889999937, 9.33339625800005],
                    [-0.962649764999981, 9.333693948000075],
                    [-0.962605157999974, 9.333983373000024],
                    [-0.962618646999942, 9.334349983000038],
                    [-0.962615550999942, 9.334382505000065],
                    [-0.962577695999926, 9.334691164000049],
                    [-0.962568331999933, 9.334767528000043],
                    [-0.96229337699998, 9.334774444000061],
                    [-0.962100496999938, 9.334793719000061],
                    [-0.962022785999977, 9.334832301000063],
                    [-0.961714732999951, 9.334832268000071],
                    [-0.961637021999934, 9.334870852000051],
                    [-0.961406675999967, 9.334870826000042],
                    [-0.96132896499995, 9.334909408000044],
                    [-0.961176325999929, 9.334909391000053],
                    [-0.961098614999969, 9.334947973000055],
                    [-0.96059628699993, 9.335022342000059],
                    [-0.960443649999945, 9.335022325000068],
                    [-0.960307654999951, 9.33509949200004],
                    [-0.960096733999933, 9.335099468000067],
                    [-0.960019023999962, 9.335138049000022],
                    [-0.959286356999939, 9.335137966000048],
                    [-0.959208654999941, 9.335099368000044],
                    [-0.958939457999975, 9.335099337000031],
                    [-0.957185494999976, 9.335137720000034],
                    [-0.956666501999962, 9.335311314000023],
                    [-0.956511076999959, 9.335405016000038],
                    [-0.956436134999933, 9.335482187000025],
                    [-0.95635842799993, 9.335501472000033],
                    [-0.956128053999976, 9.335710935000066],
                    [-0.956089191999979, 9.335788111000056],
                    [-0.955856041999937, 9.336016869000048],
                    [-0.955703376999963, 9.336229099000036],
                    [-0.955664509999963, 9.336325569000053],
                    [-0.955586796999967, 9.336380689000066],
                    [-0.955087171999935, 9.336976021000055],
                    [-0.954507078999939, 9.337472112000057],
                    [-0.954354419999959, 9.337626453000041],
                    [-0.954315554999937, 9.337700874000063],
                    [-0.954160129999934, 9.337778034000053],
                    [-0.953929757999958, 9.337970956000049],
                    [-0.953774329999931, 9.338064656000029],
                    [-0.953699384999936, 9.338161123000077],
                    [-0.953621675999955, 9.338180408000028],
                    [-0.953313596999976, 9.338351268000054],
                    [-0.953235879999966, 9.33842843900004],
                    [-0.953083229999947, 9.338505600000076],
                    [-0.952850079999962, 9.338695765000068],
                    [-0.952464285999952, 9.338927256000034],
                    [-0.952405993999946, 9.339004429000056],
                    [-0.952253343999928, 9.339078834000077],
                    [-0.95207847599994, 9.339271762000067],
                    [-0.952042386999949, 9.339348939000047],
                    [-0.951925824999933, 9.339348923000045],
                    [-0.951676022999948, 9.339539086000059],
                    [-0.951520596999956, 9.339616245000059],
                    [-0.951231935999942, 9.339844992000053],
                    [-0.951154226999961, 9.339844982000045],
                    [-0.95107650999995, 9.339922151000053],
                    [-0.950866954999924, 9.340065458000026],
                    [-0.950657399999955, 9.340208765000057],
                    [-0.950171692999959, 9.340437484000063],
                    [-0.950019044999976, 9.340476053000032],
                    [-0.949727614999972, 9.340649669000072],
                    [-0.949652681999964, 9.340649659000064],
                    [-0.949574967999979, 9.340688238000041],
                    [-0.949477822999938, 9.340762649000055],
                    [-0.949419529999943, 9.340839821000031],
                    [-0.949169739999945, 9.34093626400005],
                    [-0.949033730999929, 9.341068553000071],
                    [-0.94886164899998, 9.341165004000061],
                    [-0.948611801999959, 9.341644593000069],
                    [-0.948592356999939, 9.34177690000007],
                    [-0.948572897999952, 9.34198914600006],
                    [-0.948417435999943, 9.34229509000005],
                    [-0.948109354999929, 9.342446650000056],
                    [-0.947878970999966, 9.342678159000059],
                    [-0.947801239999933, 9.342829754000036],
                    [-0.947723523999969, 9.342868332000023],
                    [-0.947609701999966, 9.343097103000048],
                    [-0.94755138599993, 9.343328636000024],
                    [-0.947629038999935, 9.343711797000026],
                    [-0.947570653999946, 9.344400903000064],
                    [-0.947434596999926, 9.344839160000049],
                    [-0.947492798999974, 9.345376680000072],
                    [-0.94741505199994, 9.34562475000007],
                    [-0.947337325999968, 9.345740509000052],
                    [-0.947262380999973, 9.345814922000045],
                    [-0.94679889899993, 9.345814853000036],
                    [-0.946721195999942, 9.345779007000033],
                    [-0.946260490999975, 9.345778938000024],
                    [-0.946182776999933, 9.345814760000053],
                    [-0.946105068999941, 9.345795453000051],
                    [-0.946027357999981, 9.345814737000069],
                    [-0.945641585999965, 9.345814679000057],
                    [-0.945566646999964, 9.345853258000034],
                    [-0.945258584999976, 9.34585321000003],
                    [-0.945180869999945, 9.345891788000074],
                    [-0.945103159999974, 9.34589177600003],
                    [-0.944986583999935, 9.345968940000034],
                    [-0.945064268999943, 9.346120556000074],
                    [-0.945333440999946, 9.346352141000068],
                    [-0.945411150999973, 9.346352153000055],
                    [-0.945488846999979, 9.346429345000047],
                    [-0.945547131999945, 9.34641005900005],
                    [-0.945584598999972, 9.346419712000056],
                    [-0.945622063999963, 9.346429367000042],
                    [-0.945699776999959, 9.346410083000023],
                    [-0.945796909999956, 9.34642939400004],
                    [-0.945874626999966, 9.346390815000063],
                    [-0.946007843999951, 9.346371540000064],
                    [-0.946163263999949, 9.346371563000048],
                    [-0.946240965999948, 9.346410165000066],
                    [-0.946393610999962, 9.346410189000039],
                    [-0.946490738999955, 9.346465332000037],
                    [-0.946568447999937, 9.346465343000034],
                    [-0.946721068999977, 9.346619728000064],
                    [-0.946798771999966, 9.346658330000025],
                    [-0.94687646999995, 9.346735524000053],
                    [-0.946970799999974, 9.34694502800005],
                    [-0.946954097999935, 9.347270289000051],
                    [-0.94691523399996, 9.347328169000036],
                    [-0.946876353999926, 9.347499063000043],
                    [-0.946876329999952, 9.347653426000022],
                    [-0.94691295399997, 9.347761304000073],
                    [-0.946954006999931, 9.347882222000067],
                    [-0.946915138999941, 9.347959398000057],
                    [-0.94691512199995, 9.348070508000035],
                    [-0.946915114999967, 9.348113759000057],
                    [-0.946876249999946, 9.348188178000044],
                    [-0.946817960999965, 9.348226761000035],
                    [-0.946740227999953, 9.348381111000037],
                    [-0.946701348999966, 9.34853270900004],
                    [-0.946720764999952, 9.348609893000059],
                    [-0.946681898999941, 9.34868706900005],
                    [-0.946720729999925, 9.348838680000028],
                    [-0.946856704999959, 9.34895447100007],
                    [-0.946934392999935, 9.349108845000046],
                    [-0.946934370999941, 9.349260450000031],
                    [-0.946895489999974, 9.349414806000027],
                    [-0.946823491999965, 9.349485272000038],
                    [-0.946701185999927, 9.349604974000044],
                    [-0.946662308999976, 9.34975933000004],
                    [-0.946720355999958, 9.349835674000076],
                    [-0.946718530999931, 9.349909527000023],
                    [-0.946954277999964, 9.350104105000071],
                    [-0.947262579999972, 9.350235645000055],
                    [-0.947338744999968, 9.350293299000043],
                    [-0.94743664799995, 9.350523880000026],
                    [-0.947654606999947, 9.350672929000041],
                    [-0.947819296999967, 9.350754504000065],
                    [-0.947989758999938, 9.350904038000067],
                    [-0.948053233999929, 9.350929266000037],
                    [-0.948325226999941, 9.35131298400006],
                    [-0.948608118999971, 9.351592227000026],
                    [-0.948744131999945, 9.35167150500007],
                    [-0.94886381699996, 9.351792211000031],
                    [-0.94890189299997, 9.351869672000021],
                    [-0.948958084999958, 9.352096645000074],
                    [-0.94903328099997, 9.352170429000068],
                    [-0.94910497099994, 9.352240771000027],
                    [-0.949186577999967, 9.352285816000062],
                    [-0.949268194999945, 9.352284025000074],
                    [-0.949422334999952, 9.352442562000022],
                    [-0.949491233999936, 9.352584875000048],
                    [-0.94971972899998, 9.352779450000071],
                    [-0.949803580999969, 9.35282221600005],
                    [-0.95003393199994, 9.352860838000026],
                    [-0.950127819999977, 9.352905814000053],
                    [-0.950189343999966, 9.352935284000068],
                    [-0.950419672999942, 9.353128269000024],
                    [-0.950429369999938, 9.353242665000039],
                    [-0.95043906899997, 9.353357058000029],
                    [-0.950477900999942, 9.353511425000022],
                    [-0.950594448999937, 9.35364375100005],
                    [-0.950672138999948, 9.353798124000036],
                    [-0.950902478999978, 9.353930466000065],
                    [-0.950999617999969, 9.353930480000031],
                    [-0.951152253999965, 9.354007681000041],
                    [-0.951210539999977, 9.353988395000044],
                    [-0.951365949999968, 9.354065596000055],
                    [-0.951421445999927, 9.354162080000037],
                    [-0.951421437999954, 9.354219965000027],
                    [-0.951346466999951, 9.35446803800005],
                    [-0.951346456999943, 9.354545218000055],
                    [-0.951307590999932, 9.354619637000042],
                    [-0.951346435999938, 9.35469682400003],
                    [-0.951346423999951, 9.354774004000035],
                    [-0.951440758999979, 9.354983508000032],
                    [-0.951499031999958, 9.355060697000056],
                    [-0.951537874999929, 9.355157179000059],
                    [-0.951537862999942, 9.355234360000054],
                    [-0.951576709999927, 9.355308789000048],
                    [-0.951576698999929, 9.355385970000043],
                    [-0.951537830999939, 9.355463145000044],
                    [-0.951382381999963, 9.355653321000034],
                    [-0.951346291999926, 9.355730496000035],
                    [-0.951326842999947, 9.355884856000046],
                    [-0.951382328999955, 9.35603646800007],
                    [-0.951576576999969, 9.356265281000049],
                    [-0.951654284999961, 9.356284586000072],
                    [-0.951806920999957, 9.356381085000066],
                    [-0.951884621999966, 9.356458274000033],
                    [-0.951962326999933, 9.356496875000062],
                    [-0.952192654999976, 9.356725693000044],
                    [-0.952500703999931, 9.356899393000049],
                    [-0.952617249999946, 9.357070307000072],
                    [-0.952694952999934, 9.357128203000059],
                    [-0.952769874999944, 9.357224689000077],
                    [-0.952769864999937, 9.357299114000057],
                    [-0.952847572999929, 9.357337715000028],
                    [-0.952828132999969, 9.357414893000055],
                    [-0.952858612999933, 9.357536045000074],
                    [-0.952866969999945, 9.357569261000037],
                    [-0.95300294599997, 9.357720885000049],
                    [-0.953079079999952, 9.357837698000026],
                    [-0.953325235999955, 9.357756760000029],
                    [-0.953383157999951, 9.357833092000021],
                    [-0.95353023399997, 9.358026920000043],
                    [-0.953613469999937, 9.358230909000042],
                    [-0.953655061999939, 9.358539637000035],
                    [-0.95366742899995, 9.358538542000076],
                    [-0.953679798999929, 9.35853744800005],
                    [-0.953810487999931, 9.358525875000055],
                    [-0.953888194999934, 9.358564477000073],
                    [-0.954099127999939, 9.358564503000025],
                    [-0.954176840999935, 9.358545218000074],
                    [-0.954429402999949, 9.358564547000071],
                    [-0.954504345999965, 9.358525965000069],
                    [-0.954692020999971, 9.358631079000077],
                    [-0.954777185999944, 9.358678984000051],
                    [-0.954928952999978, 9.358793397000056],
                    [-0.955198135999979, 9.359060807000048],
                    [-0.95519812799995, 9.359117625000067],
                    [-0.955198114999973, 9.359215168000048],
                    [-0.955275816999972, 9.359292359000051],
                    [-0.955256381999959, 9.359347486000047],
                    [-0.955275797999946, 9.359443964000036],
                    [-0.955304067999975, 9.359490829000038],
                    [-0.955332335999969, 9.359537691000071],
                    [-0.955362339999965, 9.359585934000052],
                    [-0.955392341999925, 9.359634175000053],
                    [-0.955429807999963, 9.359653475000073],
                    [-0.955467273999943, 9.359672775000035],
                    [-0.955544977999978, 9.359749965000049],
                    [-0.955603260999965, 9.359749972000031],
                    [-0.955853016999924, 9.36003667600005],
                    [-0.95589184399995, 9.360248928000033],
                    [-0.955930690999935, 9.360323358000073],
                    [-0.955930680999927, 9.360400539000068],
                    [-0.955911248999939, 9.360439127000063],
                    [-0.955891814999973, 9.360477715000059],
                    [-0.955852929999935, 9.360706495000045],
                    [-0.955891777999966, 9.360783682000033],
                    [-0.955833472999927, 9.36093803600005],
                    [-0.955852883999967, 9.361089643000071],
                    [-0.955891729999962, 9.361166829000069],
                    [-0.955872271999965, 9.36139561300007],
                    [-0.955891679999979, 9.361549977000038],
                    [-0.955930526999964, 9.361627163000037],
                    [-0.955930498999976, 9.361855949000073],
                    [-0.956008191999956, 9.362007563000077],
                    [-0.955988756999943, 9.36206544700002],
                    [-0.956047, 9.36239071600005],
                    [-0.956124695999961, 9.362545087000058],
                    [-0.956124684999963, 9.362622268000052],
                    [-0.956199587999947, 9.362889654000071],
                    [-0.956238434999932, 9.36296684000007],
                    [-0.95623842699996, 9.36304126400006],
                    [-0.956277274999934, 9.363118451000048],
                    [-0.956354980999947, 9.36315705100003],
                    [-0.956374400999948, 9.363234233000071],
                    [-0.956488179999951, 9.363347264000026],
                    [-0.95672129899998, 9.36352094700004],
                    [-0.956818432999967, 9.363578846000053],
                    [-0.956912788999944, 9.363656037000055],
                    [-0.957009921999941, 9.363730473000032],
                    [-0.957107034999979, 9.36396202800006],
                    [-0.957201362999967, 9.364268007000021],
                    [-0.957201353999949, 9.364345187000026],
                    [-0.95731789599995, 9.364573987000028],
                    [-0.957298461999926, 9.364631870000039],
                    [-0.957434428999932, 9.364879968000025],
                    [-0.957509358999971, 9.364957159000028],
                    [-0.957820195999943, 9.365089505000071],
                    [-0.957895126999972, 9.365147401000058],
                    [-0.957972841999947, 9.365147410000077],
                    [-0.958050558999958, 9.365108829000064],
                    [-0.958280926999976, 9.365089561000048],
                    [-0.958589004999965, 9.365089597000065],
                    [-0.958897083999943, 9.365089633000025],
                    [-0.958974802999933, 9.365051050000034],
                    [-0.959130224999967, 9.365089660000024],
                    [-0.959360577999973, 9.365205456000069],
                    [-0.959565948999966, 9.365326765000077],
                    [-0.959685264999962, 9.365581752000026],
                    [-0.959804581999947, 9.365836736000063],
                    [-0.959898932999977, 9.365971814000034],
                    [-0.959996048999926, 9.366200610000021],
                    [-0.960015467999938, 9.366297089000057],
                    [-0.96013202499995, 9.366410116000054],
                    [-0.960132016999978, 9.366487297000049],
                    [-0.960197362999963, 9.366618070000072],
                    [-0.960323481999978, 9.366870467000069],
                    [-0.960323460999973, 9.367060662000029],
                    [-0.960226301999967, 9.367195719000051],
                    [-0.960151336999957, 9.367424497000059],
                    [-0.96017074599996, 9.367598156000042],
                    [-0.960381653999946, 9.367865556000027],
                    [-0.960502883999936, 9.36807888900006],
                    [-0.960541903999967, 9.368250246000059],
                    [-0.960544076999952, 9.368467966000026],
                    [-0.960491927999954, 9.36863455200006],
                    [-0.960360840999954, 9.368789502000027],
                    [-0.960289517999968, 9.36882390300002],
                    [-0.960253589999979, 9.368855118000056],
                    [-0.960123642999974, 9.368987830000037],
                    [-0.959986359999959, 9.369138290000024],
                    [-0.95996125399995, 9.369217936000041],
                    [-0.959935074999976, 9.369278038000061],
                    [-0.959935064999968, 9.369360884000059],
                    [-0.959898535999969, 9.369433926000056],
                    [-0.959809874999962, 9.369550691000029],
                    [-0.95959598099995, 9.370022387000063],
                    [-0.959544545999961, 9.370135818000051],
                    [-0.958920239999941, 9.371895276000032],
                    [-0.958554826999944, 9.37459560800005],
                    [-0.957757873999981, 9.376121234000038],
                    [-0.957633309999949, 9.376327355000058],
                    [-0.957390265999948, 9.376729528000055],
                    [-0.95681605599998, 9.377523981000024],
                    [-0.956226238999932, 9.378067729000065],
                    [-0.955450261999943, 9.378594860000021],
                    [-0.954457892999926, 9.379462247000049],
                    [-0.953985985999964, 9.380737508000038],
                    [-0.953349763999938, 9.38242191300003],
                    [-0.95113633699998, 9.388307139000062],
                    [-0.950548262999973, 9.390876735000063],
                    [-0.949901122999961, 9.393704368000044],
                    [-0.948849584999948, 9.39663493300003],
                    [-0.947389546999943, 9.398173778000057],
                    [-0.946442317999924, 9.400668077000034],
                    [-0.947158628999944, 9.401881443000036],
                    [-0.947220802999936, 9.403306434000058],
                    [-0.94681572199994, 9.404504512000074],
                    [-0.945972649999931, 9.405536651000034],
                    [-0.944537596999965, 9.405970120000063],
                    [-0.943262107999942, 9.405818396000029],
                    [-0.941730122999957, 9.405288155000051],
                    [-0.941107967999926, 9.404350006000072],
                    [-0.939168991999964, 9.404373746000033],
                    [-0.938521507999951, 9.404370558000039],
                    [-0.93751903499998, 9.404365618000043],
                    [-0.924283307999929, 9.404300144000047],
                    [-0.919652760999952, 9.404277121000064],
                    [-0.916526997999938, 9.404210523000074],
                    [-0.915304079999942, 9.404339085000061],
                    [-0.913247881999951, 9.404252416000077],
                    [-0.911336024999969, 9.404283231000022],
                    [-0.910940190999952, 9.404270762000067],
                    [-0.910540158999936, 9.404265810000027],
                    [-0.909379830999967, 9.404251447000036],
                    [-0.908901484999944, 9.404268867000042],
                    [-0.908274506999931, 9.40428244900005],
                    [-0.90784961199995, 9.404278575000035],
                    [-0.907334734999949, 9.404287701000044],
                    [-0.906226112999946, 9.404277789000048],
                    [-0.905963149999934, 9.40425441800005],
                    [-0.905495341999938, 9.404255603000024],
                    [-0.905183922999925, 9.404280259000075],
                    [-0.904584615999966, 9.40433095000003],
                    [-0.90397840199995, 9.404333535000035],
                    [-0.90380401799996, 9.404312871000059],
                    [-0.903267018999941, 9.40426599500006],
                    [-0.903028967999944, 9.404249437000033],
                    [-0.901611701999968, 9.404247672000054],
                    [-0.900764381999977, 9.40422595800004],
                    [-0.898134975999938, 9.40422469400005],
                    [-0.897206280999967, 9.404214805000038],
                    [-0.895775166999954, 9.404232253000032],
                    [-0.894421565999949, 9.404240096000024],
                    [-0.892757938999978, 9.404235472000039],
                    [-0.892456636999952, 9.40423469600006],
                    [-0.891124810999941, 9.404234422000059],
                    [-0.889885566999965, 9.404228063000062],
                    [-0.88837095599996, 9.404228966000062],
                    [-0.88821384299996, 9.404227554000045],
                    [-0.887157953999974, 9.404232441000033],
                    [-0.886659408999947, 9.404234746000043],
                    [-0.886419609999962, 9.404206059000046],
                    [-0.885952252999971, 9.404204734000075],
                    [-0.885773289999975, 9.404230005000045],
                    [-0.885166466999976, 9.404234264000024],
                    [-0.885054768999964, 9.404232795000041],
                    [-0.88459888999995, 9.404226797000035],
                    [-0.884114968999938, 9.404220430000066],
                    [-0.883714471999951, 9.404224158000034],
                    [-0.882469509999964, 9.404233378000072],
                    [-0.881919360999973, 9.404216865000024],
                    [-0.880501973999969, 9.404234599000063],
                    [-0.88037518799996, 9.404231669000069],
                    [-0.88033053099997, 9.40423177100007],
                    [-0.879716685999938, 9.404233185000066],
                    [-0.878959805999955, 9.404234928000051],
                    [-0.878509776999977, 9.404235963000076],
                    [-0.878044668999962, 9.404237032000026],
                    [-0.877412552999942, 9.404238485000064],
                    [-0.877317167999934, 9.404238851000059],
                    [-0.87680211199995, 9.404240831000038],
                    [-0.876689642999963, 9.404226007000034],
                    [-0.876626972999929, 9.404217749000054],
                    [-0.876540241999976, 9.40419285400003],
                    [-0.876377157999968, 9.404146044000072],
                    [-0.876328383999976, 9.404126890000043],
                    [-0.87595995199996, 9.403982202000066],
                    [-0.875429391999944, 9.403773705000049],
                    [-0.87537514099995, 9.403752385000075],
                    [-0.875125833999959, 9.403664233000029],
                    [-0.874941103999959, 9.403598916000021],
                    [-0.874734756999942, 9.403557757000044],
                    [-0.874632515999963, 9.403537364000044],
                    [-0.874556263999978, 9.403538509000043],
                    [-0.874041820999935, 9.403546232000053],
                    [-0.873992962999978, 9.403546965000032],
                    [-0.869910723999965, 9.404144123000037],
                    [-0.869582701999946, 9.404196916000046],
                    [-0.869236923999949, 9.404237945000034],
                    [-0.868702571999961, 9.404256844000031],
                    [-0.868561147999969, 9.404259354000033],
                    [-0.86781766799993, 9.404266006000057],
                    [-0.867695276999939, 9.40427472600004],
                    [-0.86666516899993, 9.404273690000025],
                    [-0.863956946999963, 9.404276579000054],
                    [-0.86387880999996, 9.404275477000056],
                    [-0.863862875999928, 9.404559426000048],
                    [-0.863837650999926, 9.404957721000073],
                    [-0.863817326999936, 9.405278664000036],
                    [-0.863801519999924, 9.405489447000036],
                    [-0.86377480699997, 9.405944226000031],
                    [-0.863738634999947, 9.406487503000051],
                    [-0.863739366999937, 9.406547527000043],
                    [-0.863707808999948, 9.407058233000043],
                    [-0.86370973399994, 9.407333057000073],
                    [-0.863701367999965, 9.407569760000058],
                    [-0.863684460999934, 9.407819871000072],
                    [-0.86365825699994, 9.408207434000076],
                    [-0.863610044999973, 9.408435162000046],
                    [-0.863610089999952, 9.408639681000068],
                    [-0.863599233999935, 9.409154988000068],
                    [-0.863580986999978, 9.409663490000071],
                    [-0.863611545999959, 9.409961849000069],
                    [-0.863307307999946, 9.410400871000036],
                    [-0.862661278999951, 9.411266954000041],
                    [-0.86155933699996, 9.412674581000033],
                    [-0.859960583999964, 9.414719025000068],
                    [-0.858838623999929, 9.416129943000044],
                    [-0.858113052999954, 9.417034446000059],
                    [-0.857479926999929, 9.417823698000063],
                    [-0.856628017999981, 9.418908765000026],
                    [-0.85519594699997, 9.420688519000066],
                    [-0.854286385999956, 9.421803621000038],
                    [-0.854167084999972, 9.42190213300006],
                    [-0.854014847999963, 9.422048823000068],
                    [-0.853896739999925, 9.422162627000034],
                    [-0.853827966999972, 9.422086796000031],
                    [-0.853564500999937, 9.422287874000062],
                    [-0.85295881199994, 9.422686291000048],
                    [-0.85210443099993, 9.423248289000071],
                    [-0.850937815999941, 9.424050951000027],
                    [-0.84974619999997, 9.424870806000058],
                    [-0.84961455499996, 9.424951211000064],
                    [-0.849558055999978, 9.424923768000042],
                    [-0.849287705999927, 9.424914365000063],
                    [-0.848932678999972, 9.424929195000061],
                    [-0.848678878999976, 9.424955614000055],
                    [-0.848551606999933, 9.424968860000035],
                    [-0.848061809999933, 9.425077860000044],
                    [-0.847904300999971, 9.425113414000066],
                    [-0.847791258999962, 9.425116985000045],
                    [-0.847540113999969, 9.425156104000052],
                    [-0.846639530999937, 9.425270818000058],
                    [-0.845809790999965, 9.42538869200007],
                    [-0.845375136999962, 9.425431866000054],
                    [-0.842689675999964, 9.425820187000056],
                    [-0.842081650999944, 9.425827960000049],
                  ],
                ],
              },
            },
          ],
        };

        setBoundaryGeoJson(geojson);
      } catch (err) {
        console.error("Failed to load GeoJSON boundary", err);
      }
    };
    fetchBoundary();
  }, []);
  const handleVisualize = async (file) => {
    // The API endpoint is updated for the Tamale dataset
    const url = `https://ghclimatevulnerabilityhub.com/dataset/Tamale/${file}`;
    setSelectedFile(file);
    setLoading(true);
    setResponse(null);
    setSelectedLocation(null);

    try {
      const res = await fetch(
        `https://climate.misconm.org/api/load?url=${encodeURIComponent(url)}`
      );
      const json = await res.json();

      if (json.error) {
        alert("Error loading data: " + json.error);
        return;
      }

      const validVariables = json.variables.filter(
        (v) => !["time", "latitude", "longitude", "spatial_ref"].includes(v)
      );

      if (validVariables.length === 0) {
        alert("No valid visualizable variable found in this dataset.");
        return;
      }

      setResponse(json);
      setSelectedVariable(validVariables[0]);
    } catch (err) {
      console.error("Failed to load file", err);
      alert("Failed to load file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tamale-page-container">
      <header className="page-header">
        <h1 className="page-title">Tamale Dataset Viewer</h1>
      </header>

      <main className="page-content">
        <section className="file-list-section">
          <h2 className="section-title">📁 Available Datasets</h2>
          <div className="file-list-grid">
            {ncFiles.map((file) => {
              const key = file.split("_")[0];
              const isSelected = selectedFile === file;
              return (
                <div
                  key={file}
                  className={`file-card ${isSelected ? "selected" : ""}`}
                >
                  <div className="file-info">
                    <p className="file-name">{file}</p>
                    <p className="file-description">
                      {descriptions[key] || "No description"}
                    </p>
                  </div>
                  <button
                    className="visualize-button"
                    onClick={() => handleVisualize(file)}
                    disabled={loading && isSelected}
                  >
                    {loading && isSelected ? "Loading..." : "Visualize"}
                  </button>
                </div>
              );
            })}
          </div>
        </section>

        {loading && (
          <div className="loading-message-container">
            <div className="spinner"></div>
            <p>Loading dataset...</p>
          </div>
        )}

        {response && selectedVariable && (
          <section className="visualization-section">
            <div className="visualization-grid">
              <div className="chart-container">
                <h3 className="chart-title">🗺 Map Visualization</h3>
                <MapVisualization
                  response={response}
                  selectedVariable={selectedVariable}
                  onLocationSelect={(loc) => setSelectedLocation(loc)}
                  boundaryGeoJson={geojson}
                />
              </div>

              <div className="chart-container">
                <h3 className="chart-title">🟦 Spatial Grid Preview</h3>
                <div style={{ padding: "20px", width: "100%", height: "100%" }}>
                  <SpatialGridOverlay
                    response={response}
                    selectedVariable={selectedVariable}
                  />
                </div>
              </div>
            </div>

            {selectedLocation && response.coords.time?.length > 0 && (
              <div className="chart-container time-series-container">
                <h3 className="chart-title">
                  📈 Time Series at ({selectedLocation.lat.toFixed(2)}°N,{" "}
                  {selectedLocation.lon.toFixed(2)}°E)
                </h3>
                <TimeSeriesChart
                  data={{
                    variables: {
                      [selectedVariable]: {
                        data: response.data[selectedVariable],
                      },
                      latitude: { data: response.coords.latitude },
                      longitude: { data: response.coords.longitude },
                      time: { data: response.coords.time },
                    },
                  }}
                  location={selectedLocation}
                  variable={selectedVariable}
                />
              </div>
            )}
          </section>
        )}
      </main>
    </div>
  );
}

export default TamalePage;
